var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 217,
    height: 63,
    viewBox: "0 0 217 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4_3",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 62,
    height: 63
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.7123 62.1486H31.5461C41.2722 61.9854 50.0956 57.1169 55.8342 48.7357L55.7907 48.7031C55.8704 48.5907 55.9502 48.4783 56.0263 48.3623L55.9864 48.3333L56.0807 48.1992L56.1604 48.2536C57.7062 46.0104 58.9483 43.5725 59.8544 41.0034C59.8645 40.9918 59.8719 40.9782 59.8762 40.9635C61.4949 36.3239 61.9805 31.3643 61.2924 26.4988C60.6044 21.6333 58.7627 17.0029 55.921 12.994C53.0792 8.98506 49.3199 5.71392 44.9568 3.45352C40.5936 1.19312 35.7531 0.00900643 30.8392 0C29.5559 0.00016088 28.2739 0.0788518 27.0002 0.235631C11.8038 2.26931 0.381165 15.5553 0.381165 31.1142C0.381165 48.1194 13.9644 61.9709 30.7268 62.1558L30.7123 62.1486ZM58.524 43.1422C58.611 43.0117 58.698 42.8667 58.7814 42.7253C58.7814 42.7253 58.7814 42.7253 58.7814 42.7543C58.698 42.8848 58.6182 43.0226 58.5349 43.1458L58.524 43.1422ZM58.9155 42.3809C58.9336 42.3483 58.9481 42.3193 58.9626 42.2867C58.964 42.2951 58.964 42.3037 58.9626 42.3121C58.9626 42.3338 58.9372 42.3556 58.9264 42.3809H58.9155ZM11.8981 8.19633L11.8292 8.27971C11.8546 8.24708 11.8836 8.22171 11.909 8.18908L11.8981 8.19633ZM12.0141 9.52674L11.6987 9.94C11.5646 10.114 11.4232 10.2808 11.2927 10.4548C11.4232 10.2699 11.5609 10.0923 11.6987 9.911C11.8365 9.72974 11.938 9.65362 12.0431 9.52674H12.0141ZM11.2891 10.7194C11.4377 10.5091 11.5936 10.2989 11.7494 10.0923C11.5392 10.3714 11.3362 10.6541 11.1332 10.9405C11.1876 10.8644 11.2383 10.7955 11.2891 10.7194ZM31.0748 61.9564C14.2616 61.9564 0.584169 48.1158 0.584169 31.1069C0.58056 26.5801 1.56857 22.1075 3.47873 18.0035C5.38889 13.8994 8.17483 10.2636 11.6407 7.35168C10.3674 8.44135 9.18645 9.63444 8.10985 10.9188C3.298 16.7058 0.715946 24.0238 0.830678 31.5492C0.851785 35.617 1.68588 39.6395 3.28394 43.3804C4.88199 47.1212 7.21176 50.5048 10.1363 53.3323C15.6963 58.6878 23.1267 61.6623 30.8464 61.6229C31.1219 61.6229 31.3974 61.6229 31.6693 61.6229C37.948 61.4598 43.6502 59.5929 48.4064 56.236C43.3964 59.9595 37.3169 61.9636 31.0748 61.9492V61.9564ZM31.6657 61.4235C27.7322 61.5492 23.8132 60.8862 20.14 59.4735C16.4667 58.0609 13.1134 55.9272 10.2777 53.1982C7.36737 50.3893 5.04834 47.0266 3.45708 43.3081C1.86581 39.5895 1.03445 35.5902 1.01193 31.5455C0.902693 23.8443 3.64807 16.3752 8.71887 10.578C8.49774 10.839 8.28024 11.0928 8.06636 11.361C3.45418 17.2282 1.04743 24.528 1.26569 31.9878C1.48319 40.3835 4.85453 48.0179 10.7634 53.481C16.1658 58.4515 23.2554 61.1832 30.5963 61.1227C31.1437 61.1227 31.6838 61.1227 32.2566 61.0792C38.8832 60.7166 44.6544 58.7518 49.3453 55.279C44.4151 59.1144 38.3649 61.2495 31.6512 61.4417L31.6657 61.4235ZM32.2602 60.8979C24.2125 61.322 16.6179 58.6431 10.8939 53.3468C5.02491 47.9092 1.67895 40.3291 1.46869 31.9842C1.21856 22.3233 5.13728 13.6412 11.6914 7.78669C10.3655 9.01198 9.15232 10.3538 8.06636 11.796C3.6413 17.7402 1.39732 25.0264 1.71157 32.4301C2.04146 40.8439 5.48529 48.3805 11.3942 53.6223C16.5382 58.1936 23.1902 60.6405 30.3425 60.6405C31.1763 60.6405 32.021 60.6115 32.8801 60.5426C39.9599 59.9844 45.8507 57.8419 50.4835 54.1734C45.615 58.2226 39.4488 60.5173 32.2711 60.8943L32.2602 60.8979ZM7.20358 28.225C7.34164 30.5439 7.67022 32.8476 8.18598 35.1126C7.0042 30.2115 6.59457 24.3135 8.00835 18.7163C7.26842 21.8245 6.99838 25.0259 7.20721 28.2141L7.20358 28.225ZM9.60702 40.137L9.64327 40.2349C9.51277 40.0826 9.38951 39.934 9.28076 39.7745C9.28076 39.7346 9.25539 39.6984 9.24089 39.6549C9.36414 39.8216 9.49464 39.9775 9.62152 40.137H9.60702ZM9.53814 39.7527C9.56078 39.784 9.58136 39.8167 9.59977 39.8506L9.54177 39.7745C9.54426 39.7675 9.54426 39.7598 9.54177 39.7527H9.53814ZM10.216 40.9998C10.2259 41.0238 10.2381 41.0469 10.2523 41.0686C10.2052 41.0252 10.1617 40.978 10.1182 40.9309C10.0747 40.8838 10.0964 40.8874 10.0892 40.862C10.1327 40.9128 10.1762 40.9526 10.2197 41.0034L10.216 40.9998ZM10.0928 40.6119L10.1435 40.6699C10.1263 40.657 10.1116 40.641 10.1 40.6228L10.0928 40.6119ZM14.3378 44.4871L14.229 44.4617L14.1964 44.4255L14.3015 44.4581C14.3129 44.4658 14.3228 44.4757 14.3305 44.4871H14.3378ZM14.3088 44.3566C14.3183 44.3591 14.3283 44.3591 14.3378 44.3566C14.3337 44.3583 14.3294 44.3592 14.3251 44.3592C14.3207 44.3592 14.3164 44.3583 14.3124 44.3566H14.3088ZM14.2218 44.5596C15.7262 46.0096 16.9442 47.4053 18.0571 48.6777C19.8696 50.7658 21.4103 52.5094 23.4512 53.6658L23.6361 53.8906C21.2218 52.6617 19.46 50.628 17.3031 48.0905C16.3388 46.9739 15.2984 45.7668 14.0876 44.5016L14.2218 44.5379V44.5596ZM14.5009 44.6321C16.0143 46.0343 17.4439 47.5244 18.7821 49.0946C20.2902 50.8129 21.5626 52.2629 23.2011 53.3215C23.241 53.3795 23.2881 53.4375 23.3316 53.4991C21.3777 52.3499 19.8914 50.6498 18.1187 48.627C17.0312 47.3799 15.8422 46.0241 14.3849 44.6031L14.5045 44.6321H14.5009ZM14.5009 44.5161L14.577 44.5415L14.5009 44.5197V44.5161ZM21.8018 50.3163C21.0551 48.8662 20.2104 47.3582 17.9049 45.9371C20.3953 47.2966 21.1384 48.7756 21.7909 50.3126L21.8018 50.3163ZM18.5972 46.2308C20.6817 47.4017 21.3197 48.6886 21.7837 50.0299C21.1732 48.4404 20.0474 47.1015 18.5864 46.2272L18.5972 46.2308ZM21.8598 50.6099V50.6353L21.7873 50.5084C20.8883 48.975 19.9748 47.4053 17.6257 45.8791C20.2285 47.4126 21.0478 49.0293 21.849 50.5918L21.8598 50.6099ZM21.7184 50.5555L21.9758 50.9978L21.5879 50.4141C20.5729 48.8771 19.4491 47.1914 16.8753 45.5275C19.7174 47.1806 20.7215 48.8916 21.7039 50.5555H21.7184ZM21.5154 50.4649C21.7257 50.7875 21.936 51.1029 22.1535 51.4147C21.8707 51.0522 21.5952 50.6896 21.3161 50.2873C20.2285 48.7647 18.9924 47.0936 16.5382 45.4115C19.3041 47.1298 20.4605 48.8771 21.5154 50.4866V50.4649ZM21.2436 50.3416C21.6061 50.8636 21.9867 51.3639 22.3782 51.8388C21.8852 51.2987 21.4393 50.7259 20.9717 50.1241C19.779 48.5907 18.4667 46.9123 16.0633 45.194C18.793 46.963 20.0799 48.7321 21.2436 50.338V50.3416ZM20.9028 50.1785C21.4227 50.8714 21.9781 51.5369 22.5667 52.1723C22.5681 52.1868 22.5681 52.2013 22.5667 52.2158C21.848 51.4917 21.1703 50.728 20.5367 49.9284C19.1022 48.0653 17.4288 46.3992 15.5594 44.9729C18.2311 46.7854 19.6268 48.5653 20.8847 50.1821L20.9028 50.1785ZM20.4895 49.9791C21.1664 50.8451 21.9016 51.6638 22.69 52.4297C22.7047 52.4567 22.718 52.4846 22.7298 52.5131C21.7699 51.6408 20.8791 50.6955 20.0654 49.6855C18.6282 47.9126 17.0126 46.2921 15.244 44.8496H15.2875C17.2389 46.3057 18.9807 48.0232 20.4642 49.9537L20.4895 49.9791ZM20.0002 49.7399C20.8544 50.8032 21.7993 51.7905 22.8241 52.6907C22.8437 52.7282 22.8655 52.7645 22.8893 52.7994C21.6466 51.783 20.512 50.6411 19.5035 49.3919C18.1204 47.7349 16.6089 46.1895 14.983 44.7699C15.0065 44.7755 15.0295 44.7827 15.0519 44.7916C16.8743 46.2557 18.5344 47.9109 20.0038 49.729L20.0002 49.7399ZM22.8749 52.6001L22.9256 52.6436C22.94 52.6685 22.9558 52.6927 22.9727 52.7161L22.9111 52.6653C22.9004 52.6428 22.8883 52.621 22.8749 52.6001ZM19.4346 49.4462C20.6309 50.8201 21.6858 52.0345 22.9981 52.9952L23.1032 53.1619C21.5481 52.1143 20.3083 50.7005 18.8546 49.0511C17.5512 47.522 16.1605 46.0696 14.6894 44.701L14.7836 44.7264C16.4613 46.1742 18.0168 47.7577 19.4346 49.4607V49.4462ZM23.009 52.8393L23.0996 52.9082L23.1757 53.0133C23.1392 52.99 23.1041 52.9646 23.0706 52.9372C23.0489 52.9082 23.0307 52.8719 23.009 52.8357V52.8393ZM23.3316 53.2308C23.3751 53.2816 23.415 53.3396 23.4585 53.394L23.2881 53.2888L23.183 53.1257L23.3316 53.2308ZM23.1902 52.8683L23.2229 52.9082C23.2229 52.9082 23.1721 52.8828 23.1649 52.8683H23.1902ZM23.6071 53.568L23.7557 53.7347L23.5237 53.6078C23.4802 53.5535 23.4367 53.4918 23.4005 53.4375L23.6071 53.568ZM25.909 54.583L25.7858 54.5467C25.7446 54.5228 25.7023 54.5011 25.6589 54.4815L25.7314 54.5032L25.909 54.5866V54.583ZM25.8764 54.4706H25.8982L25.9598 54.496H25.9199L25.8764 54.4742V54.4706ZM25.706 54.6084C25.7894 54.6555 25.8764 54.699 25.9671 54.7425L25.7024 54.6736C25.6227 54.6265 25.5429 54.583 25.4704 54.5359L25.7097 54.6084H25.706ZM26.6123 54.8875L26.3767 54.8404L26.1592 54.7389L26.3622 54.786C26.4419 54.8222 26.5253 54.8549 26.6123 54.8875ZM26.3694 54.6881C26.4218 54.7044 26.4751 54.7177 26.5289 54.728L26.6051 54.757L26.4456 54.7207C26.4209 54.7083 26.3954 54.6974 26.3694 54.6881ZM27.8195 55.1413L28.095 55.2101L27.7325 55.1847L27.4606 55.1014L27.8231 55.1413H27.8195ZM27.8195 55.047H27.8847L28.0152 55.0796C27.9912 55.083 27.9668 55.083 27.9427 55.0796L27.8158 55.0506L27.8195 55.047ZM28.5155 55.3116L28.8309 55.3841C28.6895 55.3841 28.5481 55.3841 28.4067 55.3841C28.2654 55.3841 28.1892 55.3261 28.0877 55.2935C28.2291 55.2935 28.3705 55.2935 28.5155 55.3153V55.3116ZM28.3741 55.192H28.5626L28.8019 55.2391H28.5844L28.3741 55.1884V55.192ZM29.2623 55.3261L29.5631 55.3733H29.2333L28.9614 55.3189H29.2623V55.3261ZM29.1898 55.2283H29.2623L29.4109 55.2464H29.2913L29.1499 55.221L29.1898 55.2283ZM30.0272 55.3044L30.2737 55.3298H30.009C29.9256 55.3298 29.8386 55.3116 29.7589 55.2971C29.8495 55.2971 29.9365 55.2971 30.0308 55.2971L30.0272 55.3044ZM29.9655 55.4276L30.3063 55.4711L29.9111 55.5001C29.7951 55.5001 29.6791 55.4639 29.5668 55.4385H29.9655V55.4276ZM30.6905 55.3624C30.8029 55.3624 30.9298 55.3624 31.0531 55.3841L30.7159 55.4276L30.386 55.3914C30.4912 55.3914 30.5963 55.3914 30.7014 55.3624H30.6905ZM30.5927 55.2718C30.6615 55.2718 30.7377 55.2718 30.8065 55.2718H30.9842L30.7739 55.2971H30.5927V55.2718ZM31.7853 55.2718L31.4917 55.3261C31.4011 55.3261 31.3104 55.3261 31.2234 55.3261L31.5062 55.2863L31.7853 55.2718ZM32.253 55.2718C32.3581 55.2718 32.4632 55.2718 32.572 55.2718C32.4306 55.3044 32.2965 55.3298 32.1551 55.3551C32.0137 55.3805 31.934 55.3551 31.8252 55.3551L32.253 55.2899V55.2718ZM32.108 55.192L32.2856 55.1666H32.4741C32.4125 55.1666 32.3472 55.1848 32.2856 55.1993H32.108V55.192ZM32.9381 55.1268L33.2607 55.105C33.1701 55.1267 33.0759 55.1521 32.9816 55.1703C32.8873 55.1884 32.7786 55.1703 32.6843 55.1703L32.9417 55.1122L32.9381 55.1268ZM32.9381 55.0506L33.036 55.0325H33.1302L33.0287 55.0542H32.9345L32.9381 55.0506ZM32.9381 55.2573C33.0577 55.2573 33.1846 55.2573 33.3006 55.2573C33.1592 55.2971 33.0142 55.337 32.8729 55.3696H32.5103L32.9454 55.2754L32.9381 55.2573ZM33.7066 55.0724L34.0691 55.0361L33.6704 55.1485H33.3514C33.471 55.1231 33.5906 55.0905 33.7139 55.0579L33.7066 55.0724ZM33.5616 55.0035L33.7936 54.9527L34.0039 54.9237C33.9205 54.9491 33.8408 54.9673 33.761 54.9854L33.5616 55.0035ZM34.4896 54.8621L34.7615 54.8222L34.4461 54.9201L34.1743 54.9491L34.4896 54.8621ZM34.4026 54.7932H34.4679C34.5069 54.7881 34.5456 54.7808 34.5839 54.7715L34.5186 54.7932H34.3954H34.4026ZM35.9651 54.496L36.1862 54.4489L35.8817 54.5649L35.6533 54.6047C35.7548 54.5721 35.8563 54.5286 35.9651 54.496ZM35.8925 54.4307L36.0049 54.3981H36.0738L35.9687 54.438L35.8925 54.4561V54.4307ZM36.6429 54.351L36.9547 54.2821C36.8133 54.3437 36.6756 54.3981 36.5378 54.4525L36.2587 54.4996C36.3892 54.4525 36.5197 54.3981 36.6466 54.3474L36.6429 54.351ZM36.4979 54.3039L36.7481 54.2096L36.9039 54.1697L36.6321 54.2749L36.4979 54.3039ZM37.397 54.0429L37.6616 53.9703L37.2991 54.1226L37.0526 54.1806L37.3788 54.0429H37.397ZM37.3607 53.974L37.5166 53.9123L37.3897 53.9667H37.3462L37.3607 53.974ZM37.3027 54.1987L37.687 54.1117L37.252 54.3184L36.8894 54.3909L37.3172 54.1987H37.3027ZM38.1256 53.8362L38.4482 53.7456L38.0096 53.9522L37.6833 54.032L38.1256 53.8362ZM37.9226 53.8181C38.0096 53.7746 38.1002 53.7383 38.1872 53.7021C38.2548 53.6765 38.3238 53.6548 38.3939 53.6368L38.1292 53.7601L37.9226 53.8181ZM38.8615 53.481L39.1588 53.3867C39.0391 53.4447 38.9231 53.5136 38.7962 53.5716H38.7636L38.499 53.6477L38.8615 53.4773V53.481ZM38.7999 53.4266L38.9775 53.3432L39.0391 53.3215C38.9848 53.3468 38.9304 53.3758 38.876 53.3976L38.8035 53.423L38.7999 53.4266ZM40.2499 52.8683L40.529 52.7704C40.384 52.8574 40.239 52.9299 40.094 53.0133L39.8584 53.0894L40.2535 52.8719L40.2499 52.8683ZM40.1375 52.8357L40.326 52.7378L40.4783 52.6762L40.2825 52.7849L40.1375 52.8357ZM48.7362 49.2106C50.9657 48.6741 53.2314 48.1231 55.3158 46.6477C54.7258 47.0928 54.0974 47.4847 53.438 47.8186C51.9933 48.4332 50.4912 48.9032 48.9538 49.2215C47.4263 49.5424 45.9314 50.0022 44.4876 50.5954C44.1541 50.7114 43.8242 50.8383 43.498 50.9796L43.5886 50.9216L43.6647 50.8745C45.238 50.048 46.9273 49.642 48.671 49.2179L48.7362 49.2106ZM44.2484 50.5483C45.9703 49.5586 47.7792 49.1309 49.5374 48.7357C51.2956 48.3406 53.1951 47.8766 54.9315 46.8362C52.9522 48.1339 50.8207 48.6487 48.7254 49.1635C47.193 49.4845 45.695 49.9518 44.252 50.5591L44.2484 50.5483ZM53.2567 48.1956C52.7521 48.4376 52.2341 48.6506 51.7052 48.8336C52.8987 48.3677 54.0241 47.7435 55.0512 46.9775L55.0838 46.9558C54.5127 47.4155 53.9067 47.83 53.2712 48.1956H53.2567ZM54.3805 47.5576C54.3225 47.6011 54.2645 47.6482 54.1993 47.6881C54.1631 47.7067 54.128 47.7273 54.0941 47.7497L54.3805 47.5576ZM52.8362 48.9677L52.5353 49.12C52.9522 48.8698 53.3655 48.6016 53.7679 48.308C53.4126 48.5472 53.1009 48.7683 52.7855 48.975L52.8362 48.9677ZM53.5939 48.5363L53.5431 48.5726H53.5177C53.5417 48.5536 53.5671 48.5366 53.5939 48.5218V48.5363ZM52.9631 49.8885L52.7746 50.0154C52.9812 49.8522 53.1806 49.6819 53.3764 49.5115L53.4489 49.4607L52.9631 49.8885ZM53.0392 50.0371C53.0097 50.0618 52.9818 50.0884 52.9558 50.1169C52.9451 50.1195 52.9339 50.1195 52.9232 50.1169L53.0356 50.019L53.0392 50.0371ZM52.133 50.6498L52.0496 50.7041C52.2526 50.5446 52.4483 50.3743 52.6513 50.2075L52.6949 50.1785C52.5136 50.338 52.3323 50.4975 52.133 50.6498ZM52.452 50.6244L52.2562 50.7984L52.2091 50.831C52.2925 50.7621 52.3722 50.6969 52.452 50.6244ZM3.19786 31.5238C3.24136 32.0385 3.31024 32.5388 3.38999 33.0282C3.41537 33.4161 3.44074 33.804 3.48062 34.1882C3.48062 34.3514 3.52049 34.5145 3.53862 34.674C3.34152 33.9229 3.19976 33.1584 3.11448 32.3866C3.05934 30.9225 3.09445 29.4564 3.21961 27.9966C3.1166 29.1686 3.10932 30.347 3.19786 31.5202V31.5238ZM4.22013 22.8236C3.53202 25.8004 3.23588 28.8544 3.33924 31.908C3.33924 31.7739 3.30299 31.6434 3.29211 31.502C3.10264 28.5703 3.41651 25.6277 4.22013 22.8018V22.8236ZM6.7577 18.6583C5.95126 21.1616 5.44027 23.7506 5.23516 26.3725C5.26779 25.778 5.31129 25.1763 5.38016 24.56C5.78866 21.1829 6.75264 17.8965 8.23311 14.8339C8.47599 14.3481 8.737 13.866 9.00888 13.3838C8.0958 15.0642 7.34211 16.8265 6.7577 18.6475V18.6583ZM9.13576 13.5288C8.911 13.9385 8.70075 14.3517 8.49412 14.7759C8.65362 14.446 8.81675 14.1197 8.98713 13.7935L9.13576 13.5288ZM6.23568 28.4823C6.23568 29.2762 6.27919 30.0447 6.33356 30.7843C6.22481 30.0302 6.14868 29.269 6.10518 28.4896C6.10518 27.4383 6.14144 26.3435 6.22844 25.227C6.16691 26.3137 6.16691 27.4029 6.22844 28.4896L6.23568 28.4823ZM39.9128 53.3432C39.9889 53.3215 40.0687 53.3033 40.1484 53.2888C39.9128 53.4048 39.6808 53.51 39.4488 53.6223L39.3001 53.6513L39.9128 53.3432ZM39.804 53.2925C39.9816 53.1982 40.1665 53.104 40.3369 53.0024L40.4565 52.9734L39.8729 53.2743L39.8113 53.2925H39.804ZM6.17406 17.6071C6.15231 17.6687 6.12693 17.7267 6.10518 17.7847C4.39414 21.9282 3.50961 26.2022 3.62924 29.9432C3.62924 30.3311 3.66912 30.7335 3.70537 31.1432C3.70537 31.7884 3.738 32.4301 3.7815 33.0789C3.63833 32.3064 3.54509 31.5253 3.50237 30.7408C3.48424 30.4725 3.47699 30.2006 3.47337 29.9287C3.51338 28.125 3.68787 26.3269 3.99538 24.5491C4.48087 22.1691 5.20972 19.8453 6.17043 17.6143L6.17406 17.6071ZM4.78928 21.0799C4.90528 20.6666 5.03216 20.2534 5.15178 19.851C5.44904 19.0366 5.77288 18.2354 6.12331 17.4476C5.61004 18.6312 5.15989 19.8413 4.77477 21.0727L4.78928 21.0799ZM4.42677 29.9759C4.42677 30.6501 4.44851 31.3317 4.48114 32.0095C4.33927 31.1352 4.25571 30.2523 4.23101 29.3669C4.26416 28.0925 4.36459 26.8207 4.53189 25.5569C4.46664 26.1695 4.41952 26.7785 4.39777 27.3694C4.36175 28.2347 4.37506 29.1013 4.43764 29.965L4.42677 29.9759ZM5.42004 29.5336C5.42004 30.1825 5.44179 30.8314 5.48166 31.4839C5.34941 30.6774 5.26228 29.8641 5.22066 29.0479C5.22066 27.9603 5.28591 26.8438 5.39829 25.7418C5.31167 27.0045 5.31772 28.2718 5.41641 29.5336H5.42004ZM6.87007 28.1162C6.90995 29.2799 7.00058 30.4 7.12383 31.4585C6.97883 30.545 6.87008 29.6025 6.80483 28.6382C6.75627 27.2433 6.78289 25.8469 6.88458 24.4549C6.81382 25.6731 6.81382 26.8944 6.88458 28.1126L6.87007 28.1162ZM37.5166 54.5794L37.687 54.5576L36.9076 54.8694H36.7988C37.0381 54.7751 37.2773 54.6736 37.5238 54.5685L37.5166 54.5794ZM36.9583 54.7244L37.1758 54.6301C37.189 54.633 37.2026 54.633 37.2157 54.6301L36.962 54.7316L36.9583 54.7244ZM37.455 54.5069L38.1039 54.2169C38.1303 54.2206 38.1572 54.2206 38.1836 54.2169C37.9516 54.322 37.7196 54.4235 37.4948 54.5177H37.455V54.5069ZM36.9076 57.4758C36.3348 57.5338 35.7874 57.5701 35.269 57.5846C35.6678 57.5012 36.0666 57.4106 36.4689 57.3127L37.1577 57.1459C38.3096 57.024 39.4526 56.8291 40.5798 56.5623C42.459 56.1183 44.2901 55.4905 46.0464 54.6881C46.4669 54.5359 46.8802 54.3727 47.2935 54.1987C46.4633 54.6446 45.6295 55.0434 44.803 55.3914C42.2144 56.2395 39.578 56.9343 36.9076 57.4722V57.4758ZM42.1241 56.3883C41.0636 56.7178 39.9852 56.9865 38.8941 57.1931C39.9744 56.9429 41.0547 56.6783 42.1132 56.3883H42.1241ZM3.88663 29.1385C3.89524 30.1228 3.97398 31.1053 4.12226 32.0784C4.14642 32.6149 4.18267 33.1515 4.23101 33.688C4.07291 33.0417 3.95187 32.3869 3.8685 31.7268C3.84312 30.8676 3.84312 30.0012 3.8685 29.1385H3.88663ZM3.73437 29.3995C3.73947 27.1617 4.0232 24.9332 4.57902 22.7656C4.0853 24.9451 3.79765 27.1661 3.71987 29.3995H3.73437ZM4.29989 34.3151C4.32889 34.5652 4.35064 34.8226 4.38326 35.0728C4.38326 35.196 4.42314 35.3156 4.43764 35.4353C4.28539 35.0039 4.15126 34.5652 4.0425 34.1339C3.99538 33.6372 3.9555 33.1442 3.9265 32.6476C4.01801 33.2058 4.13902 33.7588 4.28901 34.3042L4.29989 34.3151ZM5.8913 32.5461C5.93118 32.9847 5.9783 33.427 6.03268 33.8656C5.88768 33.3617 5.7608 32.8433 5.67017 32.3177C5.62667 31.792 5.6013 31.2592 5.57592 30.7263C5.6593 31.3462 5.7753 31.9515 5.9058 32.5388L5.8913 32.5461ZM5.52879 29.7149C5.52879 28.8992 5.52879 28.0763 5.57954 27.2571C5.5791 28.226 5.63235 29.1941 5.73905 30.1571C5.73905 30.7299 5.78255 31.299 5.82605 31.8682C5.69555 31.1673 5.59646 30.452 5.52879 29.7221V29.7149ZM7.41021 34.9749C7.45372 35.1996 7.49722 35.4171 7.54072 35.631C7.39571 35.2359 7.25796 34.8299 7.13833 34.4202C7.09121 34.1375 7.04771 33.8438 7.00783 33.5357C7.12746 34.0251 7.26521 34.5036 7.41747 34.9857L7.41021 34.9749ZM6.90995 32.8361C6.8592 32.418 6.81207 31.9866 6.76857 31.5419C6.8737 32.1799 6.99695 32.7998 7.14921 33.4161C7.19996 33.7423 7.25071 34.065 7.30508 34.3767C7.16008 33.8728 7.02595 33.3581 6.90995 32.8361ZM48.0294 51.6177C48.5514 51.4582 49.0661 51.2914 49.5773 51.1065C46.9759 52.281 44.2329 53.112 41.4172 53.5788C42.0697 53.3432 42.7258 53.1293 43.3747 52.9336C44.9541 52.5985 46.5091 52.1576 48.0294 51.614V51.6177ZM45.1293 52.4369L45.6042 52.3101L45.8905 52.2303L45.1293 52.4369ZM46.5793 53.7093C47.0397 53.5498 47.5001 53.3795 47.9532 53.2055C46.9081 53.7331 45.8319 54.1968 44.7305 54.5939C43.2515 55.0506 41.7362 55.4458 40.1955 55.8373C39.3799 55.9968 38.6005 56.1128 37.8791 56.1998C38.4482 56.0258 39.021 55.8626 39.5865 55.7068C41.9874 55.3199 44.3345 54.652 46.5793 53.7166V53.7093ZM40.5725 55.4385L41.4861 55.1884C42.7548 54.8512 44.0236 54.5177 45.238 54.1407C43.7171 54.692 42.1562 55.1259 40.5689 55.4385H40.5725ZM38.151 56.7798L36.8605 57.0916C36.4073 57.1351 35.965 57.1641 35.5482 57.1749C36.0521 57.0553 36.5596 56.9357 37.0635 56.7943L37.2048 56.758C37.9951 56.6819 38.8397 56.5695 39.7424 56.3955C39.2204 56.526 38.6911 56.6529 38.1619 56.758L38.151 56.7798ZM44.6761 55.1811C42.5279 56.0381 40.285 56.6356 37.9951 56.961L38.1836 56.9139C40.4022 56.3847 42.5845 55.859 44.6761 55.1775V55.1811ZM7.41384 36.5119C7.45009 36.6968 7.48634 36.8744 7.52621 37.0375C7.38484 36.7584 7.25433 36.4684 7.13108 36.1748C7.09121 35.9754 7.05133 35.7615 7.01145 35.5404C7.14921 35.8594 7.27246 36.1857 7.41384 36.5119ZM6.93533 35.0619C6.89545 34.8335 6.8592 34.6015 6.82295 34.3586C6.94258 34.7429 7.0767 35.1199 7.21446 35.4896C7.24708 35.6781 7.28334 35.8521 7.31959 36.0406C7.18546 35.718 7.05133 35.3918 6.93533 35.0583V35.0619ZM27.1488 57.3163C27.6563 57.3163 28.1711 57.3163 28.6931 57.2656L28.7837 57.3054C24.5569 57.5483 20.7832 56.7508 17.5025 54.8947C12.8188 52.2521 9.35326 47.5286 7.35221 41.1194C7.47184 41.2209 7.58784 41.326 7.71472 41.4239C9.83177 47.9164 13.3626 52.6291 18.0716 55.1449C20.8728 56.6183 23.9986 57.3661 27.1633 57.3199L27.1488 57.3163ZM33.0976 56.3049C33.1339 56.3049 33.1701 56.3049 33.2064 56.3049L32.4088 56.4898H32.3218C32.5792 56.4354 32.8402 56.3738 33.0976 56.3085V56.3049ZM40.4892 54.1444C40.1267 54.2749 39.7641 54.4054 39.4016 54.5467C39.3654 54.5467 39.3364 54.5685 39.3001 54.5866L38.6875 54.6664C38.9993 54.5431 39.311 54.4162 39.63 54.2821C39.9092 54.2386 40.1955 54.1951 40.4892 54.1444ZM39.9309 54.1444L40.0433 54.0972C40.355 53.9595 40.674 53.8362 40.993 53.7166C41.7181 53.5933 42.4431 53.4447 43.2189 53.278C42.4648 53.4918 41.7108 53.7202 40.9532 53.9776C40.6088 54.0392 40.2644 54.0936 39.9382 54.1444H39.9309ZM20.156 55.8481C19.6666 55.656 19.1845 55.4494 18.706 55.2101C14.084 52.8719 10.5423 48.3225 8.32736 41.9097C8.43612 41.9894 8.55574 42.0619 8.67174 42.1417C9.47673 44.4839 10.5625 46.7199 11.9053 48.801C13.9245 51.8533 16.4113 54.0936 19.2896 55.4675C19.5724 55.6004 19.8588 55.7213 20.1488 55.83L20.156 55.8481ZM20.6092 55.7539C15.9256 53.7927 12.2715 49.4281 9.70127 42.7724L10.0312 42.9501C12.663 49.5695 16.2808 53.8906 20.8122 55.83C20.7469 55.8046 20.6744 55.7865 20.6055 55.7539H20.6092ZM20.3554 55.7249C20.2285 55.6705 20.0944 55.6234 19.9639 55.569C15.2839 53.4737 11.6951 49.0873 9.25901 42.5187C9.36777 42.5839 9.48014 42.6528 9.59614 42.7144C12.1337 49.3339 15.737 53.7021 20.3554 55.7249ZM9.19376 42.3447C9.16838 42.2649 9.13576 42.1924 9.11038 42.1127C9.22276 42.1924 9.33151 42.2722 9.45114 42.3447C9.48014 42.4172 9.50552 42.4824 9.5309 42.5549L9.19376 42.3411V42.3447ZM9.13938 42.4389C11.5827 49.0837 15.1969 53.5208 19.924 55.6379C19.7283 55.5581 19.5289 55.4784 19.3368 55.3841C14.7256 53.1873 11.1332 48.6705 8.824 42.2251L9.15751 42.4389H9.13938ZM8.7515 42.0764C8.71887 41.9894 8.68987 41.906 8.66087 41.819C8.766 41.8952 8.882 41.9677 8.99075 42.0438C9.01976 42.1236 9.04876 42.2033 9.08138 42.2831C8.97625 42.2142 8.86025 42.1489 8.75512 42.0764H8.7515ZM8.60287 41.6487L8.50862 41.3804C8.61737 41.471 8.73337 41.5617 8.84938 41.6487C8.87475 41.7284 8.90375 41.8045 8.93275 41.8807C8.824 41.8082 8.708 41.732 8.59924 41.6523L8.60287 41.6487ZM8.52311 41.7103C8.55574 41.7973 8.58474 41.8879 8.61374 41.9749L8.26936 41.7248C8.23673 41.6305 8.20049 41.5327 8.17149 41.4312C8.28749 41.5254 8.39624 41.6233 8.53399 41.7103H8.52311ZM8.11348 41.2608C8.08448 41.1629 8.04823 41.0686 8.0156 40.9671C8.13161 41.0723 8.24761 41.1702 8.37811 41.2717C8.40711 41.3623 8.43974 41.4493 8.47236 41.5399C8.35274 41.4493 8.24036 41.355 8.10985 41.2608H8.11348ZM26.2389 57.5737C26.6703 57.5954 27.1053 57.6099 27.544 57.6099C28.1457 57.6099 28.7584 57.5809 29.3783 57.5374L29.574 57.6172C24.546 57.9326 20.0437 56.9175 16.2989 54.5757C11.5863 51.6213 8.10623 46.5462 6.29006 40.0754C6.40607 40.2059 6.52569 40.34 6.65257 40.4669C8.56299 47.0464 12.0322 51.9765 16.8463 54.8367C19.7085 56.5094 22.9374 57.4542 26.2498 57.5882L26.2389 57.5737ZM29.5233 56.6819C29.5751 56.6956 29.6259 56.7125 29.6755 56.7327L29.0121 56.8197L28.8599 56.7617L29.5233 56.6855V56.6819ZM28.7257 56.7L28.3052 56.5297L28.9432 56.4862L29.3855 56.6384C29.1608 56.6674 28.9433 56.6855 28.7257 56.7037V56.7ZM30.6833 57.0335L30.8573 57.0807C30.5782 57.1169 30.3027 57.1568 30.0272 57.1822L29.8967 57.1423C30.1577 57.1133 30.4187 57.0734 30.6833 57.0335ZM29.6538 57.0553C29.636 57.0502 29.619 57.0429 29.603 57.0335C29.8531 57.0082 30.1105 56.9755 30.3643 56.9393L30.4585 56.9683C30.1867 57.0045 29.9256 57.0263 29.6574 57.0553H29.6538ZM31.1328 57.1604C31.1981 57.1604 31.2561 57.1967 31.3141 57.2112C31.0168 57.2511 30.7195 57.2909 30.4187 57.3163L30.2737 57.2692C30.5564 57.2402 30.8428 57.2039 31.1328 57.1604ZM30.0453 57.2982C30.0853 57.3154 30.1265 57.33 30.1685 57.3417L29.3275 57.4178L29.2115 57.3671C29.4906 57.3489 29.7661 57.3308 30.0489 57.3018L30.0453 57.2982ZM30.4767 57.4432L30.7195 57.5266C30.415 57.5592 30.1069 57.5846 29.806 57.6099L29.5921 57.5266C29.8858 57.5012 30.183 57.4794 30.4767 57.4468V57.4432ZM30.7014 57.4178L31.6403 57.2982L31.9448 57.3779C31.6149 57.4251 31.2887 57.4649 30.9624 57.5012L30.7014 57.4178ZM32.514 57.0299C32.1913 57.0879 31.876 57.1314 31.5533 57.1822L31.3684 57.1314C31.6584 57.0916 31.9557 57.0299 32.2566 56.9792L32.514 57.0372V57.0299ZM32.514 56.932C32.8293 56.874 33.1447 56.8088 33.4637 56.7363L33.8262 56.7762C33.4637 56.8523 33.1012 56.9175 32.7605 56.9792H32.6408C32.5901 56.9792 32.543 56.9574 32.4958 56.9465L32.514 56.932ZM31.8868 57.2583C32.2203 57.2076 32.5538 57.1568 32.891 57.0952L33.3187 57.1568C32.9562 57.2257 32.5756 57.2837 32.2058 57.3381L32.0536 57.3018L31.8832 57.2583H31.8868ZM33.1484 57.0444C33.5109 56.9719 33.8988 56.8958 34.2758 56.8124C34.4788 56.8124 34.6854 56.8124 34.9029 56.8124C34.4715 56.9103 34.051 56.9973 33.6269 57.0807L33.1484 57.0444ZM34.1453 56.7109L33.7356 56.6783C34.0981 56.5985 34.4353 56.5115 34.7869 56.4209C34.9537 56.4209 35.1168 56.4209 35.2944 56.4209H35.3307C34.9283 56.5224 34.5331 56.613 34.138 56.7L34.1453 56.7109ZM34.7071 56.3303C34.573 56.3303 34.4498 56.3303 34.3446 56.3122C34.66 56.2288 34.9863 56.1345 35.3089 56.0439H35.3343H35.82C35.4575 56.1527 35.095 56.2397 34.7325 56.3339L34.7071 56.3303ZM34.4063 56.4064C34.0655 56.4898 33.732 56.5659 33.3912 56.6384H33.2644L33.1339 56.6167C33.4311 56.5514 33.7356 56.4753 34.0365 56.4028C34.1561 56.4028 34.2758 56.4209 34.399 56.4245L34.4063 56.4064ZM32.833 56.5514L32.6662 56.5297C32.9454 56.4644 33.2245 56.4028 33.5072 56.3303L33.7139 56.3557C33.4166 56.4245 33.123 56.4934 32.8293 56.555L32.833 56.5514ZM32.8873 56.6529L33.1375 56.6928C32.8293 56.758 32.5212 56.816 32.2203 56.8704L31.9992 56.8233C32.2928 56.7689 32.5865 56.7182 32.8873 56.6493V56.6529ZM31.7454 56.7689L31.6186 56.7399C31.8868 56.6928 32.1551 56.6384 32.427 56.5804L32.572 56.6022L31.7454 56.7689ZM31.7636 56.8668L31.9629 56.9103L31.1038 57.0517L30.9189 57.0009C31.1981 56.961 31.4808 56.9175 31.7636 56.8668ZM30.676 56.932L30.589 56.9103C30.85 56.8704 31.1111 56.8305 31.3793 56.7834L31.4917 56.8088C31.2162 56.874 30.9479 56.9139 30.676 56.9502V56.932ZM30.3462 56.8342C30.5927 56.8015 30.8392 56.7617 31.0929 56.7145H31.1364C30.8718 56.758 30.6108 56.7907 30.3534 56.8269L30.3462 56.8342ZM30.4984 56.6022C30.3027 56.6384 30.1069 56.671 29.9075 56.6964L29.7553 56.6493C29.9764 56.6167 30.1939 56.584 30.4187 56.5442L30.5854 56.5877H30.5057L30.4984 56.6022ZM30.1359 56.8668C29.9402 56.8958 29.7408 56.9212 29.5486 56.9429C29.5715 56.9463 29.5947 56.9463 29.6175 56.9429L30.1359 56.8668ZM29.4109 57.0589C29.4274 57.0643 29.4432 57.0716 29.458 57.0807L28.7004 57.1387C28.6908 57.1409 28.6809 57.1409 28.6714 57.1387C28.8997 57.1242 29.1318 57.0988 29.3819 57.077L29.4109 57.0589ZM29.6936 57.1604L29.835 57.2112C29.5523 57.2402 29.284 57.2547 29.0085 57.2728L28.9106 57.2293C29.168 57.2076 29.429 57.1894 29.6864 57.1604H29.6936ZM29.0266 57.3816L29.1318 57.4251C27.6432 57.5125 26.1499 57.4677 24.6693 57.2909C25.5585 57.3937 26.453 57.4445 27.3482 57.4432C27.8992 57.4432 28.4611 57.4214 29.0303 57.3816H29.0266ZM6.7867 39.1111C6.7432 38.9407 6.69607 38.7776 6.6562 38.6036C6.77582 38.774 6.9027 38.9335 7.0187 39.0966C7.05858 39.2561 7.10571 39.4084 7.14921 39.5679C7.0187 39.4192 6.89908 39.2634 6.7867 39.1111ZM7.19996 39.7745C7.23621 39.9014 7.26883 40.0319 7.30508 40.137C7.17821 40.0029 7.05133 39.8724 6.94257 39.7382C6.9027 39.6005 6.87008 39.4591 6.83383 39.3177C6.95708 39.4664 7.07671 39.615 7.19634 39.76L7.19996 39.7745ZM6.58732 38.3788C6.54019 38.1831 6.50757 37.9837 6.46407 37.7807C6.58732 37.9873 6.7142 38.1903 6.84832 38.3861C6.89183 38.5601 6.92808 38.7486 6.96795 38.9081C6.83382 38.7341 6.71057 38.5456 6.58732 38.3752V38.3788ZM6.58732 38.8791C6.45319 38.6978 6.32631 38.5166 6.20306 38.3353C6.15593 38.136 6.11606 37.9402 6.07256 37.7372C6.18856 37.9329 6.31906 38.1251 6.43506 38.3136C6.47857 38.5057 6.52932 38.6761 6.57282 38.8791H6.58732ZM6.64532 39.1147C6.6852 39.2634 6.71782 39.4156 6.7577 39.5606C6.62719 39.4047 6.50394 39.2525 6.39519 39.0966C6.35531 38.9298 6.31906 38.7667 6.27919 38.5963C6.39882 38.7667 6.52569 38.9407 6.6417 39.1111L6.64532 39.1147ZM6.81208 39.7709C6.84833 39.9086 6.8882 40.0428 6.92808 40.1769C6.8012 40.0428 6.67795 39.905 6.56557 39.7672C6.52569 39.6186 6.48219 39.47 6.44594 39.3214C6.57644 39.4772 6.6997 39.6259 6.82657 39.7745L6.81208 39.7709ZM6.9897 40.3944C7.02958 40.5213 7.06946 40.6518 7.10571 40.7786C6.9752 40.6554 6.8592 40.5285 6.7432 40.4161C6.70332 40.2748 6.65982 40.1334 6.61994 39.992C6.7432 40.1261 6.86282 40.2711 6.98245 40.4053L6.9897 40.3944ZM7.09846 40.3581C7.05496 40.224 7.01508 40.0935 6.9752 39.9557C7.09121 40.0899 7.21446 40.2204 7.33771 40.3509C7.37034 40.4633 7.40659 40.5793 7.44284 40.6916C7.34496 40.5829 7.22533 40.4741 7.11295 40.3618L7.09846 40.3581ZM7.44284 40.311C7.40659 40.1914 7.37759 40.0718 7.34496 39.9485C7.46096 40.079 7.58784 40.2131 7.70747 40.3364C7.7401 40.4451 7.77272 40.5575 7.80172 40.6626C7.67847 40.5466 7.55522 40.427 7.43922 40.3001L7.44284 40.311ZM7.29059 39.7455C7.25071 39.6005 7.20721 39.4482 7.16733 39.2996C7.29059 39.4519 7.41022 39.6005 7.52984 39.7491C7.56609 39.8796 7.60234 40.0065 7.64222 40.1406C7.54072 40.0137 7.42109 39.8832 7.30508 39.7491L7.29059 39.7455ZM7.14921 39.1256C7.10571 38.9588 7.06221 38.7885 7.0187 38.6145C7.14558 38.7957 7.26521 38.977 7.40296 39.151L7.52259 39.5787C7.39209 39.4301 7.26884 39.2742 7.16008 39.1256H7.14921ZM6.95708 38.3535C6.9172 38.194 6.88095 38.0345 6.8447 37.8749C6.96795 38.0743 7.09846 38.2628 7.22896 38.4513C7.26159 38.5891 7.29421 38.7268 7.33046 38.861C7.20358 38.6942 7.07308 38.5275 6.96795 38.3535H6.95708ZM6.77582 37.5813C6.75045 37.4689 6.72145 37.3602 6.69607 37.2478C6.6707 37.1354 6.66707 37.0956 6.64894 37.0122C6.7722 37.2442 6.90632 37.4689 7.0332 37.6901C7.07308 37.8568 7.11658 38.02 7.16008 38.1867C7.02595 37.9801 6.89908 37.7734 6.7722 37.5596L6.77582 37.5813ZM6.66345 37.5813C6.6997 37.7589 6.7432 37.9438 6.78308 38.1033C6.65257 37.9076 6.52569 37.7082 6.42057 37.5052C6.37707 37.2986 6.32631 37.0919 6.28643 36.878C6.40969 37.1173 6.54382 37.3493 6.67432 37.5777L6.66345 37.5813ZM6.30094 37.4979C6.34444 37.7154 6.39519 37.9257 6.44232 38.1396C6.30819 37.9329 6.18131 37.7263 6.05806 37.5161C6.00731 37.2696 5.96018 37.023 5.91305 36.7693C5.98193 36.9034 6.03993 37.0375 6.10881 37.1681C6.17769 37.2986 6.23931 37.3856 6.30818 37.4979H6.30094ZM5.91668 37.4146C5.96018 37.6321 6.00006 37.8459 6.04718 38.0598C5.90943 37.8423 5.78255 37.6284 5.66292 37.4073C5.61579 37.1717 5.57592 36.9324 5.53241 36.6823C5.65567 36.9288 5.78618 37.1681 5.91668 37.4073V37.4146ZM6.10881 38.3317C6.14868 38.5093 6.19581 38.6942 6.23931 38.8718C6.10881 38.6906 5.98556 38.5093 5.8768 38.3317C5.82968 38.1251 5.78255 37.9221 5.73905 37.7154C5.8623 37.9221 5.9928 38.1251 6.12693 38.3317H6.10881ZM6.30094 39.1111C6.33719 39.2706 6.37344 39.4301 6.41331 39.586C6.28281 39.4265 6.16681 39.267 6.05081 39.1039C6.0073 38.9371 5.97468 38.7667 5.93118 38.5963C6.05081 38.7703 6.17768 38.9588 6.29369 39.1184L6.30094 39.1111ZM6.47494 39.7999C6.51482 39.9521 6.55832 40.1007 6.60182 40.2494C6.47857 40.1189 6.36257 39.9884 6.23931 39.8579C6.18856 39.6947 6.14868 39.528 6.10518 39.3612C6.22118 39.5099 6.34444 39.6585 6.46769 39.8035L6.47494 39.7999ZM16.9225 54.7606C12.2098 51.9475 8.75875 47.1153 6.8447 40.6663C6.95708 40.7786 7.08396 40.8874 7.20721 40.9925C9.21914 47.5177 12.7173 52.3246 17.4735 55.0107C19.06 55.9069 20.7702 56.5641 22.5486 56.961C20.5574 56.5275 18.6483 55.7785 16.8935 54.7425L16.9225 54.7606ZM7.14921 40.5466C7.26521 40.659 7.38121 40.7714 7.51172 40.8838C7.54797 40.9961 7.58422 41.1122 7.61684 41.2245L7.25433 40.92C7.21446 40.7968 7.17821 40.6699 7.14196 40.5575L7.14921 40.5466ZM7.60234 40.8403C7.56609 40.7279 7.53347 40.6155 7.49722 40.5031L7.85973 40.8439C7.89235 40.949 7.93223 41.0469 7.96485 41.1557C7.8416 41.0541 7.7256 40.9454 7.60234 40.8403ZM8.0156 41.3224C8.04823 41.4275 8.08086 41.5254 8.11711 41.6269L7.7546 41.355C7.71835 41.2499 7.68572 41.1375 7.6531 41.0324C7.76547 41.1339 7.88873 41.2282 8.0156 41.326V41.3224ZM7.93947 40.7931L7.87423 40.4995C7.99023 40.6155 8.10986 40.7279 8.23673 40.862C8.26936 40.9563 8.29836 41.0541 8.32374 41.1484C8.20049 41.0469 8.08448 40.9381 7.96123 40.833L7.93947 40.7931ZM7.79447 40.2965C7.7546 40.1696 7.72197 40.0428 7.68572 39.934C7.80897 40.0681 7.92498 40.2059 8.04823 40.3364C8.08448 40.4451 8.11348 40.5575 8.14973 40.6663C8.0301 40.5503 7.90685 40.4343 7.78722 40.3038L7.79447 40.2965ZM7.6531 39.7745C7.61322 39.6295 7.56609 39.4845 7.52621 39.3395C7.64947 39.4917 7.77272 39.6367 7.88872 39.7817L8.01923 40.137C7.89235 40.0065 7.77272 39.876 7.65672 39.7491L7.6531 39.7745ZM7.46097 39.0821C7.42834 38.9552 7.39572 38.8247 7.36672 38.7196C7.48997 38.8863 7.61322 39.0567 7.72922 39.2235C7.76185 39.3359 7.78723 39.4482 7.81985 39.5606C7.69297 39.4084 7.5661 39.2561 7.45734 39.1002L7.46097 39.0821ZM7.30508 38.4513C7.26883 38.3027 7.22896 38.1577 7.19271 38.0055C7.31596 38.2012 7.44647 38.3933 7.58059 38.5855C7.61322 38.7232 7.64947 38.8573 7.68935 38.9915C7.55522 38.8138 7.43197 38.629 7.30871 38.455L7.30508 38.4513ZM7.12746 37.7263V37.6792L7.00783 37.1572C7.13833 37.4001 7.26884 37.6393 7.40659 37.8822L7.47184 38.1541C7.47184 38.2302 7.51172 38.2991 7.52984 38.3716C7.39209 38.165 7.26521 37.9511 7.13833 37.7372L7.12746 37.7263ZM6.93533 36.8418C6.89908 36.6605 6.8592 36.4793 6.81932 36.2654C6.9462 36.5445 7.0767 36.8164 7.21446 37.0811C7.24708 37.2406 7.27971 37.3892 7.31596 37.5306C7.18546 37.3058 7.05133 37.0811 6.93533 36.8454V36.8418ZM6.83383 36.8418C6.88095 37.0666 6.92445 37.2732 6.96795 37.4689C6.82657 37.2224 6.6997 36.9723 6.57282 36.7222C6.52932 36.501 6.48581 36.2582 6.43869 35.9972C6.56557 36.2835 6.69607 36.5699 6.83383 36.8454V36.8418ZM6.47132 36.6497C6.50757 36.8527 6.54382 37.0593 6.58732 37.2623C6.45319 37.0194 6.32631 36.7729 6.20306 36.5373L6.06168 35.7869C6.09431 35.863 6.12331 35.9464 6.15593 36.0261C6.25018 36.24 6.35894 36.4394 6.45681 36.6424L6.47132 36.6497ZM6.06168 36.4793C6.08343 36.5953 6.10155 36.7113 6.12693 36.8418C6.15231 36.9723 6.17044 37.0376 6.18856 37.1391C6.05081 36.8889 5.9203 36.6388 5.79705 36.3778C5.75355 36.124 5.71367 35.8703 5.67379 35.6201C5.79705 35.9174 5.92755 36.2074 6.06168 36.4902V36.4793ZM5.69917 36.3923C5.7463 36.6497 5.8043 36.8998 5.85142 37.1608C5.71005 36.8998 5.57954 36.6388 5.45629 36.3705C5.43454 36.2219 5.40191 36.0805 5.37654 35.9319C5.35116 35.7833 5.33304 35.6056 5.30766 35.4425C5.42729 35.7506 5.55417 36.0551 5.69192 36.3524C5.69051 36.3657 5.69051 36.379 5.69192 36.3923H5.69917ZM5.45267 37.0339C5.31129 36.762 5.18078 36.4902 5.06478 36.2147C5.0249 35.9754 4.9814 35.7325 4.94878 35.4896C4.94878 35.4026 4.92703 35.3193 4.91615 35.2323C5.03578 35.5621 5.16628 35.8884 5.30766 36.2038C5.35479 36.4829 5.40554 36.762 5.45629 37.0339H5.45267ZM5.50704 37.3348C5.55054 37.5559 5.60129 37.7771 5.64842 37.9982C5.51067 37.7734 5.38379 37.5451 5.26053 37.3167C5.21341 37.0738 5.16991 36.8237 5.12641 36.5917C5.24603 36.8454 5.37654 37.0956 5.51067 37.3493L5.50704 37.3348ZM5.71005 38.2773C5.75355 38.4658 5.7898 38.6398 5.8333 38.8392C5.69917 38.6543 5.57954 38.4767 5.47079 38.2701C5.42366 38.0598 5.38379 37.8532 5.34029 37.6429C5.46354 37.8568 5.59042 38.0707 5.72817 38.2773H5.71005ZM5.88768 39.0712C5.93118 39.2525 5.98193 39.4337 6.02906 39.6005C5.90943 39.4519 5.78255 39.3032 5.66655 39.1474C5.6158 38.9443 5.56142 38.745 5.51067 38.542C5.63392 38.7196 5.7608 38.9045 5.87317 39.0712H5.88768ZM5.98918 39.7745C6.01818 39.8144 6.05806 39.847 6.09068 39.8869C6.75172 42.4038 7.73757 44.8239 9.02338 47.0863C10.763 50.1791 13.2398 52.7942 16.2337 54.699C19.5579 56.7798 23.4839 57.8238 27.834 57.8238C28.501 57.8238 29.1825 57.7984 29.8676 57.7441L30.154 57.8564C24.6656 58.2407 19.7536 57.0988 15.7117 54.4489C10.9012 51.2914 7.44284 46.0314 5.7318 39.412C5.82242 39.528 5.9058 39.644 5.99643 39.7745H5.98918ZM30.0924 57.7441C30.4005 57.7223 30.7195 57.6861 31.0349 57.6498L31.3974 57.7586C31.0603 57.7948 30.7304 57.8274 30.3969 57.8528C30.2845 57.8093 30.1867 57.7731 30.0924 57.7332V57.7441ZM31.2814 57.6244C31.6186 57.5882 31.9629 57.5374 32.3073 57.4867C32.4632 57.5157 32.63 57.5483 32.8003 57.5737C32.4125 57.6353 32.0246 57.6861 31.6403 57.7332L31.4482 57.6824L31.2814 57.6317V57.6244ZM32.5865 57.4468C32.9743 57.3816 33.3622 57.3127 33.7574 57.2366C33.9857 57.2583 34.2178 57.2692 34.4606 57.2764C34.0039 57.3671 33.5507 57.4468 33.1049 57.5229C32.9236 57.5012 32.7423 57.4758 32.5865 57.4468ZM34.1018 57.1677C34.5476 57.077 35.0008 56.9755 35.4575 56.8595C35.7657 56.8595 36.0883 56.8595 36.4218 56.8197C35.9034 56.9538 35.3887 57.077 34.8811 57.1822C34.6129 57.1822 34.3519 57.1822 34.1054 57.1604L34.1018 57.1677ZM35.8454 56.7617C36.3131 56.6457 36.7843 56.5152 37.2592 56.3738C37.745 56.3303 38.2634 56.2759 38.8035 56.1962C38.209 56.3484 37.6121 56.5067 37.0127 56.671L36.9076 56.7C36.5451 56.729 36.1826 56.7508 35.8454 56.7617ZM35.2618 56.7617C35.0298 56.7617 34.8086 56.7617 34.5984 56.7617C35.0044 56.6674 35.414 56.5659 35.8309 56.4499L36.6393 56.4173C36.1753 56.5333 35.7185 56.6529 35.2618 56.7617ZM35.7149 56.3448H35.1277L36.2152 56.033C36.4436 56.033 36.6756 56.0076 36.9148 55.9931C36.5052 56.1164 36.1064 56.2288 35.7004 56.3375L35.7149 56.3448ZM36.1173 55.9605H35.6098C35.9506 55.859 36.2986 55.7539 36.6429 55.6379L37.2628 55.5944C36.8786 55.7213 36.4943 55.8373 36.1137 55.9569L36.1173 55.9605ZM36.9692 55.5436C37.3317 55.4204 37.6942 55.3008 38.0567 55.1811C38.3069 55.1558 38.5534 55.1231 38.7817 55.0905C38.3794 55.2391 37.9806 55.3733 37.5818 55.5038C37.3643 55.5219 37.1505 55.5436 36.9474 55.5545L36.9692 55.5436ZM38.3794 55.0434C38.7419 54.9165 39.0754 54.7896 39.427 54.6482C39.8258 54.5902 40.2318 54.525 40.6559 54.4561C40.1702 54.6084 39.6844 54.7642 39.2059 54.9382C38.9304 54.9781 38.6585 55.0144 38.3902 55.0434H38.3794ZM38.9521 54.7135C38.6186 54.844 38.2851 54.9745 37.9589 55.076L37.4368 55.134C37.7522 55.018 38.064 54.902 38.383 54.7715L38.9557 54.6954L38.9521 54.7135ZM37.6 55.2174C37.2375 55.3406 36.9076 55.4566 36.5596 55.5799L36.1463 55.6016C36.4689 55.4965 36.7988 55.3805 37.136 55.2645C37.2918 55.2645 37.4477 55.2645 37.6 55.2283V55.2174ZM36.2551 55.6705C35.8925 55.7793 35.5663 55.8771 35.2219 55.9714H34.921L35.8454 55.6886H36.2551V55.6705ZM34.573 55.9605H34.4063L35.24 55.7068H35.4829C35.1784 55.801 34.8775 55.8808 34.573 55.9678V55.9605ZM34.6419 56.0511H34.9392C34.6165 56.1418 34.2939 56.2215 33.9749 56.2977H33.8661C33.8311 56.2994 33.796 56.2994 33.761 56.2977C34.051 56.2215 34.3446 56.1454 34.6383 56.062L34.6419 56.0511ZM33.4601 56.2542H33.3477C33.616 56.1889 33.8806 56.1128 34.1489 56.0403C34.202 56.0368 34.2553 56.0368 34.3084 56.0403L33.4565 56.2578L33.4601 56.2542ZM33.0795 56.2143H33.0396C33.2934 56.1527 33.5399 56.0838 33.7972 56.0113H33.8444C33.587 56.0838 33.3332 56.1563 33.0795 56.2143ZM31.6838 56.381L31.5098 56.3484L32.1478 56.1925L32.3508 56.2215C32.1261 56.2795 31.9013 56.3303 31.6802 56.381H31.6838ZM32.0717 56.5442H32.1442C31.8796 56.5985 31.6113 56.6457 31.3539 56.6928C31.3395 56.6953 31.3248 56.6953 31.3104 56.6928L32.0717 56.5442ZM30.9588 56.5442L30.7957 56.5732L30.6289 56.5333C30.8464 56.4934 31.0603 56.4499 31.2778 56.3992C31.335 56.4139 31.3932 56.4248 31.4518 56.4318L30.9552 56.5442H30.9588ZM30.4803 56.4934L30.0453 56.381L30.6833 56.2832L31.1183 56.3738L30.4803 56.5007V56.4934ZM30.2519 56.5297C30.038 56.5659 29.8205 56.6058 29.6103 56.6312L29.1644 56.4862C29.3783 56.4862 29.5921 56.439 29.8133 56.4137L30.2519 56.5297ZM28.994 56.4282L28.5844 56.2832L29.2079 56.2397L29.6501 56.3702C29.429 56.3955 29.2115 56.4137 28.9976 56.4318L28.994 56.4282ZM28.7656 56.4499L28.1312 56.4825L27.7361 56.3122C27.9282 56.3122 28.1276 56.3122 28.3234 56.2904L28.762 56.4499H28.7656ZM27.544 56.2215L27.1815 56.0439C27.37 56.0439 27.5621 56.0439 27.7578 56.0439L28.1639 56.207L27.544 56.2215ZM27.9065 56.4898H27.2685L26.8625 56.2759C27.0727 56.2759 27.283 56.2759 27.4968 56.2759L27.9065 56.4644V56.4898ZM27.544 56.5768C27.718 56.5768 27.9065 56.5768 28.0805 56.5768L28.5264 56.7617C28.2944 56.7617 28.066 56.7798 27.8376 56.787C27.6962 56.7218 27.5585 56.6565 27.4243 56.5877L27.544 56.5768ZM28.6315 56.7979L28.7982 56.8632H28.7692C28.5481 56.8849 28.327 56.8958 28.1131 56.9067L27.95 56.8342L28.6351 56.7943L28.6315 56.7979ZM28.4285 57.1604H28.4502C28.2364 57.1604 28.0225 57.1604 27.8086 57.1786L28.4285 57.1532V57.1604ZM27.0908 57.2039C27.254 57.2039 27.4135 57.2039 27.573 57.2039H27.0908ZM18.0897 55.0579C13.4387 52.5674 9.94053 47.9346 7.83073 41.5399C7.95035 41.6305 8.06273 41.7248 8.19324 41.8118C10.4118 48.3116 13.9934 52.9408 18.6661 55.308C19.636 55.7973 20.6509 56.1919 21.6967 56.4862C20.4472 56.1365 19.24 55.6502 18.097 55.0361L18.0897 55.0579ZM10.535 43.2292C10.6365 43.28 10.7489 43.3235 10.8541 43.3742C13.6164 49.8631 17.0493 53.9848 21.2726 55.8953C16.7956 54.0247 13.2647 49.8595 10.535 43.2292ZM10.4662 43.077C10.4662 43.0262 10.4263 42.9682 10.4045 42.9174C10.5097 42.9791 10.622 43.0298 10.7344 43.0842C10.7525 43.1349 10.7779 43.1857 10.796 43.2365L10.4662 43.077ZM10.4662 43.1893C11.4563 45.6911 12.7505 48.0616 14.3196 50.2474C16.1721 52.7487 18.3072 54.5757 20.6889 55.685C16.2663 53.7347 12.7137 49.4789 10.1363 42.9972C10.245 43.0588 10.3502 43.1204 10.4662 43.1748V43.1893ZM10.071 42.8594C10.0493 42.7978 10.0203 42.7398 9.99491 42.6709L10.3284 42.8631C10.3502 42.9174 10.3755 42.9754 10.3937 43.0298C10.2849 42.9754 10.1798 42.9138 10.0674 42.8594H10.071ZM9.94053 42.5259C9.91878 42.4716 9.90065 42.4099 9.87528 42.3556L10.216 42.5658C10.2342 42.6166 10.2523 42.6673 10.274 42.7181C10.158 42.6564 10.0493 42.5912 9.94053 42.5259ZM9.89703 42.6129C9.91878 42.6782 9.94777 42.7398 9.97315 42.8051L9.64689 42.6311L9.56714 42.4244C9.67227 42.4897 9.78465 42.5477 9.8934 42.6129H9.89703ZM9.50914 42.2504C9.48739 42.1852 9.45839 42.1127 9.43664 42.0474C9.54902 42.1272 9.66502 42.2069 9.79915 42.2794L9.8644 42.4534C9.75202 42.3846 9.63602 42.3229 9.52727 42.2504H9.50914ZM9.38227 41.8879C9.35689 41.8154 9.33514 41.7465 9.30614 41.674C9.41851 41.761 9.53452 41.8444 9.66864 41.9314C9.6904 41.993 9.71577 42.0547 9.73752 42.1199L9.38227 41.8879ZM9.32426 41.964C9.34964 42.0329 9.37501 42.1018 9.39676 42.1671C9.28438 42.0909 9.16838 42.0148 9.05963 41.935L8.97625 41.7103C9.08863 41.7973 9.20826 41.8807 9.33876 41.9604L9.32426 41.964ZM8.91463 41.587C8.88562 41.5073 8.86387 41.4239 8.83487 41.3478C8.95088 41.442 9.06688 41.5363 9.19738 41.6269C9.22276 41.6994 9.24814 41.7755 9.26989 41.8444L8.90738 41.587H8.91463ZM8.7805 41.181C8.74787 41.0868 8.71887 40.9925 8.68987 40.8983C8.81312 41.007 8.9255 41.1194 9.05238 41.2245C9.07776 41.3043 9.10676 41.384 9.13213 41.4638L8.76962 41.1774L8.7805 41.181ZM8.71162 41.2499C8.737 41.3297 8.766 41.4167 8.79137 41.5L8.42886 41.2173C8.39986 41.1267 8.37449 41.0324 8.34549 40.9454C8.46149 41.0469 8.57749 41.1484 8.708 41.2499H8.71162ZM8.30561 40.7678C8.27299 40.6663 8.24398 40.5648 8.21136 40.4633L8.57387 40.7859C8.60287 40.8874 8.63912 40.9853 8.67174 41.0831C8.53762 40.9816 8.42524 40.862 8.30561 40.7678ZM8.16061 40.2965C8.12435 40.1805 8.08448 40.0645 8.05186 39.934C8.16424 40.0609 8.28749 40.1805 8.41437 40.2965C8.45062 40.4089 8.48687 40.514 8.51949 40.6264C8.39261 40.5249 8.27298 40.4125 8.16061 40.2965ZM7.9721 39.6839C7.93948 39.5824 7.91773 39.47 7.8851 39.3649C8.01198 39.5207 8.13161 39.6802 8.24761 39.8289C8.27661 39.9195 8.29836 40.0137 8.32736 40.1044C8.19686 39.9666 8.07723 39.8216 7.96485 39.6802L7.9721 39.6839ZM7.83073 39.1582L7.73285 38.7957C7.8561 38.9734 7.98298 39.1582 8.11711 39.3177C8.14248 39.4192 8.17511 39.5207 8.20411 39.6259C8.07361 39.47 7.95035 39.3141 7.8416 39.1618L7.83073 39.1582ZM7.67847 38.5855C7.6386 38.4296 7.59509 38.281 7.55522 38.1287C7.68934 38.3426 7.81622 38.5565 7.9576 38.7595C7.9866 38.8791 8.02285 38.9915 8.05548 39.1039C7.92498 38.9371 7.7981 38.7667 7.69297 38.5891L7.67847 38.5855ZM7.47909 37.8314C7.45009 37.6973 7.41384 37.5559 7.38121 37.4037C7.50809 37.6357 7.64222 37.8604 7.77635 38.0852C7.80535 38.2012 7.83435 38.3172 7.86335 38.4223C7.73285 38.2266 7.60235 38.0345 7.47909 37.8314ZM7.31596 37.1064C7.27609 36.9179 7.23258 36.7149 7.18908 36.501C7.31596 36.7765 7.45009 37.0484 7.58785 37.3094C7.62772 37.4834 7.66397 37.6502 7.70385 37.8061C7.57334 37.5777 7.43922 37.3457 7.31596 37.1064ZM7.01508 36.1132C7.05858 36.3488 7.10208 36.5627 7.14558 36.7765C7.01508 36.501 6.88457 36.2255 6.76132 35.9428C6.71782 35.6926 6.67432 35.4244 6.63082 35.1416C6.75045 35.4715 6.87733 35.7978 7.0187 36.1132H7.01508ZM6.65257 35.8449C6.69245 36.0588 6.7287 36.269 6.76857 36.4648C6.63444 36.1857 6.50757 35.9065 6.40606 35.6165C6.36619 35.3845 6.33356 35.1416 6.29369 34.8915C6.40606 35.2178 6.53657 35.5368 6.6562 35.8521L6.65257 35.8449ZM6.42419 36.414C6.27919 36.1095 6.14868 35.7941 6.0218 35.4824C5.97105 35.1585 5.92393 34.8359 5.88043 34.5145C5.98555 34.8371 6.09793 35.1561 6.21756 35.4643L6.27556 35.5948C6.31906 35.8703 6.36981 36.1422 6.42419 36.414ZM5.8913 35.3265C5.93118 35.5984 5.9783 35.8775 6.02906 36.153C5.8913 35.8413 5.7608 35.5223 5.63392 35.196C5.5868 34.877 5.54692 34.5544 5.50704 34.2354C5.62304 34.5979 5.75355 34.9604 5.8913 35.3229V35.3265ZM5.62667 35.9138C5.48892 35.5948 5.36204 35.2721 5.26416 34.9386C5.22066 34.6124 5.18078 34.2789 5.14453 33.949C5.25691 34.3369 5.38016 34.7139 5.50704 35.0872C5.54692 35.3628 5.59042 35.6383 5.63755 35.9101L5.62667 35.9138ZM5.26416 35.8739C5.12278 35.5331 4.9959 35.1924 4.90165 34.848C4.8509 34.442 4.80377 34.0287 4.76752 33.6155C4.87627 34.0432 5.00315 34.4637 5.13003 34.8734C5.17353 35.2069 5.22066 35.5404 5.27141 35.8739H5.26416ZM4.92703 36.0914C4.97053 36.3597 5.01041 36.6279 5.06116 36.8962C4.91978 36.6098 4.78928 36.3198 4.66965 36.0298C4.6189 35.7035 4.56814 35.3736 4.52464 35.0437C4.5266 35.0317 4.5266 35.0195 4.52464 35.0075C4.64789 35.37 4.78202 35.7325 4.93428 36.095L4.92703 36.0914ZM5.12278 37.2369C5.16991 37.4798 5.22066 37.7154 5.27141 37.9619C5.13003 37.7263 4.99953 37.4834 4.87627 37.2369C4.82552 36.965 4.77115 36.6968 4.72765 36.4213C4.8219 36.6968 4.9524 36.9723 5.09741 37.2369H5.12278ZM5.32579 38.223C5.36929 38.426 5.41642 38.629 5.46354 38.832C5.32941 38.6435 5.19891 38.4695 5.07928 38.2556C5.02853 38.0236 4.98503 37.7952 4.9379 37.5559C5.06115 37.7807 5.18803 38.0054 5.32579 38.223ZM5.54692 39.151C7.23621 45.9371 10.7453 51.3349 15.6537 54.5576C19.2135 56.8922 23.4367 58.0667 28.1312 58.0667C28.8998 58.0667 29.6864 58.0304 30.4839 57.9688C30.5999 58.0123 30.7123 58.0558 30.8464 58.0957C24.8614 58.5742 19.4999 57.3018 15.1389 54.3039C10.2015 50.9071 6.73232 45.4006 5.16266 38.5818C5.28591 38.774 5.41279 38.9625 5.55054 39.1474L5.54692 39.151ZM30.7123 57.9507C31.0748 57.9181 31.4047 57.8818 31.7563 57.8383C31.9231 57.8818 32.1188 57.9181 32.2965 57.9507C31.8941 58.0014 31.4953 58.0377 31.0966 58.0739L30.8645 58.0014L30.7123 57.9434V57.9507ZM32.0427 57.8021C32.4523 57.7513 32.8656 57.6897 33.2825 57.6208C33.5387 57.645 33.8069 57.6631 34.0873 57.6752C33.5979 57.7586 33.1121 57.8383 32.6372 57.9036C32.4306 57.8746 32.2348 57.8383 32.05 57.8021H32.0427ZM33.6631 57.5556C34.138 57.4722 34.6129 57.3707 35.1132 57.2692C35.4757 57.2692 35.8635 57.2692 36.2587 57.2293C35.6859 57.3671 35.1168 57.4903 34.5549 57.5918C34.2468 57.5918 33.9568 57.5918 33.6812 57.5519L33.6631 57.5556ZM37.7558 56.6022C38.5171 56.3955 39.2748 56.1998 40.0179 56.0113L40.4094 55.9134C41.7421 55.6469 43.055 55.2896 44.339 54.844C45.093 54.6156 45.8362 54.3764 46.5684 54.119C43.7783 55.4037 40.8052 56.2463 37.7558 56.6167V56.6022ZM37.6362 56.1237C37.484 56.1744 37.3353 56.2107 37.1831 56.2542C36.8677 56.2832 36.5704 56.3013 36.2841 56.3158C36.6828 56.2034 37.0852 56.0874 37.484 55.9533C37.8718 55.917 38.2742 55.8699 38.6839 55.8191C38.3214 55.917 37.9842 56.0149 37.6362 56.1237ZM37.3245 55.8808C37.0743 55.9025 36.8278 55.9206 36.5994 55.9315C36.9837 55.8155 37.3752 55.6886 37.7631 55.569C38.0495 55.5436 38.3467 55.511 38.6585 55.4711L38.2416 55.6053C37.9371 55.7068 37.6362 55.7974 37.3317 55.8916L37.3245 55.8808ZM38.1147 55.4349C38.3649 55.3479 38.615 55.2645 38.8687 55.1703L39.3581 54.9999C39.9817 54.9165 40.5943 54.8114 41.1997 54.699C40.5073 54.8911 39.8149 55.0941 39.1153 55.3116C38.7624 55.3575 38.4289 55.3974 38.1147 55.4313V55.4349ZM42.744 54.3945C44.3499 53.9595 45.9341 53.5281 47.4566 52.9879C45.0446 54.0444 42.5068 54.7864 39.9055 55.1956C40.8553 54.9092 41.8051 54.6482 42.7367 54.3945H42.744ZM43.44 54.0827C42.246 54.3998 41.0359 54.6527 39.8149 54.8404C40.4336 54.6301 41.0511 54.4368 41.6673 54.2604C43.5721 53.8933 45.4404 53.3571 47.25 52.6581C47.6741 52.5203 48.0946 52.3753 48.5151 52.2267C47.0195 52.9366 45.4659 53.5176 43.8714 53.9631L43.4327 54.0863L43.44 54.0827ZM42.8745 53.9196L43.817 53.6622C44.4115 53.4955 45.0097 53.3323 45.6005 53.1619C44.6725 53.4628 43.7554 53.7166 42.8745 53.9196ZM47.5146 52.4623C46.3002 52.8611 45.035 53.2091 43.7626 53.5498C42.9542 53.7746 42.1277 54.003 41.3012 54.2459C40.7828 54.3437 40.2825 54.4271 39.804 54.5032C40.2535 54.3292 40.703 54.1733 41.1525 54.0175C43.8756 53.5691 46.5294 52.7711 49.048 51.643C49.338 51.5379 49.628 51.4292 49.9144 51.3095C49.1353 51.7304 48.3342 52.1091 47.5146 52.4442V52.4623ZM41.7434 53.8435C42.7512 53.5281 43.7517 53.2453 44.7341 52.9771C45.876 52.6617 47.0034 52.3499 48.1091 51.9838C46.0551 52.8188 43.9208 53.4407 41.7398 53.8398L41.7434 53.8435ZM40.8589 53.6731L40.1593 53.7963L40.6414 53.5752L41.0366 53.4012L42.3525 53.1438C41.8558 53.307 41.3556 53.4846 40.8589 53.6767V53.6731ZM40.4964 53.8145L39.9961 54.0211L39.5104 54.2205L39.0174 54.2966L39.8765 53.9341L40.4964 53.8145ZM39.2023 54.351L38.2887 54.7135L37.8646 54.7642C38.1546 54.6519 38.4446 54.5322 38.7346 54.4017L39.2023 54.3365V54.351ZM37.9625 54.8331C37.6507 54.9491 37.3462 55.0687 37.0381 55.1739L36.6756 55.1993C36.9619 55.0978 37.252 54.989 37.542 54.8766L37.948 54.8331H37.9625ZM36.7589 55.2718L35.7765 55.5944H35.5192C35.82 55.4965 36.1173 55.395 36.4182 55.2863L36.7589 55.2718ZM35.1857 55.6053H35.0624L35.8527 55.3334C35.9215 55.3334 35.9868 55.3334 36.0557 55.3334C35.7548 55.4349 35.4648 55.5255 35.1712 55.6161L35.1857 55.6053ZM34.8231 55.6053L35.4938 55.3696H35.5337L34.8086 55.6053H34.8231ZM34.8811 55.7031H34.9029C34.6383 55.7865 34.37 55.8626 34.1054 55.9388H34.0401C34.2903 55.8626 34.5476 55.7901 34.8014 55.7068H34.8811V55.7031ZM33.5399 55.8916H33.4964L33.2426 55.8735L33.8516 55.6814H34.1308C33.9314 55.743 33.7356 55.8155 33.5399 55.8735V55.8916ZM33.2462 55.975L32.5792 56.1599L32.3798 56.1345C32.5865 56.0802 32.7931 56.0221 33.007 55.9569H33.2499L33.2462 55.975ZM32.2095 56.1128L31.7781 56.0511L32.3726 55.9025L32.8185 55.9424C32.6155 56.0004 32.4088 56.062 32.2095 56.1128ZM31.992 56.1708C31.7744 56.2252 31.5606 56.2687 31.3467 56.3158C31.2017 56.2868 31.0531 56.2614 30.9117 56.2288L31.5388 56.1091L31.9956 56.1708H31.992ZM30.7377 56.1925C30.5963 56.1671 30.4585 56.1345 30.3244 56.1019C30.5202 56.0765 30.7159 56.0439 30.9117 56.0076C31.0458 56.033 31.1836 56.0512 31.3177 56.0729C31.1256 56.1128 30.9298 56.1599 30.7377 56.1925ZM30.4803 56.2324C30.2737 56.2687 30.0707 56.3013 29.8676 56.3267L29.4508 56.2107C29.6429 56.1889 29.835 56.178 30.0308 56.149H30.0779C30.212 56.1817 30.3425 56.2143 30.4803 56.2397V56.2324ZM29.2659 56.149L28.8816 56.033L29.4653 55.9931L29.8278 56.0874C29.6356 56.1128 29.4435 56.1382 29.2586 56.1563L29.2659 56.149ZM29.0158 56.1708C28.8055 56.1708 28.5952 56.1925 28.3886 56.1998C28.2617 56.1563 28.1421 56.1091 28.0261 56.0584C28.2255 56.0584 28.4249 56.0584 28.6315 56.0584L29.0194 56.1853L29.0158 56.1708ZM27.834 55.9859L27.4062 55.8046C27.5947 55.8046 27.7905 55.8046 27.9826 55.8228C28.1747 55.8409 28.269 55.9279 28.4249 55.9786H27.834V55.9859ZM27.5657 55.9859C27.3808 55.9859 27.2032 55.9859 27.0147 55.9859C26.8624 55.9134 26.7211 55.8373 26.5797 55.7648L27.1271 55.8155L27.5621 56.0076L27.5657 55.9859ZM26.7537 55.9424C26.5543 55.9424 26.3549 55.9061 26.1556 55.8808C26.0142 55.7938 25.8837 55.7068 25.7532 55.6198C25.9417 55.656 26.1338 55.6814 26.3296 55.7104L26.7537 55.9388V55.9424ZM26.9096 56.0222L27.3047 56.2179C27.0981 56.2179 26.8951 56.2179 26.6921 56.1889C26.5579 56.1164 26.4311 56.0403 26.3078 55.9641C26.5036 55.9895 26.7066 56.004 26.906 56.0222H26.9096ZM27.051 56.4934C25.8654 56.4677 24.6888 56.2824 23.5527 55.9424C18.5827 54.4271 15.0845 50.019 11.6987 43.744C11.7857 43.7802 11.88 43.8128 11.9706 43.8418C14.9939 48.9423 17.8759 52.9263 21.7583 54.9237C23.2724 55.6929 24.9255 56.1502 26.6196 56.2687C26.7537 56.3412 26.8878 56.4173 27.0292 56.4898L27.051 56.4934ZM11.6298 43.6243C11.6044 43.5845 11.5863 43.541 11.5609 43.5011L11.8219 43.6062C11.8437 43.6461 11.8691 43.686 11.8908 43.7295L11.6262 43.628L11.6298 43.6243ZM11.6298 43.7295C15.0338 50.0516 18.5501 54.496 23.5564 56.0222C24.7453 56.3767 25.9772 56.5669 27.2177 56.5877L27.6382 56.8015C26.1005 56.836 24.5675 56.6192 23.0996 56.1599C18.4994 54.7099 14.7981 50.7694 11.3217 43.5845L11.6298 43.7295ZM11.2673 43.4576C11.2492 43.4141 11.2238 43.367 11.2057 43.3235L11.4848 43.4612C11.4848 43.5011 11.5247 43.5446 11.5464 43.5845L11.2673 43.4612V43.4576ZM11.2492 43.5627C14.7438 50.8129 18.4667 54.757 23.0996 56.2324C24.4768 56.6635 25.9124 56.8787 27.3555 56.8704C27.4896 56.8704 27.6237 56.8704 27.7615 56.8704L27.9355 56.9538C27.8122 56.9538 27.6926 56.9755 27.573 56.9755C27.1815 56.9755 26.7899 56.9755 26.4093 56.9755C26.3562 56.9792 26.3029 56.9792 26.2498 56.9755C25.9562 56.9755 25.6698 56.9465 25.3762 56.9212C25.184 56.9212 24.9919 56.8885 24.8034 56.8632C24.6874 56.8632 24.5678 56.8305 24.4409 56.816C24.2161 56.7834 23.9986 56.7399 23.7811 56.6964C23.647 56.671 23.5129 56.6384 23.3787 56.6058C23.1286 56.5405 22.8785 56.4753 22.6283 56.3919C17.8178 54.7932 13.9825 50.5374 10.9447 43.4322L11.2492 43.57V43.5627ZM10.8867 43.2945C10.8649 43.2437 10.8468 43.1893 10.8214 43.1422L11.1078 43.28C11.1296 43.3271 11.1477 43.3742 11.1731 43.4177L10.8831 43.2945H10.8867ZM10.7707 43.0081C10.7489 42.9646 10.7344 42.9174 10.7127 42.8739C10.8033 42.9174 10.8903 42.9718 10.9809 43.0189L11.0389 43.1386L10.7707 43.0081ZM10.6547 42.7326L10.5967 42.5948C10.6837 42.6456 10.7634 42.6963 10.8504 42.7434L10.9157 42.8812C10.825 42.8304 10.7417 42.7797 10.651 42.7326H10.6547ZM10.6293 42.8304C10.651 42.8739 10.6692 42.9247 10.6909 42.9718L10.361 42.7942C10.3393 42.7434 10.3212 42.6927 10.303 42.6456L10.6293 42.8304ZM10.245 42.5006C10.2277 42.445 10.2071 42.3906 10.1834 42.3374C10.2885 42.4063 10.4045 42.4716 10.5133 42.5368C10.535 42.5839 10.5532 42.6383 10.5713 42.6854L10.245 42.4933V42.5006ZM10.1254 42.1888C10.1 42.1308 10.0819 42.0728 10.0565 42.0148C10.1653 42.0909 10.2777 42.1562 10.3828 42.2323C10.4082 42.2867 10.4263 42.3374 10.4517 42.3954C10.3393 42.3302 10.2305 42.2577 10.1218 42.1924L10.1254 42.1888ZM10.0892 42.2794C10.1073 42.3338 10.1327 42.3882 10.1508 42.4426L9.81727 42.2396L9.7484 42.051L10.0855 42.2794H10.0892ZM9.69765 41.9169C9.66864 41.8444 9.64689 41.7755 9.61789 41.6994C9.73752 41.79 9.84627 41.8807 9.9804 41.9677C10.0022 42.0257 10.0203 42.0801 10.0457 42.1417L9.69765 41.9169ZM9.57077 41.5544C9.54539 41.4783 9.51639 41.4058 9.48739 41.3297C9.60702 41.4275 9.7194 41.5327 9.8499 41.6269C9.87165 41.6849 9.89703 41.7429 9.91515 41.8045L9.57802 41.5544H9.57077ZM9.51277 41.6015C9.53814 41.6777 9.56714 41.7502 9.59614 41.8263C9.47652 41.7429 9.36051 41.6595 9.23363 41.5725C9.20826 41.4928 9.17926 41.413 9.15388 41.3369C9.28439 41.4094 9.40039 41.4928 9.52001 41.587L9.51277 41.6015ZM9.11763 41.1883C9.09225 41.1085 9.05963 41.0252 9.03425 40.9381C9.14301 41.0396 9.26626 41.1339 9.37864 41.2318C9.40764 41.3152 9.43664 41.3913 9.46564 41.4674C9.34601 41.3804 9.23363 41.2862 9.10313 41.1883H9.11763ZM8.95813 40.7206C8.93638 40.6518 8.911 40.5793 8.88925 40.5068C9.00525 40.6228 9.12488 40.7388 9.25176 40.8693C9.27714 40.9345 9.29526 41.0034 9.32064 41.0686C9.19739 40.9599 9.07776 40.8511 8.95813 40.7388V40.7206ZM8.911 40.833C8.94 40.92 8.969 41.007 9.00163 41.094L8.63912 40.7823C8.60649 40.6735 8.57024 40.572 8.53762 40.4669C8.66087 40.5865 8.77687 40.7134 8.90013 40.8294L8.911 40.833ZM8.47962 40.2566C8.45061 40.1696 8.42524 40.079 8.39986 39.9884C8.51949 40.1225 8.64274 40.2458 8.76237 40.3763C8.78775 40.4524 8.8095 40.5285 8.83487 40.6046C8.71524 40.4923 8.58837 40.3763 8.47236 40.2421L8.47962 40.2566ZM8.35274 39.7745C8.32011 39.6766 8.29474 39.5715 8.26574 39.47C8.38899 39.6259 8.51224 39.7781 8.62825 39.9231L8.70075 40.1588C8.57749 40.0319 8.45424 39.9086 8.33824 39.7745H8.35274ZM8.21136 39.2851C8.17511 39.1691 8.14248 39.0495 8.10985 38.9226C8.23311 39.0966 8.35999 39.2597 8.47236 39.4265C8.50136 39.5171 8.53037 39.615 8.55937 39.7092C8.43611 39.5679 8.30924 39.4265 8.19686 39.2815L8.21136 39.2851ZM8.02648 38.6362L8.00473 38.5565C7.98298 38.4876 7.96848 38.4187 7.95036 38.3426C8.06998 38.5347 8.20411 38.7051 8.33461 38.8972C8.33461 38.9371 8.35636 38.9806 8.36724 39.0132L8.41799 39.1655C8.28749 38.9915 8.15698 38.803 8.03373 38.6362H8.02648ZM7.87423 38.0634C7.83798 37.9221 7.80172 37.7734 7.76547 37.6103C7.89235 37.8459 8.02648 38.0779 8.16423 38.3063C8.20049 38.4332 8.22949 38.5601 8.26574 38.6688C8.13161 38.4695 8.00473 38.2628 7.87423 38.0598V38.0634ZM7.69297 37.3167C7.65672 37.1717 7.62772 37.0158 7.59147 36.8599C7.7256 37.1391 7.85973 37.4109 8.00111 37.6792C8.03011 37.8061 8.06273 37.9329 8.09536 38.0417C7.9576 37.7988 7.8271 37.5523 7.69297 37.3167ZM7.51172 36.4865C7.48272 36.3307 7.44646 36.1639 7.41384 35.9972C7.54797 36.327 7.68572 36.6569 7.83073 36.9759C7.85973 37.0883 7.8851 37.1971 7.91048 37.3094C7.77273 37.0375 7.63497 36.762 7.50809 36.4829L7.51172 36.4865ZM7.34859 35.6673C7.30509 35.4389 7.26159 35.1924 7.21809 34.9422C7.34376 35.3265 7.48151 35.7035 7.63135 36.0733C7.6676 36.2582 7.70747 36.4358 7.74735 36.617C7.60959 36.3053 7.47184 35.9899 7.35221 35.6673H7.34859ZM7.00421 34.268C7.05496 34.558 7.09846 34.8371 7.14558 35.109C7.00783 34.7151 6.88699 34.3127 6.78308 33.9018C6.73595 33.5393 6.69607 33.2058 6.65257 32.8397C6.76132 33.3255 6.8882 33.804 7.01508 34.268H7.00421ZM6.83383 35.0619C6.87733 35.3084 6.92083 35.5513 6.96433 35.7869C6.82658 35.4498 6.6997 35.1054 6.57644 34.7574C6.53294 34.4746 6.49669 34.1774 6.45681 33.8692C6.57282 34.2716 6.69607 34.674 6.81932 35.0691L6.83383 35.0619ZM6.47132 34.6522C6.51482 34.9531 6.56194 35.2395 6.60907 35.515C6.47131 35.1779 6.34806 34.8262 6.24656 34.4746C6.20306 34.1483 6.15956 33.804 6.11968 33.4415C6.23206 33.8547 6.35169 34.2535 6.48219 34.6522H6.47132ZM6.21393 35.1344C6.07256 34.7719 5.94568 34.3731 5.82605 33.978C5.77893 33.6155 5.73905 33.224 5.70642 32.8433C5.81518 33.3182 5.94568 33.7822 6.06893 34.239L6.19944 35.1344H6.21393ZM5.69917 33.8982C5.74267 34.2607 5.79705 34.6232 5.8478 34.9857C5.69917 34.5906 5.57229 34.1846 5.45629 33.7713C5.40554 33.3146 5.36567 32.8578 5.33304 32.4011C5.43817 32.9086 5.5578 33.4016 5.69555 33.8873L5.69917 33.8982ZM5.44542 34.6704C5.30404 34.2499 5.17716 33.8185 5.08291 33.3835C5.03941 32.9194 5.01041 32.4554 4.98141 31.9878C5.07566 32.5207 5.19166 33.0463 5.34391 33.5575C5.38379 33.92 5.42729 34.3042 5.47442 34.6704H5.44542ZM4.93428 31.2809C4.9089 30.5559 4.90165 29.8019 4.91253 29.0551C4.95074 29.8406 5.03061 30.6235 5.15178 31.4005C5.17716 31.966 5.21703 32.5279 5.26779 33.0862C5.11916 32.5026 5.01403 31.8972 4.92703 31.2809H4.93428ZM4.93428 33.1732C4.97053 33.5828 5.01403 33.9925 5.06116 34.3949C4.91615 33.9308 4.7929 33.456 4.69865 32.9702C4.65877 32.4627 4.62977 31.9588 4.61164 31.4477C4.6769 32.0385 4.78927 32.6113 4.9234 33.1732H4.93428ZM4.7204 34.6232C4.75302 34.9169 4.78565 35.2069 4.82915 35.4969C4.82915 35.5513 4.84727 35.6093 4.85452 35.6673C4.70952 35.3048 4.57902 34.9096 4.46664 34.529C4.41589 34.0831 4.37239 33.6336 4.34339 33.1877C4.45214 33.6771 4.57177 34.1592 4.70589 34.6377L4.7204 34.6232ZM4.50652 35.8811C4.55002 36.1784 4.59352 36.472 4.64427 36.7657C4.50289 36.4575 4.36876 36.1422 4.24914 35.8231C4.19113 35.4606 4.13676 35.0691 4.09326 34.6849C4.2141 35.086 4.35185 35.4848 4.50652 35.8811ZM4.71315 37.1354C4.7639 37.3856 4.80377 37.6321 4.85452 37.8604C4.7204 37.6176 4.58627 37.3711 4.46301 37.1137C4.40864 36.8128 4.35064 36.5119 4.30351 36.2074C4.42676 36.5155 4.56452 36.8237 4.71315 37.1209V37.1354ZM4.93065 38.223C6.46769 45.2556 10.0058 50.9325 15.0555 54.409C18.8474 57.0154 23.3932 58.335 28.4212 58.335C29.3299 58.335 30.2567 58.2915 31.2017 58.2045C31.3829 58.2588 31.5642 58.2987 31.7781 58.3386C25.184 58.9875 19.286 57.5737 14.5371 54.1588C9.42214 50.4758 5.92755 44.6321 4.53189 37.5052C4.65515 37.7517 4.78565 37.9909 4.92703 38.2302L4.93065 38.223ZM31.4881 58.1609C31.9231 58.1175 32.3581 58.0631 32.7967 57.9978C33.0831 58.0341 33.384 58.0594 33.7102 58.0739C33.1774 58.1573 32.6553 58.2262 32.1333 58.2842C31.9049 58.248 31.6947 58.2045 31.4917 58.1573L31.4881 58.1609ZM33.1846 57.9434C33.7066 57.8637 34.2395 57.7694 34.7688 57.6643C35.2183 57.6643 35.6932 57.6462 36.1862 57.6099L35.8237 57.6861C35.2799 57.8021 34.7361 57.9036 34.2033 57.9942C33.8408 57.9942 33.4964 57.9724 33.1701 57.9398L33.1846 57.9434ZM46.4669 54.3619C45.6767 54.6664 44.8683 54.9419 44.049 55.1956C45.2266 54.7859 46.3768 54.3016 47.4928 53.7456C47.8155 53.6151 48.1381 53.4773 48.4571 53.336C47.801 53.6985 47.134 54.061 46.4669 54.3764V54.3619ZM47.917 53.4085C47.4566 53.6006 46.989 53.771 46.5177 53.9558C47.2681 53.626 48.0293 53.2562 48.7761 52.8393L48.8377 52.8248C49.0553 52.7269 49.2764 52.6291 49.4975 52.5239C48.9719 52.8538 48.4354 53.1583 47.8988 53.4411L47.917 53.4085ZM49.1386 52.5276C48.8124 52.6762 48.4825 52.8176 48.1526 52.9517C48.4317 52.8139 48.7109 52.6689 48.9864 52.5203C49.3199 52.3391 49.6425 52.1578 49.9579 51.9548C50.1428 51.8678 50.3204 51.7808 50.5053 51.6865C50.0522 51.9838 49.599 52.2629 49.1386 52.5276ZM48.9429 52.4406C48.3266 52.7813 47.7031 53.0822 47.0723 53.365C45.2598 54.0211 43.3784 54.5214 41.4571 55.0325C40.7321 55.2246 40.007 55.424 39.253 55.6306C38.7817 55.6995 38.3286 55.7539 37.8863 55.801L38.2489 55.685C38.5932 55.569 38.9412 55.4603 39.2856 55.3515C42.3943 54.9246 45.4183 54.0197 48.2505 52.6689C48.5586 52.5529 48.8667 52.4297 49.1676 52.3064C49.0843 52.3499 49.0118 52.4007 48.9284 52.4442L48.9429 52.4406ZM48.7399 52.3536C48.1055 52.6109 47.4602 52.8429 46.8113 53.0604C47.6914 52.7166 48.5519 52.3245 49.3888 51.8859C49.4576 51.8533 49.5156 51.817 49.5809 51.7808C49.86 51.6684 50.1355 51.5452 50.4074 51.4183C49.8564 51.759 49.2981 52.0708 48.7435 52.3536H48.7399ZM49.5229 51.6829C49.2691 51.788 49.0081 51.8895 48.7507 51.991C49.0408 51.8533 49.3308 51.7119 49.6171 51.5597C50.0086 51.3567 50.3929 51.1464 50.7699 50.9216L51.0019 50.8129C50.5125 51.1246 50.0232 51.411 49.5229 51.6793V51.6829ZM50.7844 50.802C50.5814 50.8963 50.3712 50.9905 50.1609 51.0775C50.7047 50.7923 51.2436 50.477 51.7777 50.1314L52.0061 50.0117C51.6001 50.2909 51.194 50.5555 50.7808 50.7984L50.7844 50.802ZM49.2836 51.4255C48.6746 51.6527 48.0584 51.863 47.4348 52.0563C48.4896 51.6773 49.5168 51.2255 50.5089 50.7041C50.7155 50.6171 50.9258 50.5301 51.1288 50.4359C50.5198 50.7984 49.9047 51.1283 49.2836 51.4255ZM50.4908 50.6063C50.1537 50.744 49.8165 50.8745 49.4721 50.9941C50.2458 50.6574 50.9987 50.2749 51.7269 49.8486C51.8248 49.8015 51.9263 49.758 52.0242 49.7072C51.5239 50.0335 51.0092 50.3271 50.4944 50.6026L50.4908 50.6063ZM48.2541 51.4038C47.3732 51.6793 46.4742 51.9258 45.5679 52.1759C44.7523 52.3971 43.9185 52.6254 43.0847 52.9009C42.4902 53.0278 41.9066 53.1438 41.3592 53.2635C41.7906 53.0858 42.2292 52.9191 42.6642 52.7668C45.1717 52.3031 47.6228 51.574 49.976 50.5918C50.2805 50.483 50.5887 50.367 50.8932 50.2293C50.0403 50.6811 49.1601 51.0795 48.2577 51.4219L48.2541 51.4038ZM43.266 52.5239C44.3028 52.1868 45.3432 51.904 46.3654 51.6249C47.2753 51.3748 48.178 51.1319 49.0698 50.8528C47.1858 51.569 45.2458 52.128 43.2696 52.5239H43.266ZM42.5228 52.6834L41.9029 52.8103L41.4752 52.9009C41.7894 52.7487 42.1047 52.6073 42.4213 52.4768L43.0485 52.3391C43.7735 52.1832 44.4985 52.0164 45.2707 51.8315C44.3608 52.0853 43.44 52.3608 42.5228 52.6834ZM41.9211 52.8828L42.0371 52.8574C41.6794 52.9952 41.3169 53.1438 40.9495 53.3033L40.6885 53.3541L40.4312 53.4012C40.6849 53.2816 40.9351 53.1583 41.1852 53.0387L41.9102 52.8901L41.9211 52.8828ZM40.6559 53.4411H40.616C40.3405 53.5716 40.0723 53.684 39.7968 53.8036C39.6663 53.829 39.5321 53.8471 39.4016 53.8688L40.1774 53.5063L40.6559 53.4157V53.4411ZM39.05 53.9921C38.9703 53.9921 38.8905 54.0211 38.8144 54.0284C39.0464 53.9232 39.2784 53.8145 39.514 53.6985L39.8294 53.6368C39.5684 53.7601 39.311 53.8725 39.0536 53.9993L39.05 53.9921ZM39.1225 54.0573L39.4089 54.0102H39.5104C39.224 54.1371 38.9449 54.2567 38.6621 54.3727L38.3359 54.4162L39.1189 54.0755L39.1225 54.0573ZM38.3576 54.4779C38.0785 54.5939 37.7993 54.7099 37.5238 54.815L37.252 54.8476C37.513 54.7461 37.7812 54.6374 38.0422 54.525C38.1474 54.525 38.2525 54.4996 38.3576 54.4815V54.4779ZM36.9511 54.9564L37.2085 54.931L36.3529 55.2428H36.1681C36.4291 55.1485 36.6937 55.0506 36.9547 54.9455L36.9511 54.9564ZM35.8382 55.2718H35.7874L36.5124 54.9999H36.6321C36.3674 55.1014 36.1028 55.1884 35.8345 55.2826L35.8382 55.2718ZM35.2799 55.3008H34.9645L35.559 55.076L35.8889 55.047L35.2799 55.2863V55.3008ZM35.0117 55.3986C34.8086 55.4711 34.6093 55.5509 34.4063 55.6161H34.1163C34.3156 55.5509 34.5114 55.4856 34.718 55.4095H35.0153L35.0117 55.3986ZM33.9241 55.6161C33.7791 55.6161 33.6414 55.6161 33.5 55.6161C33.6957 55.5581 33.8879 55.5074 34.0836 55.4385H34.5259C34.3229 55.511 34.1235 55.5726 33.9277 55.6343L33.9241 55.6161ZM33.6849 55.6923C33.4891 55.7575 33.2897 55.8228 33.0976 55.8771L32.6626 55.8409L33.2354 55.6814H33.6849V55.6923ZM32.4378 55.8264L32.0753 55.7901C32.2602 55.7503 32.4378 55.7068 32.6372 55.656C32.7713 55.656 32.9018 55.656 33.0396 55.6741C32.8438 55.7285 32.6517 55.7756 32.456 55.8228L32.4378 55.8264ZM32.1877 55.8916C31.9883 55.946 31.7926 55.9859 31.5932 56.0294L31.2089 55.9714L31.7926 55.8518C31.9194 55.8699 32.0536 55.8808 32.1877 55.8916ZM30.9588 55.9315L30.5963 55.8699L31.1546 55.7793C31.2814 55.7793 31.4047 55.8119 31.5171 55.8228C31.3213 55.8626 31.1256 55.8916 30.9334 55.9279L30.9588 55.9315ZM30.7014 55.9786L30.1323 56.0657L29.7698 55.9786C29.9546 55.9786 30.1323 55.9424 30.3353 55.9134C30.4622 55.9351 30.589 55.9605 30.7195 55.9786H30.7014ZM29.5559 55.9243C29.4145 55.888 29.2731 55.8554 29.1354 55.8155C29.3094 55.8155 29.4979 55.7938 29.661 55.7793L30.1069 55.8699C29.9075 55.8916 29.7263 55.9098 29.5414 55.9243H29.5559ZM29.2913 55.9533C29.0955 55.9533 28.907 55.9714 28.7149 55.9786L28.3016 55.8373H28.8454L29.2913 55.9605V55.9533ZM28.095 55.7684L27.6962 55.6198H28.1856L28.6134 55.7503H28.095V55.7684ZM27.805 55.7684C27.6201 55.7684 27.4425 55.7684 27.2576 55.743C27.0727 55.7176 26.9785 55.6161 26.8479 55.5509C27.0256 55.5726 27.2105 55.5871 27.3917 55.6016C27.573 55.6161 27.6636 55.714 27.8086 55.7648L27.805 55.7684ZM26.9676 55.7213C26.7972 55.7031 26.6304 55.6959 26.4637 55.6741L26.0649 55.4421L26.5616 55.5219L26.9676 55.7176V55.7213ZM26.1846 55.6306C26.0069 55.6016 25.8221 55.5799 25.6444 55.5436C25.4668 55.5074 25.387 55.366 25.2819 55.279C25.4523 55.3225 25.6444 55.3588 25.8003 55.395L26.1954 55.6306H26.1846ZM25.1224 55.1703C25.0028 55.0796 24.894 54.989 24.7853 54.902C24.9411 54.9491 25.097 54.9962 25.2602 55.0397C25.4233 55.0832 25.4958 55.1993 25.6227 55.279C25.4595 55.2464 25.2892 55.2101 25.1297 55.1703H25.1224ZM25.4305 55.5001C24.6122 55.3287 23.814 55.0724 23.0489 54.7352C19.0613 52.9517 16.3098 49.0692 12.8225 44.1572L13.0364 44.2189C13.3989 44.6901 13.7614 45.1578 14.1239 45.6181C17.3538 49.8559 19.924 53.2018 23.6144 54.7389C24.0869 54.9315 24.5712 55.0937 25.0644 55.2246L25.4269 55.5001H25.4305ZM23.0199 54.7969C23.8409 55.1614 24.7007 55.4314 25.5828 55.6016L25.9924 55.8735C24.7039 55.6894 23.4531 55.3003 22.2876 54.7207C18.4486 52.8067 15.6754 48.9568 12.4672 44.0267C12.5506 44.0521 12.6303 44.0884 12.7137 44.1174L12.75 44.1681C16.2518 49.1055 19.0178 53.0024 23.0235 54.7969H23.0199ZM12.373 43.889C12.3548 43.8563 12.3295 43.8201 12.3113 43.7911L12.547 43.8853C12.5651 43.9143 12.5905 43.9433 12.6086 43.976C12.5143 43.9397 12.4382 43.9071 12.3585 43.8817L12.373 43.889ZM12.373 43.9905C15.6102 48.9605 18.3979 52.8502 22.2658 54.786C23.4794 55.3903 24.7856 55.7873 26.1302 55.9605L26.5144 56.1925C24.8898 56.068 23.3057 55.6245 21.8526 54.8875C17.9846 52.9046 15.1172 48.9568 12.112 43.8998L12.373 43.9941V43.9905ZM12.0358 43.7621C12.0108 43.726 11.9878 43.6884 11.967 43.6497L12.2135 43.7512L12.2823 43.8563L12.0358 43.7693V43.7621ZM11.8872 43.512L11.8256 43.4105L12.0648 43.5192C12.0866 43.5518 12.1047 43.5772 12.1228 43.6098C12.0467 43.5772 11.9633 43.5482 11.8872 43.512ZM11.7386 43.2691C11.7216 43.2321 11.7009 43.1969 11.6769 43.164L11.9053 43.2763C11.9053 43.309 11.9452 43.338 11.967 43.3706C11.8618 43.3271 11.7893 43.2981 11.7132 43.2618L11.7386 43.2691ZM11.7204 43.3633C11.7386 43.3996 11.7639 43.4322 11.7821 43.4685L11.5319 43.3633L11.4667 43.2437L11.7204 43.3633ZM11.3942 43.0987C11.3942 43.0588 11.3543 43.0262 11.3362 42.9863L11.5754 43.106L11.6407 43.222L11.3978 43.0987H11.3942ZM11.3942 43.193C11.3942 43.2328 11.4341 43.2727 11.4558 43.3126L11.1839 43.1821C11.1839 43.1422 11.1441 43.1023 11.1259 43.0588L11.3942 43.193ZM11.0643 42.9211C11.0426 42.8776 11.0244 42.8341 11.0027 42.7942L11.2564 42.9283C11.2564 42.9682 11.2999 43.0081 11.3181 43.0516L11.0643 42.9283V42.9211ZM10.9374 42.6456L10.8722 42.5078L11.1151 42.6564C11.1332 42.6927 11.1586 42.7362 11.1767 42.7761L10.9374 42.6419V42.6456ZM10.8106 42.3701L10.7489 42.2396L10.9737 42.3882C10.9737 42.4281 11.0172 42.4643 11.0353 42.5078C10.9592 42.4607 10.883 42.4208 10.8069 42.3701H10.8106ZM10.7815 42.4462C10.8033 42.4969 10.8287 42.5441 10.8504 42.5948L10.6003 42.4426C10.5785 42.3882 10.5568 42.3374 10.5314 42.2867C10.5713 42.3338 10.651 42.3882 10.738 42.4389L10.7815 42.4462ZM10.4807 42.1562C10.4807 42.1018 10.4372 42.0511 10.4154 41.993L10.651 42.1634C10.6728 42.2142 10.6982 42.2613 10.7163 42.3121L10.4807 42.1562ZM10.3574 41.8372C10.3574 41.7973 10.3248 41.7502 10.3103 41.7103L10.5205 41.877C10.5205 41.9169 10.5568 41.9568 10.5713 41.9894L10.3574 41.8372ZM10.3284 41.9314C10.3284 41.9858 10.3719 42.0402 10.39 42.0982L10.0602 41.8734L9.99128 41.6958C10.0964 41.7792 10.216 41.8553 10.3248 41.935L10.3284 41.9314ZM9.9224 41.5073C9.9224 41.4602 9.8934 41.413 9.87528 41.3659C9.98765 41.4602 10.1037 41.5472 10.2197 41.6378C10.2197 41.6813 10.2523 41.7284 10.2704 41.7719C10.1508 41.6849 10.0384 41.5943 9.9079 41.5037L9.9224 41.5073ZM9.81365 41.1919C9.81365 41.1448 9.78103 41.0976 9.7629 41.0505C9.87165 41.1557 9.99491 41.2535 10.1073 41.3514C10.1254 41.3949 10.1399 41.4348 10.1544 41.4783L9.81002 41.1883L9.81365 41.1919ZM9.77015 41.2753C9.78974 41.3239 9.80668 41.3735 9.8209 41.4239C9.7049 41.3297 9.58889 41.2354 9.47651 41.1375L9.41127 40.949C9.53089 41.0578 9.6469 41.1702 9.77378 41.2753H9.77015ZM9.32426 40.7714C9.30614 40.7098 9.28076 40.6481 9.26264 40.5829C9.38589 40.7098 9.50189 40.8403 9.62514 40.9454C9.62514 40.9889 9.65777 41.036 9.67227 41.0831L9.30976 40.7678L9.32426 40.7714ZM9.20463 40.4089L9.13213 40.2023C9.25901 40.34 9.37864 40.485 9.49464 40.6191C9.51277 40.6663 9.53089 40.717 9.54539 40.7641C9.42577 40.6481 9.30614 40.5285 9.18288 40.4016L9.20463 40.4089ZM9.15026 40.4705C9.17201 40.543 9.19738 40.6083 9.21551 40.6771C9.09225 40.5611 8.97263 40.4343 8.853 40.3146C8.83125 40.2494 8.81312 40.1805 8.79137 40.108C8.90375 40.2349 9.03063 40.3509 9.15388 40.4705H9.15026ZM8.72612 39.8869L8.64999 39.6404C8.76962 39.7854 8.89288 39.9267 9.0125 40.0681L9.08863 40.3001C8.96175 40.166 8.8385 40.0246 8.72612 39.8869ZM8.56299 39.3649C8.54124 39.2887 8.51224 39.209 8.49049 39.1292C8.61374 39.3032 8.74425 39.4917 8.87475 39.6367C8.8965 39.7129 8.92188 39.7781 8.94363 39.8542C8.80225 39.6911 8.67899 39.528 8.55212 39.3612L8.56299 39.3649ZM8.41799 38.8791L8.32374 38.5456C8.45787 38.7522 8.58837 38.9625 8.72975 39.1618C8.75875 39.2561 8.78412 39.3467 8.81312 39.4337C8.66449 39.2525 8.53762 39.0495 8.40711 38.8755L8.41799 38.8791ZM8.23673 38.281C8.20773 38.1758 8.18236 38.0671 8.14973 37.9511C8.28386 38.1903 8.42161 38.4332 8.56299 38.6761C8.58474 38.7595 8.61012 38.8392 8.63187 38.9117C8.49411 38.7087 8.36361 38.5021 8.23673 38.2918V38.281ZM8.06998 37.6357C8.0446 37.5306 8.01561 37.4182 7.99023 37.3022C8.12799 37.5813 8.26211 37.8604 8.41074 38.1323C8.43249 38.1976 8.44699 38.2665 8.46874 38.3317C8.33099 38.1045 8.19686 37.8725 8.06636 37.6357H8.06998ZM7.9286 37.0484C7.89235 36.9034 7.86335 36.7512 7.8271 36.5989C7.9576 36.9107 8.10261 37.2079 8.24761 37.5052C8.27661 37.6139 8.30198 37.7154 8.33099 37.8206C8.19323 37.5668 8.05548 37.3094 7.9286 37.0484ZM7.72922 36.1422C7.69297 35.979 7.65672 35.805 7.62409 35.6274C7.76547 36.0261 7.91047 36.414 8.06998 36.7947C8.09898 36.907 8.12073 37.0158 8.14973 37.1246C8.0011 36.8019 7.85973 36.4793 7.72922 36.1458V36.1422ZM7.52621 35.1163C7.48271 34.8806 7.43921 34.6414 7.39571 34.3912C7.53346 34.8806 7.68572 35.3628 7.85248 35.8413C7.8851 36.008 7.92498 36.1748 7.96123 36.3343C7.80535 35.9391 7.65672 35.5331 7.52621 35.1199V35.1163ZM7.27246 33.6336C7.22896 33.3255 7.18546 33.0065 7.14196 32.6802C7.27246 33.3327 7.42834 33.978 7.59872 34.6015C7.6386 34.8154 7.6821 35.0184 7.72197 35.225C7.55522 34.703 7.40659 34.1737 7.27246 33.6336ZM7.04771 31.9153C6.9752 31.2773 6.91358 30.6139 6.87007 29.9251C6.87007 30.0339 6.8882 30.1426 6.90633 30.2514C7.00058 31.0525 7.12021 31.8428 7.26884 32.6149C7.33771 33.0826 7.41021 33.5321 7.48634 33.9743C7.31596 33.3037 7.16733 32.6149 7.04771 31.9153ZM6.6852 25.3575C6.61946 26.76 6.63035 28.165 6.71782 29.5662C6.6106 28.401 6.56703 27.2308 6.58732 26.0608C6.64269 24.6029 6.7904 23.1499 7.02958 21.7107C6.8393 22.9111 6.71826 24.1214 6.66707 25.3358L6.6852 25.3575ZM6.79757 30.7951C6.79757 30.8531 6.8157 30.9111 6.82295 30.9691C6.87008 31.4658 6.92083 31.9443 6.98608 32.4192C6.84833 31.7159 6.7287 31.0018 6.62357 30.2731C6.58732 29.6641 6.55832 29.037 6.54744 28.3917C6.59457 29.1929 6.6707 29.9976 6.78308 30.8024L6.79757 30.7951ZM6.73595 32.4989C6.78307 32.9049 6.84108 33.3037 6.89545 33.6843C6.7577 33.1696 6.63807 32.6439 6.53294 32.1111C6.48582 31.6144 6.44232 31.0997 6.41331 30.5704C6.49669 31.2265 6.60907 31.8718 6.73595 32.5026V32.4989ZM6.73595 34.4565C6.60182 34.0432 6.48582 33.6263 6.37344 33.1986C6.33719 32.8361 6.30094 32.4736 6.26468 32.1111C6.32994 32.4446 6.39519 32.7781 6.47856 33.1043C6.51481 33.2711 6.56557 33.4233 6.60907 33.5828C6.64894 33.8873 6.69245 34.1774 6.73595 34.4601V34.4565ZM6.37344 34.1375C6.24294 33.7133 6.12331 33.2856 6.01093 32.8469C5.97105 32.4156 5.9348 31.9697 5.90218 31.502C5.9928 32.0313 6.10156 32.5533 6.22844 33.0644C6.27194 33.427 6.31544 33.7895 6.36256 34.152L6.37344 34.1375ZM5.86593 30.5921C5.83693 30.0012 5.82605 29.3814 5.82605 28.747C5.86955 29.472 5.94568 30.197 6.05443 30.9003C6.08343 31.3969 6.1233 31.8827 6.16681 32.3503C6.04718 31.7775 5.94568 31.1867 5.86955 30.5921H5.86593ZM5.7898 26.2674C5.7318 27.1628 5.69917 28.0618 5.70279 28.9753C5.63024 27.814 5.63024 26.6493 5.70279 25.488C5.83108 24.2053 6.032 22.9308 6.30456 21.6708C6.01968 23.1877 5.85483 24.7246 5.81155 26.2674H5.7898ZM5.95293 22.5734C5.83692 23.2477 5.7608 23.9183 5.69192 24.589C5.5445 25.7974 5.45629 27.0299 5.42729 28.2866C5.37515 26.7112 5.46128 25.1343 5.68467 23.574C5.71367 23.3782 5.7463 23.1788 5.77892 22.9794C6.09765 21.1968 6.56697 19.4445 7.18183 17.7412C6.63952 19.3091 6.22847 20.9193 5.95293 22.5553V22.5734ZM5.51429 32.0639C5.54692 32.5098 5.5868 32.9593 5.63392 33.4088C5.49254 32.8687 5.37654 32.3213 5.27141 31.7522C5.23879 31.1722 5.21341 30.5885 5.20616 30.0049C5.27141 30.7081 5.38016 31.3897 5.50704 32.0639H5.51429ZM5.13366 28.1742C5.10466 28.9753 5.10103 29.7765 5.13366 30.5704C5.0236 29.5895 4.97276 28.6029 4.98141 27.6159C5.06756 26.092 5.24917 24.5749 5.52517 23.0737C5.43817 23.5776 5.36204 24.0779 5.30766 24.5817C5.17112 25.7765 5.11662 26.9792 5.14453 28.1815L5.13366 28.1742ZM5.13366 24.8826C5.51865 21.6266 6.42567 18.4539 7.81985 15.4864C7.82804 15.4742 7.83416 15.4607 7.83797 15.4465C6.46775 18.4341 5.55723 21.6118 5.13728 24.8717L5.13366 24.8826ZM4.97415 25.5351C4.91615 26.1369 4.8944 26.7242 4.88353 27.3151C4.81827 28.2177 4.7929 29.1276 4.7929 30.0484C4.69458 28.8605 4.68368 27.6671 4.76027 26.4777L4.78202 26.2022C4.96568 24.5205 5.27221 22.8545 5.69917 21.2177C5.3486 22.6352 5.10623 24.0773 4.97415 25.5315V25.5351ZM4.80377 30.9728C4.80377 31.5274 4.84727 32.0857 4.88715 32.6439C4.74319 31.9507 4.6379 31.25 4.57177 30.545C4.57177 29.7475 4.57177 28.95 4.62252 28.1525C4.62376 29.0953 4.68308 30.0372 4.80015 30.9728H4.80377ZM4.64065 34.1339C4.49202 33.6046 4.37239 33.0789 4.27814 32.5497C4.24189 31.9334 4.22376 31.3172 4.21288 30.7009C4.27974 31.3763 4.38138 32.0479 4.51739 32.7128C4.55727 33.1877 4.61164 33.6626 4.65152 34.1375L4.64065 34.1339ZM4.12588 28.2648V28.3845C4.07151 29.3161 4.06063 30.255 4.08238 31.1975C4.00593 30.5077 3.96601 29.8144 3.96276 29.1204C3.92288 24.6905 5.24603 19.619 7.61322 14.9825C5.43816 19.2891 4.19114 24.0452 4.12588 28.2685V28.2648ZM3.854 33.8402C3.87575 34.1049 3.8975 34.3695 3.9265 34.6341C3.94825 34.8009 3.97363 34.964 3.99538 35.1308C3.82695 34.6041 3.69015 34.0678 3.58574 33.5248C3.53499 32.8868 3.49512 32.2416 3.48062 31.5963C3.55137 32.3515 3.67248 33.1011 3.84313 33.8402H3.854ZM4.06063 35.6274C4.10776 35.9899 4.15851 36.3089 4.22013 36.6424C4.0616 36.2877 3.92244 35.9247 3.80325 35.5549C3.74162 35.109 3.68725 34.6631 3.64012 34.21C3.75975 34.6921 3.90113 35.167 4.06063 35.6201V35.6274ZM4.29263 37.0774C5.63029 44.4654 9.17926 50.5301 14.4429 54.3147C18.4667 57.2148 23.3171 58.6648 28.7149 58.6648C29.9263 58.6644 31.1366 58.5942 32.34 58.4546C32.6662 58.4981 33.0179 58.5271 33.3912 58.5488C25.9272 59.5566 19.2534 58.0159 13.9499 54.0429C8.56299 49.9936 5.03578 43.6533 3.88663 36.0624C4.0135 36.4032 4.15488 36.7403 4.30351 37.0666L4.29263 37.0774ZM32.7351 58.4183C33.3151 58.3422 33.8951 58.2552 34.4788 58.1501C35.0479 58.1501 35.6642 58.1174 36.2913 58.0558C35.9288 58.1283 35.5663 58.1972 35.2038 58.2625C34.7688 58.3458 34.3374 58.4183 33.906 58.48C33.4819 58.48 33.0795 58.451 32.7061 58.4147L32.7351 58.4183ZM35.0552 58.0558C35.3198 58.0051 35.5917 57.9507 35.8636 57.8891L37.4731 57.5266C39.7254 57.2241 41.9332 56.6521 44.049 55.8228C44.6774 55.6198 45.2972 55.4011 45.9087 55.1666C44.8344 55.6945 43.7291 56.157 42.599 56.5514C40.9314 57.0517 39.2204 57.4541 37.4767 57.8166C36.6751 57.9321 35.868 58.0059 35.0588 58.0377L35.0552 58.0558ZM46.8585 54.7932C47.1376 54.6736 47.4167 54.554 47.6958 54.4307C47.134 54.7642 46.5684 55.0796 46.0066 55.366C45.4628 55.5908 44.919 55.801 44.3499 56.0004C45.1837 55.6379 46.0247 55.25 46.8585 54.8005V54.7932ZM47.3515 54.4307C46.9346 54.6156 46.5177 54.7932 46.0936 54.9564C46.7896 54.6265 47.4856 54.2604 48.1707 53.8688C48.381 53.7746 48.5876 53.6767 48.7906 53.5752C48.3194 53.8604 47.8433 54.1383 47.3623 54.409L47.3515 54.4307ZM48.5332 53.5353C48.2215 53.684 47.9134 53.829 47.5943 53.9631C48.149 53.6695 48.7036 53.3505 49.2655 52.9988C49.425 52.9263 49.5773 52.8466 49.7331 52.7632C49.338 53.0314 48.9356 53.2852 48.5332 53.5317V53.5353ZM49.5736 52.6979C49.3271 52.8248 49.0734 52.9444 48.8232 53.0604C49.2945 52.7886 49.7658 52.5022 50.2298 52.1904L50.5923 51.9983C50.2552 52.2376 49.9108 52.4696 49.57 52.6943L49.5736 52.6979ZM50.469 51.9258C50.3132 52.0128 50.1537 52.0926 49.9942 52.1759C50.382 51.9294 50.759 51.6757 51.1324 51.4147L51.3934 51.266C51.0853 51.4944 50.7808 51.7155 50.469 51.9258ZM50.9439 51.382C51.2774 51.1573 51.6037 50.9253 51.9227 50.686L52.1728 50.541C51.9191 50.744 51.6581 50.9361 51.3971 51.1283C51.2448 51.2153 51.0962 51.3023 50.9439 51.382ZM50.2189 51.7445C49.9651 51.8678 49.7041 51.991 49.4431 52.1071C49.9543 51.8243 50.4473 51.527 50.9222 51.2225L51.3608 50.9941C50.9983 51.2515 50.6068 51.5017 50.2153 51.7482L50.2189 51.7445ZM51.2811 50.9035C51.0635 51.0159 50.8533 51.1246 50.6322 51.2334C51.0527 50.976 51.4623 50.7114 51.8574 50.4323L52.22 50.2293C51.9082 50.4613 51.5928 50.686 51.2811 50.9035ZM51.7342 50.3743L51.6472 50.425C51.9046 50.251 52.162 50.0625 52.4085 49.8921C52.1873 50.0516 51.9626 50.2111 51.7378 50.367L51.7342 50.3743ZM51.8828 50.0117L51.4224 50.2365C51.8792 49.9719 52.3142 49.6855 52.7383 49.3846L52.9414 49.2722C52.5788 49.5332 52.2381 49.7797 51.8828 49.9972V50.0117ZM52.9703 49.3411C52.8725 49.4172 52.7782 49.497 52.6803 49.5659L52.5788 49.6239L52.9703 49.3411ZM52.6658 49.3121L52.5353 49.381C52.7347 49.2505 52.9305 49.1127 53.1226 48.9786L52.6695 49.3121H52.6658ZM51.6617 49.8124C51.4514 49.9139 51.2339 50.0081 51.02 50.0987C51.6049 49.7967 52.1837 49.4607 52.7565 49.091L52.9341 48.9967C52.5208 49.2867 52.0931 49.5622 51.6653 49.8124H51.6617ZM50.1355 50.4359C49.3525 50.7186 48.5586 50.9579 47.7538 51.1863C49.0954 50.7763 50.3973 50.2461 51.6436 49.6021C51.8031 49.5332 51.9662 49.4644 52.1257 49.3882C51.4815 49.775 50.8158 50.1248 50.1319 50.4359H50.1355ZM43.0376 52.3028L42.8237 52.3499C43.5052 52.0853 44.1868 51.8569 44.8719 51.6539C46.2679 51.3434 47.6472 50.9623 49.0045 50.512C49.6316 50.3344 50.2515 50.1495 50.8605 49.9102C48.2142 51.1609 45.4447 51.7772 43.034 52.3028H43.0376ZM42.3343 52.4587C42.1023 52.5094 41.874 52.5602 41.6492 52.6182L41.8558 52.5094L42.3887 52.2376C42.86 52.1216 43.3494 52.0092 43.8387 51.8932C43.3312 52.0635 42.8274 52.2557 42.3271 52.4623L42.3343 52.4587ZM42.3343 52.1796L41.8957 52.2919L42.4576 51.9729C42.7331 51.8895 43.0122 51.817 43.3059 51.7373C42.976 51.875 42.6497 52.0237 42.3271 52.1868L42.3343 52.1796ZM41.5876 52.3753C41.5223 52.3934 41.4607 52.4079 41.4027 52.4297L41.8776 52.1506L42.1531 52.0599L41.5876 52.3753ZM41.6492 52.4333L42.0407 52.3246L41.8232 52.4369C41.6637 52.5239 41.5006 52.6001 41.3411 52.6871L41.0583 52.7523L41.6456 52.4333H41.6492ZM41.4063 52.7451L41.9646 52.6182C41.7181 52.7269 41.4716 52.8393 41.2396 52.9807L41.1489 53.0242L40.761 53.1076C40.9822 52.9952 41.1997 52.8792 41.4208 52.7451H41.4063ZM40.8553 53.1438L40.1085 53.5063L39.804 53.5643C40.0288 53.4556 40.2535 53.3396 40.4783 53.2272L40.8408 53.1438H40.8553ZM39.0138 53.7202L39.5684 53.4338H39.63L39.0246 53.7311L39.0138 53.7202ZM39.0391 53.7963L39.1878 53.7637L38.5062 54.0791H38.4047L39.0355 53.7782L39.0391 53.7963ZM38.5389 54.1588L38.7709 54.119L38.0168 54.4489H37.9625L37.8138 54.467L38.5389 54.1552V54.1588ZM37.832 54.206L37.5456 54.2604H37.4767C37.6398 54.1879 37.803 54.1081 37.9697 54.0284L38.1691 53.9812L38.3214 53.945L37.832 54.1951V54.206ZM37.5601 54.3329L36.9982 54.5902C36.9741 54.5882 36.9498 54.5882 36.9257 54.5902C36.8314 54.6084 36.7408 54.6156 36.6466 54.6301L37.1613 54.3981L37.5456 54.3292L37.5601 54.3329ZM36.7517 54.6954L36.1644 54.9382L35.8345 54.9672L36.3819 54.7425L36.7444 54.6881L36.7517 54.6954ZM35.6025 54.9963L35.1965 55.0325L35.7077 54.8367L36.1246 54.7824L35.6025 54.9963ZM35.327 55.1014C35.1422 55.1739 34.9645 55.2464 34.776 55.3116H34.3591C34.5368 55.2536 34.7216 55.1884 34.8956 55.1231L35.3234 55.0869L35.327 55.1014ZM34.1126 55.3298H33.7501C33.9241 55.279 34.1126 55.2283 34.2721 55.1703L34.6346 55.1449C34.4606 55.2029 34.2721 55.2681 34.1126 55.3225V55.3298ZM33.819 55.4204L33.2861 55.5835H32.9236L33.4565 55.4385H33.819V55.4204ZM32.6408 55.5581L32.3073 55.54C32.4668 55.5074 32.6336 55.4639 32.7967 55.424H33.1592L32.6553 55.5545L32.6408 55.5581ZM32.3363 55.627C32.1696 55.6669 31.9956 55.714 31.8252 55.7503L31.4627 55.7104C31.6367 55.6814 31.8252 55.6451 31.9811 55.6053L32.3255 55.627H32.3363ZM31.2488 55.6814L30.8537 55.6306L31.3286 55.5581L31.7418 55.5908L31.2452 55.6814H31.2488ZM30.9443 55.7321C30.7739 55.7575 30.5818 55.7901 30.4223 55.8119L29.9873 55.7249C30.1613 55.7249 30.3498 55.6886 30.5129 55.6633L30.9334 55.7249L30.9443 55.7321ZM29.748 55.6814C29.6066 55.656 29.4725 55.6234 29.3384 55.5944C29.5124 55.5944 29.6828 55.5944 29.8532 55.5654C30.0235 55.5364 30.125 55.6089 30.2628 55.6306C30.0888 55.6524 29.9184 55.6669 29.748 55.6814ZM29.4544 55.7104L28.9288 55.7358L28.5409 55.6198C28.6859 55.6198 28.8418 55.6198 28.9868 55.6198L29.4544 55.7249V55.7104ZM28.2871 55.54C28.1602 55.5038 28.0406 55.4639 27.9246 55.4204H28.356L28.7584 55.5291H28.2944L28.2871 55.54ZM27.9645 55.54L27.4968 55.5183C27.3663 55.4675 27.2431 55.4095 27.1343 55.3588L27.5875 55.4095L27.979 55.54H27.9645ZM27.1887 55.4893C27.0147 55.4893 26.8262 55.4603 26.6703 55.4385C26.5144 55.4168 26.4202 55.3116 26.3078 55.2464C26.4673 55.2754 26.6341 55.2971 26.8008 55.3189C26.9676 55.3406 27.0328 55.4349 27.167 55.4893H27.1887ZM26.3767 55.3914C26.2244 55.3696 26.0686 55.3479 25.9163 55.3189L25.5538 55.0869L25.9924 55.1847C26.1193 55.2536 26.2462 55.3261 26.3767 55.3914ZM25.3798 54.9672C25.271 54.8911 25.1659 54.815 25.068 54.7389L25.4305 54.8549C25.5429 54.9237 25.6553 54.9962 25.7749 55.0615C25.6408 55.0289 25.5067 55.0035 25.3725 54.9672H25.3798ZM24.8832 54.6047C24.7925 54.5359 24.7055 54.4634 24.6221 54.3945H24.6584C24.7418 54.4307 24.8396 54.4561 24.9266 54.4887C25.0137 54.5214 25.126 54.6301 25.2312 54.699C25.1115 54.6664 24.9992 54.6301 24.8868 54.5902L24.8832 54.6047ZM24.7816 54.6519C24.8868 54.7316 24.9883 54.815 25.097 54.8911C24.952 54.8476 24.8034 54.8077 24.662 54.757C24.5206 54.7062 24.4699 54.5902 24.3793 54.5069L24.7635 54.6446L24.7816 54.6519ZM24.4191 54.4452C24.3503 54.4199 24.2923 54.3872 24.2306 54.3655L23.9986 54.1299L24.3321 54.2749C24.4191 54.3546 24.5098 54.4307 24.604 54.5105L24.4191 54.4452ZM23.8572 53.9776C23.7992 53.9087 23.734 53.8398 23.6796 53.771L23.9515 53.9123L24.169 54.1299C24.0603 54.0827 23.9588 54.032 23.8536 53.9812L23.8572 53.9776ZM23.7992 54.032C23.8717 54.1154 23.9515 54.1951 24.0313 54.2821C21.0659 53.0024 18.9996 50.5446 16.4186 47.4633C15.6247 46.5172 14.7655 45.4949 13.8194 44.4291L13.9861 44.4799C15.2368 45.7813 16.3026 47.0174 17.285 48.1593C19.4963 50.7295 21.2979 52.8103 23.8101 54.0356L23.7992 54.032ZM16.3606 47.5068C18.9996 50.6534 21.0949 53.1547 24.169 54.4199L24.4481 54.6881C24.3285 54.6446 24.2016 54.6047 24.0856 54.5576C20.6635 53.2055 18.3326 50.309 15.3854 46.6368C14.7981 45.9118 14.1746 45.136 13.5112 44.3349C13.5729 44.353 13.6345 44.3675 13.6925 44.3892C14.6749 45.4768 15.5522 46.5353 16.3714 47.5104L16.3606 47.5068ZM13.388 44.1935L13.3119 44.1246L13.4859 44.1826C13.5076 44.2044 13.5221 44.2261 13.5402 44.2479L13.3699 44.1971L13.388 44.1935ZM13.388 44.2914C14.0804 45.1251 14.7256 45.9263 15.331 46.6767C18.2927 50.3561 20.6273 53.2598 24.0675 54.6156C24.2488 54.6881 24.43 54.7534 24.6185 54.815C24.72 54.9092 24.8288 54.9926 24.9412 55.0832C24.5029 54.9634 24.072 54.8181 23.6506 54.6482C19.9639 53.1185 17.4155 49.7797 14.1928 45.5529L13.1814 44.2297L13.3844 44.2914H13.388ZM13.0835 44.0992C13.0835 44.0702 13.04 44.0448 13.0219 44.0158L13.2067 44.0775L13.272 44.1536L13.0835 44.0992ZM12.9131 43.8781L12.8623 43.8128L13.04 43.8781C13.0549 43.8991 13.0719 43.9185 13.0907 43.9361L12.9131 43.8781ZM12.9131 43.976C12.9364 44.005 12.9582 44.0353 12.9784 44.0666L12.7645 43.9941L12.7065 43.9107L12.9131 43.9796V43.976ZM12.6013 43.7621L12.5433 43.6787L12.75 43.7621L12.808 43.8382C12.692 43.8128 12.6267 43.7838 12.5578 43.7621H12.6013ZM12.4418 43.5337C12.4418 43.5047 12.402 43.4793 12.3838 43.454L12.576 43.541L12.6303 43.6098L12.4382 43.5337H12.4418ZM12.4418 43.628L12.4998 43.7113L12.2751 43.6207C12.2591 43.5916 12.2409 43.5637 12.2207 43.5373C12.2896 43.57 12.3657 43.5953 12.4418 43.628ZM12.1265 43.3923C12.1058 43.365 12.0876 43.3359 12.0721 43.3053L12.2751 43.3996L12.3403 43.4866L12.1265 43.3923ZM11.9706 43.1495L11.909 43.0588C11.9815 43.0914 12.0431 43.135 12.1156 43.1712L12.17 43.251L11.9706 43.1531V43.1495ZM11.8183 42.9138C11.7973 42.886 11.778 42.8569 11.7603 42.8268C11.8292 42.8594 11.8872 42.9029 11.9525 42.9392L12.0032 43.0081L11.8219 42.9138H11.8183ZM11.7893 42.9899C11.8111 43.0262 11.8328 43.0625 11.8546 43.0914L11.6407 42.9863C11.6153 42.9464 11.5972 42.9066 11.5718 42.8703L11.7893 42.9899ZM11.4957 42.7362C11.4703 42.6999 11.4522 42.6601 11.4268 42.6238L11.6262 42.7471L11.6914 42.8449L11.4921 42.7362H11.4957ZM11.4631 42.8087L11.5319 42.9319L11.2999 42.8051C11.2999 42.7652 11.2564 42.7217 11.2383 42.6854L11.4631 42.8051V42.8087ZM11.1622 42.5477C11.1622 42.5078 11.1223 42.4679 11.1006 42.4244L11.3108 42.5513L11.3797 42.6709L11.1622 42.5441V42.5477ZM11.0208 42.2686L10.9628 42.1634L11.1549 42.2939C11.1764 42.3253 11.1958 42.358 11.2129 42.3918C11.1441 42.3519 11.0788 42.3157 11.0136 42.2722L11.0208 42.2686ZM10.8867 42.0039L10.8359 41.9024L11.0099 42.0329C11.0099 42.0619 11.0462 42.0909 11.0607 42.1199C10.9447 42.0801 10.8867 42.0438 10.8287 42.0003L10.8867 42.0039ZM10.8577 42.0946C10.8577 42.1272 10.8903 42.1562 10.9048 42.1888C10.8287 42.1417 10.7634 42.0873 10.6945 42.0365L10.6438 41.9278L10.8577 42.0946ZM10.5677 41.761C10.5677 41.7284 10.5387 41.6994 10.5278 41.6704L10.7163 41.819C10.7163 41.8517 10.7489 41.8843 10.7634 41.9133L10.5677 41.761ZM10.4444 41.4855L10.4118 41.4022C10.4662 41.4529 10.5242 41.5 10.5822 41.5472C10.6402 41.5943 10.6148 41.6052 10.6293 41.6378C10.5677 41.587 10.5133 41.5363 10.448 41.4855H10.4444ZM10.4227 41.5798C10.4362 41.6146 10.4519 41.6485 10.4698 41.6813L10.274 41.529C10.2564 41.4904 10.2418 41.4504 10.2305 41.4094C10.2958 41.4638 10.3574 41.5254 10.4263 41.5798H10.4227ZM10.1653 41.2499C10.1653 41.21 10.1399 41.1702 10.1218 41.1303L10.2958 41.297L10.3393 41.3949L10.1653 41.2499ZM10.0529 40.9381L10.0203 40.8475C10.0697 40.9054 10.123 40.9599 10.1798 41.0107C10.1798 41.0324 10.1979 41.0578 10.2088 41.0795L10.0565 40.9345L10.0529 40.9381ZM10.0239 41.036C10.0239 41.0795 10.0565 41.123 10.071 41.1665L9.70852 40.8511C9.70852 40.8004 9.67227 40.7533 9.65777 40.7025C9.77015 40.8185 9.8934 40.9236 10.0203 41.036H10.0239ZM9.53814 40.4995C9.53814 40.4633 9.51277 40.4234 9.50189 40.3835C9.61427 40.514 9.74115 40.63 9.8644 40.746C9.8644 40.7823 9.8934 40.8185 9.90428 40.8511C9.78103 40.7351 9.66502 40.6155 9.54177 40.4886L9.53814 40.4995ZM9.42214 40.166C9.42214 40.1153 9.38589 40.0645 9.36776 40.0137C9.48376 40.1588 9.61427 40.2965 9.73027 40.4379L9.77378 40.5648L9.41127 40.1696L9.42214 40.166ZM9.38589 40.2603C9.38589 40.3001 9.41489 40.34 9.42576 40.3799L9.06326 39.9847C9.04513 39.9195 9.01975 39.8579 9.00163 39.7926C9.12851 39.9521 9.25176 40.1116 9.38589 40.2639V40.2603ZM8.92913 39.5787C8.91802 39.537 8.90471 39.4958 8.88925 39.4555C8.88925 39.4156 8.86387 39.3685 8.853 39.325C8.97625 39.5026 9.11038 39.6875 9.24451 39.8434L9.26626 39.9159C9.28173 39.9513 9.29504 39.9876 9.30614 40.0246C9.18288 39.876 9.056 39.731 8.94363 39.5787H8.92913ZM8.7805 39.1002C8.75875 39.0277 8.73337 38.948 8.71162 38.8646C8.84575 39.0712 8.97625 39.2706 9.11401 39.4664C9.13213 39.5207 9.14663 39.5606 9.16113 39.6114C9.03426 39.4446 8.90375 39.2779 8.7805 39.1075V39.1002ZM8.63187 38.5963C8.61374 38.5238 8.59199 38.455 8.57387 38.3788C8.70437 38.6108 8.84938 38.8392 8.99075 39.0567L9.02338 39.1764C8.88925 38.9842 8.75875 38.7921 8.63187 38.5927V38.5963ZM8.50136 38.1323C8.47961 38.0453 8.45424 37.9547 8.43249 37.8604C8.57024 38.1215 8.71525 38.3788 8.86025 38.6362C8.86025 38.6906 8.88925 38.7413 8.90738 38.7957C8.76963 38.5746 8.63187 38.3607 8.50136 38.1323ZM8.33461 37.4943C8.30924 37.4073 8.29111 37.3131 8.26574 37.2224C8.41074 37.5487 8.56299 37.8641 8.7225 38.1758C8.7225 38.2193 8.74425 38.2628 8.75875 38.3063C8.59925 38.0199 8.46512 37.7517 8.33461 37.4762V37.4943ZM8.16423 36.8092C8.13523 36.6895 8.10623 36.5627 8.07723 36.4467C8.22948 36.849 8.39261 37.2442 8.56299 37.6284L8.61737 37.8206C8.45787 37.4943 8.30561 37.1644 8.16423 36.8237V36.8092ZM7.96123 35.9138C7.9286 35.7688 7.8996 35.6238 7.8706 35.4751C8.03011 35.979 8.20411 36.4757 8.39261 36.9542C8.39261 37.023 8.42524 37.0883 8.44337 37.1499C8.27661 36.7475 8.11348 36.3343 7.96485 35.9101L7.96123 35.9138ZM7.77272 35.0002C7.71835 34.7211 7.66397 34.4347 7.61322 34.1375C7.78481 34.819 7.97573 35.4824 8.18598 36.1277C8.21498 36.2545 8.24761 36.3887 8.28023 36.5192C8.09535 36.0225 7.91773 35.5186 7.77272 35.0002ZM7.47184 33.2493C7.40296 32.7889 7.33771 32.3104 7.27246 31.7993C7.42834 32.7418 7.63497 33.6698 7.8561 34.5761C7.8996 34.8117 7.95036 35.0474 8.00111 35.2758C7.80173 34.6124 7.6386 33.9345 7.46822 33.2312L7.47184 33.2493ZM7.10933 30.3891C7.02233 29.4321 6.96796 28.4243 6.95346 27.3912C6.97158 27.9857 7.00421 28.5802 7.05496 29.1784C7.12021 29.9577 7.21083 30.7408 7.33046 31.5202C7.41384 32.1836 7.51534 32.8252 7.62409 33.4415C7.41384 32.4591 7.23621 31.4404 7.10933 30.3964V30.3891ZM7.21809 30.0266C7.08987 28.676 7.0342 27.3195 7.05133 25.9629C7.03574 28.9206 7.36791 31.8699 8.04098 34.7501C7.66285 33.1993 7.38915 31.6249 7.22171 30.0375L7.21809 30.0266ZM6.7867 22.6858C6.57618 24.2297 6.4684 25.7859 6.46407 27.3441C6.43461 26.0539 6.48668 24.7633 6.61994 23.4797C6.85067 21.5338 7.26332 19.6137 7.85248 17.7448C7.34788 19.3573 6.984 21.0105 6.76495 22.6858H6.7867ZM6.51482 29.6242C6.55107 30.2804 6.59819 30.922 6.6562 31.5383C6.53294 30.835 6.44594 30.1136 6.37706 29.3886C6.35169 28.5548 6.34806 27.6812 6.37706 26.7894C6.37344 27.7392 6.42419 28.689 6.51482 29.6242ZM6.40606 31.676C6.45319 32.1836 6.50394 32.6693 6.56194 33.1261C6.42782 32.5932 6.31906 32.0386 6.22481 31.4912C6.18493 30.9401 6.14868 30.3674 6.13056 29.7692C6.19581 30.4109 6.29006 31.0417 6.40244 31.6615L6.40606 31.676ZM6.00005 27.4129C5.9783 28.3482 6.00006 29.2545 6.02906 30.1173C5.92779 29.258 5.87092 28.3941 5.85868 27.5289C5.90416 25.8218 6.0689 24.1199 6.35169 22.4357C6.09021 24.0815 5.96894 25.7466 5.98918 27.4129H6.00005ZM6.11243 23.3818C6.18856 22.7764 6.28281 22.1674 6.40606 21.5693C6.67187 20.1835 7.03529 18.8183 7.49359 17.4838C7.73526 16.824 8.00231 16.1715 8.29474 15.5263C8.14248 15.8888 7.99023 16.2513 7.84885 16.6138C7.0118 18.8078 6.42446 21.089 6.09793 23.4145L6.11243 23.3818ZM5.10828 23.0991C4.76041 24.8748 4.54833 26.6744 4.47389 28.4823C4.47389 28.1198 4.47389 27.7356 4.47389 27.3549C4.65877 22.7873 6.09793 18.0711 8.33461 13.9421V13.9203C6.78739 16.7914 5.68721 19.8817 5.07203 23.0846L5.10828 23.0991ZM7.11658 15.0151C7.02596 15.1855 6.94258 15.3595 6.85558 15.5299C6.76857 15.7003 6.7142 15.8054 6.64894 15.9395C5.86209 17.5412 5.18152 19.193 4.61164 20.8841C5.41878 18.238 6.56927 15.7091 8.03373 13.3621C7.72197 13.9022 7.41384 14.4496 7.12021 15.026L7.11658 15.0151ZM4.94153 20.2026C4.89078 20.3694 4.83278 20.5325 4.7784 20.6993C4.13532 22.5929 3.66812 24.5418 3.38274 26.5212C3.49874 25.6185 3.651 24.7086 3.84313 23.8132C4.14318 22.587 4.50617 21.377 4.93065 20.1881L4.94153 20.2026ZM3.63287 35.3011C4.65877 43.2763 8.25849 49.9356 13.8556 54.1516C18.1224 57.3562 23.2809 58.9911 29.0411 58.9911C30.7924 58.9848 32.5403 58.8394 34.2685 58.5561C35.2308 58.5491 36.1915 58.474 37.1432 58.3313C36.3131 58.4908 35.4793 58.6358 34.6491 58.7663C26.4492 60.0859 19.0866 58.4038 13.3445 53.8942C7.51172 49.2904 3.88663 42.1308 3.20874 33.7133V33.5103C3.31661 34.1142 3.46066 34.711 3.64012 35.2975L3.63287 35.3011ZM34.9537 58.4328C35.0588 58.4147 35.1675 58.4038 35.2763 58.3785C36.5052 58.1465 37.7232 57.9036 38.9231 57.6534C39.5358 57.5302 40.1665 57.3779 40.8082 57.2003C42.0117 56.8922 43.1899 56.5442 44.3426 56.1418C41.3799 57.4775 38.1979 58.2601 34.9537 58.451V58.4328ZM45.4845 55.7031C47.8312 54.8175 50.031 53.5832 52.0097 52.0418C48.8812 54.6519 45.267 56.2469 41.4969 57.3091C42.8712 56.8688 44.2123 56.3309 45.5099 55.6995L45.4845 55.7031ZM47.1195 54.8367C47.598 54.5685 48.0729 54.2894 48.5477 53.9885H48.5695C49.8889 53.3253 51.1375 52.5297 52.2961 51.614C50.7194 52.9128 48.9804 54.001 47.1231 54.8512L47.1195 54.8367ZM48.3556 53.916C48.6891 53.7093 49.0226 53.4955 49.3525 53.278L49.599 53.1076C49.7114 53.0496 49.8165 52.9879 49.9253 52.9263C49.5954 53.1656 49.2691 53.394 48.9429 53.6078L48.352 53.916H48.3556ZM49.9108 52.7741C49.744 52.8647 49.5845 52.9589 49.4178 53.0459L50.1246 52.5783L50.5198 52.2992L50.7337 52.1723C50.4582 52.3862 50.1827 52.5819 49.9108 52.7741ZM50.4183 52.2013C50.5633 52.0962 50.7083 52.0019 50.8533 51.8932L51.2738 51.5705L51.4514 51.4654C51.2158 51.6539 50.9729 51.8279 50.7445 52.0128C50.6322 52.0744 50.5234 52.1433 50.4147 52.2013H50.4183ZM51.4333 51.7445C51.4567 51.7287 51.4809 51.7142 51.5058 51.701L50.9657 52.1397L50.7953 52.2521C51.0056 52.0889 51.2231 51.9222 51.4333 51.7445ZM51.4551 51.3204L51.2629 51.4328C51.3572 51.3675 51.4514 51.3023 51.5421 51.2334C51.7052 51.1101 51.8575 50.9833 52.0133 50.8709L52.1148 50.8129C51.901 50.9905 51.6798 51.1754 51.4587 51.3349L51.4551 51.3204ZM52.1185 51.0449C51.9626 51.1827 51.8067 51.3132 51.6508 51.44L51.5566 51.5053L52.104 51.0522L52.1185 51.0449ZM52.0895 50.4178C52.0133 50.4649 51.9336 50.5084 51.8538 50.5519C52.1547 50.338 52.4483 50.1205 52.7347 49.8921L52.8 49.8522C52.568 50.0444 52.3287 50.2148 52.075 50.4178H52.0895ZM52.9414 49.6347L52.7275 49.7725C52.9595 49.5912 53.1879 49.41 53.409 49.2142L53.5177 49.1417C53.3292 49.3121 53.1371 49.4716 52.9414 49.6347ZM51.7342 49.4535C51.3209 49.6311 50.904 49.7906 50.4763 49.9392C51.3386 49.5817 52.1724 49.1587 52.9703 48.6741C53.0863 48.6161 53.2096 48.5581 53.3329 48.4928C52.8202 48.8427 52.2889 49.1646 51.7414 49.4571L51.7342 49.4535ZM49.3888 50.2873C48.6202 50.5193 47.8408 50.7295 47.0542 50.9361C46.2676 51.1428 45.4519 51.3639 44.6471 51.6068L44.0998 51.7337L42.6896 52.0635C43.0992 51.875 43.5125 51.701 43.9258 51.5488L45.1293 51.2588C47.2133 50.8224 49.2539 50.2 51.2267 49.3991C51.6218 49.2577 52.0206 49.1018 52.4085 48.9315C51.4425 49.4663 50.4336 49.9198 49.3924 50.2873H49.3888ZM44.5565 51.3277C45.6223 50.9651 46.6881 50.6896 47.743 50.4178C48.5912 50.1966 49.4323 49.9791 50.2552 49.7254C48.5756 50.3284 46.8585 50.8212 45.1148 51.2008L44.5601 51.3313L44.5565 51.3277ZM47.7212 50.338C46.4013 50.6578 45.0992 51.0474 43.8206 51.5053C43.4581 51.5959 43.0956 51.6902 42.7331 51.788C42.9977 51.6467 43.2624 51.5125 43.5234 51.3893C44.3426 51.1464 45.2018 50.9398 46.0827 50.7223C48.4825 50.1423 50.9548 49.5369 53.2785 48.1847L53.6011 48.0288C52.8754 48.4939 52.1156 48.9035 51.3282 49.2541C50.1537 49.6819 48.9429 49.9791 47.7031 50.3163L47.7212 50.338ZM47.888 49.6819C49.7005 49.2432 51.5312 48.7828 53.2966 47.9092C53.5576 47.7896 53.8186 47.6663 54.0724 47.5467C52.8464 48.2973 51.5295 48.8881 50.1537 49.3049C49.5555 49.468 48.9574 49.6202 48.3411 49.7761C47.5871 49.9646 46.8222 50.1604 46.0573 50.3888C45.2308 50.5954 44.426 50.8129 43.6647 51.0739C43.9765 50.9071 44.2846 50.7585 44.6036 50.6135C45.6513 50.251 46.7497 49.9791 47.888 49.7V49.6819ZM45.4048 50.2873C46.5676 49.8763 47.7539 49.5349 48.9574 49.265C50.0475 49.0163 51.1243 48.7126 52.1837 48.3551C50.7761 48.8817 49.3334 49.3093 47.8662 49.6347C47.0216 49.8414 46.1987 50.0444 45.4012 50.2873H45.4048ZM46.2929 50.3924L47.018 50.2148C47.9895 49.9755 48.9864 49.7326 49.9833 49.4245C50.8455 49.1932 51.6929 48.9099 52.5208 48.5762C50.4219 49.6239 48.1961 50.1676 46.0863 50.6788C45.3613 50.86 44.6363 51.0413 43.9113 51.2298C44.6882 50.9014 45.4848 50.6217 46.2966 50.3924H46.2929ZM54.6306 47.1588C54.743 47.0863 54.8481 47.0065 54.9533 46.9304L54.7213 47.0972L54.6306 47.1588ZM43.904 50.8673C43.7046 50.9688 43.5089 51.0812 43.3095 51.1935L42.9941 51.3132L43.208 51.1718C43.4364 51.0667 43.6684 50.9615 43.904 50.8673ZM43.0376 51.4219C43.1355 51.3603 43.2334 51.3095 43.3349 51.2515C43.875 51.0558 44.4224 50.889 45.0024 50.7223C44.4876 50.9035 43.9729 51.1101 43.4617 51.3458C43.2515 51.411 43.0448 51.4727 42.8418 51.5415L43.0376 51.4219ZM42.5337 51.6467L42.367 51.7047C42.4685 51.643 42.5663 51.5814 42.6678 51.5125C42.7694 51.4437 42.86 51.4292 42.9615 51.3929L42.5337 51.6467ZM42.5772 51.701L43.0521 51.5452C42.8382 51.6539 42.6207 51.7663 42.4032 51.9077L42.1277 51.991L42.5736 51.7192L42.5772 51.701ZM42.0878 51.8823L42.2473 51.8207C42.106 51.9004 41.9682 51.9874 41.8268 52.0708L41.7217 52.1071C41.8413 52.0309 41.9646 51.962 42.0842 51.8823H42.0878ZM42.0262 51.8352L42.2401 51.7083L42.2945 51.6829L42.0951 51.8098L42.0262 51.8352ZM41.4389 52.1977C41.3989 52.2084 41.3601 52.2229 41.3229 52.2412L41.6274 52.0672L41.7616 52.0092L41.4389 52.2013V52.1977ZM41.4389 52.2629L41.5549 52.2231L41.0837 52.4877H41.0402L41.4426 52.2448L41.4389 52.2629ZM40.7792 52.5819L40.5943 52.6436L40.9568 52.4442L41.1308 52.3753C41.0184 52.4406 40.9024 52.5167 40.7864 52.5819H40.7792ZM40.7792 52.6544C40.7248 52.6834 40.6704 52.7124 40.6197 52.7451L40.7647 52.6617L40.7792 52.6544ZM41.0982 52.5566L41.2939 52.4949L40.7357 52.8067L40.587 52.8466L41.1018 52.5566H41.0982ZM40.7647 52.8719L41.0474 52.7994C40.8299 52.9118 40.616 53.0278 40.4022 53.133L40.1702 53.1837L40.7683 52.8683L40.7647 52.8719ZM39.485 53.1656L39.3328 53.2091C39.3328 53.2091 39.311 53.2091 39.3001 53.2091L39.601 53.0568L39.8185 52.9771L39.485 53.1474V53.1656ZM39.485 53.2417L39.7569 53.1583C39.6191 53.2345 39.485 53.3142 39.3473 53.3867C39.2095 53.4592 39.1479 53.4447 39.0464 53.4665L39.485 53.2417ZM38.7346 53.6296C38.7405 53.6315 38.7469 53.6315 38.7527 53.6296L39.0754 53.5462L38.5787 53.7963C38.47 53.8181 38.3649 53.8435 38.2597 53.8725L38.7383 53.6368L38.7346 53.6296ZM36.5124 54.5141L36.9112 54.4416L36.4073 54.6591L36.0122 54.7099L36.5088 54.5141H36.5124ZM35.8527 54.6301C35.9578 54.6084 36.0629 54.5939 36.1753 54.5757L35.7367 54.7534L35.4177 54.7896L35.8527 54.6301ZM35.1784 54.7389L35.4467 54.7026L35.0479 54.8367L34.7941 54.8657L35.1748 54.7389H35.1784ZM35.0189 54.6845C35.1023 54.6627 35.1784 54.6374 35.2618 54.6084L35.4684 54.5721L35.2255 54.6519C35.1567 54.6519 35.0914 54.6736 35.0189 54.6845ZM35.0479 54.9165L35.4104 54.873C35.2473 54.9382 35.0805 54.9926 34.9174 55.0506L34.5803 55.0724L35.0479 54.9165ZM34.3845 54.9926L34.6926 54.9564C34.5549 54.9999 34.4171 55.0542 34.2794 55.0941H33.9785C34.1126 55.0542 34.2431 55.0107 34.3845 54.9745V54.9926ZM33.6124 55.2174H33.9277L33.4529 55.3551H33.1411L33.616 55.2246L33.6124 55.2174ZM32.1261 55.4168H32.5248C32.3617 55.4566 32.2022 55.4856 32.0427 55.5219L31.6802 55.5001C31.8288 55.4711 31.9811 55.4385 32.1406 55.4131L32.1261 55.4168ZM31.4011 55.3914C31.5279 55.3914 31.6476 55.3914 31.7636 55.4131L31.3684 55.482L31.0059 55.453L31.3684 55.3914H31.4011ZM30.6108 55.4929C30.7413 55.4929 30.8754 55.5219 31.0132 55.5328L30.5818 55.598C30.444 55.5763 30.3099 55.5581 30.1758 55.5328C30.3208 55.5328 30.4658 55.5183 30.6108 55.4893V55.4929ZM29.1608 55.4421L29.5668 55.5219C29.4 55.5219 29.2369 55.5219 29.0738 55.5219L28.7112 55.4385H28.8127C28.9215 55.4385 29.0339 55.4385 29.1426 55.4385L29.1608 55.4421ZM27.6781 55.25C27.7941 55.2863 27.9137 55.3261 28.0406 55.3588L27.6455 55.337L27.3156 55.2174L27.6781 55.25ZM27.022 55.0289L27.3373 55.1413L27.022 55.1014C26.9241 55.0615 26.8226 55.0216 26.7283 54.9781C26.8081 54.9999 26.906 54.9999 27.0038 55.0289H27.022ZM26.9313 54.902L27.1887 54.9455C27.254 54.9636 27.3228 54.9817 27.3953 55.0071L27.1162 54.9672L26.935 54.902H26.9313ZM26.9313 55.1594L27.2938 55.3008C27.1561 55.3008 27.0183 55.2754 26.8842 55.2536L26.5471 55.0978L26.9313 55.1558V55.1594ZM26.3223 54.8947C26.4238 54.9455 26.5289 54.9926 26.6377 55.0361C26.5217 55.0144 26.4093 54.9962 26.3006 54.9709C26.1918 54.9455 26.0976 54.8694 25.9997 54.815L26.3223 54.8947ZM26.2027 55.0289C26.3151 55.0905 26.4311 55.1485 26.5652 55.2029C26.4093 55.1811 26.2498 55.1521 26.1012 55.1231C25.9526 55.0941 25.8692 54.9963 25.7604 54.9274C25.8764 54.9636 26.0251 54.9999 26.1809 55.0289H26.2027ZM25.6372 54.7244C25.7387 54.7824 25.8438 54.844 25.9489 54.8947C25.8075 54.8657 25.6698 54.8295 25.532 54.7932C25.3943 54.757 25.3435 54.6736 25.2529 54.6084L25.6372 54.7244ZM25.1115 54.4017L25.3689 54.5685L25.0282 54.4525C24.9484 54.3981 24.8759 54.3437 24.8034 54.2857L25.1152 54.4017H25.1115ZM25.0463 54.2459C25.0921 54.2596 25.137 54.2765 25.1804 54.2966C25.242 54.3365 25.3109 54.3727 25.3725 54.409C25.3109 54.3909 25.2529 54.3655 25.1913 54.3437L25.0427 54.2459H25.0463ZM24.6366 54.0718L24.8215 54.206L24.5605 54.0936C24.5061 54.0537 24.4481 54.003 24.3974 53.9595L24.6366 54.0718ZM24.6366 53.945L24.6838 53.9703C24.7381 54.0102 24.7998 54.0429 24.8541 54.0827L24.7744 54.0465L24.6366 53.945ZM24.4808 54.1444C24.5605 54.2132 24.6403 54.2749 24.7273 54.3437H24.691C24.6113 54.3147 24.5315 54.2785 24.4481 54.2422C24.3648 54.206 24.3068 54.1154 24.2415 54.0501C24.2923 54.0718 24.3684 54.1117 24.4518 54.1444H24.4808ZM24.0856 53.8L24.2524 53.9522L24.0566 53.858C24.0059 53.8072 23.9551 53.7565 23.908 53.7021L24.0856 53.8ZM24.0639 53.6441L24.2089 53.7238L24.3865 53.8688L24.2089 53.7818L24.0675 53.6477L24.0639 53.6441ZM23.8282 53.4085L23.7775 53.3577C23.8006 53.3701 23.8224 53.3847 23.8428 53.4012L23.908 53.4592L23.8282 53.4121V53.4085ZM23.8862 53.6042L23.7594 53.5353L23.6289 53.3795L23.734 53.4483L23.8826 53.6042H23.8862ZM23.3969 53.0858L23.444 53.1221C23.473 53.1511 23.4984 53.1837 23.5237 53.2127L23.4621 53.1728C23.4404 53.1438 23.415 53.1148 23.3969 53.0858ZM14.0913 44.2624L14.0695 44.237C14.1001 44.25 14.1316 44.2609 14.1638 44.2696H14.1855L14.0985 44.2442L14.0913 44.2624ZM14.0913 44.3602L14.1348 44.4037C14.1348 44.4037 14.1094 44.4037 14.0949 44.4037L14.0115 44.3784C13.9979 44.363 13.9834 44.3484 13.968 44.3349L14.0913 44.3747V44.3602ZM13.9136 44.0811L13.9753 44.1029L13.91 44.0847L13.9136 44.0811ZM13.939 44.208H13.8955L13.8266 44.1862L13.794 44.15L13.9028 44.1899C13.9157 44.201 13.9278 44.2131 13.939 44.2261V44.208ZM13.8157 44.2732L13.8629 44.3204C13.8121 44.3204 13.765 44.2877 13.7142 44.2769L13.6671 44.2225L13.8157 44.2732ZM13.6889 44.0014H13.6454L13.6164 43.9723L13.7179 44.0122L13.7396 44.0376C13.7228 44.035 13.7057 44.035 13.6889 44.0376V44.0014ZM13.6309 44.0811L13.6707 44.121L13.5402 44.0775L13.504 44.034L13.6345 44.0811H13.6309ZM13.4895 43.8056H13.4641C13.486 43.8186 13.5091 43.8295 13.533 43.8382H13.4967L13.4895 43.8056ZM13.4895 43.9216C13.45 43.9093 13.4113 43.8948 13.3735 43.8781C13.3593 43.8657 13.346 43.8524 13.3336 43.8382L13.4532 43.8853L13.4895 43.918V43.9216ZM13.359 43.9796C13.3763 43.995 13.3921 44.012 13.4061 44.0303L13.2466 43.9723L13.1995 43.9216L13.359 43.9796ZM13.1741 43.7766L13.2212 43.8273L13.0762 43.7766C13.0614 43.7555 13.0444 43.7361 13.0255 43.7186L13.1741 43.7766ZM13.1741 43.6533L13.272 43.7005L13.2974 43.7222C13.2609 43.7115 13.2256 43.6969 13.1922 43.6787L13.1596 43.6497L13.1741 43.6533ZM13.0436 43.6207L12.9131 43.57L12.8623 43.5083L13.0001 43.5736C13.0176 43.5887 13.0335 43.6057 13.0472 43.6243L13.0436 43.6207ZM13.0074 43.4721L13.0654 43.5011C13.0654 43.5011 13.0654 43.5011 13.0871 43.5011C13.0637 43.4876 13.0395 43.4755 13.0146 43.4648L13.0074 43.4721ZM12.895 43.6642L12.9494 43.7258L12.7862 43.6606L12.7391 43.5953L12.8986 43.6642H12.895ZM12.7028 43.4395C12.7028 43.4648 12.7427 43.4866 12.7608 43.5083L12.6086 43.4431C12.5883 43.4219 12.5701 43.3989 12.5542 43.3742C12.5397 43.3996 12.5868 43.4213 12.6412 43.4395H12.7028ZM12.7028 43.3126L12.8225 43.3778C12.8354 43.389 12.8476 43.4011 12.8587 43.4141L12.7463 43.3633L12.7028 43.3162V43.3126ZM12.5868 43.2945L12.4455 43.222C12.4309 43.1996 12.4138 43.1789 12.3947 43.1603L12.5325 43.2292C12.4817 43.251 12.4962 43.2727 12.5143 43.2945H12.5868ZM12.5397 43.1241C12.5708 43.1394 12.601 43.1564 12.6303 43.1748C12.6018 43.1618 12.574 43.1472 12.547 43.1313L12.5397 43.1241ZM12.4273 43.309L12.4853 43.3851L12.3113 43.3053L12.2533 43.2292L12.4273 43.309ZM12.2533 43.0842C12.2714 43.1063 12.2884 43.1293 12.3041 43.1531L12.1446 43.0733L12.0975 43.0081L12.2533 43.0842ZM12.2533 42.9573L12.3766 43.0226C12.3859 43.0327 12.3944 43.0437 12.402 43.0552L12.286 42.9936C12.2732 42.982 12.2622 42.9685 12.2533 42.9537V42.9573ZM12.0938 42.8667L12.1373 42.9211C12.0866 42.8921 12.0358 42.8667 11.9923 42.8377C11.9791 42.8217 11.9669 42.8047 11.9561 42.7869C11.9996 42.8159 12.0503 42.8377 12.0938 42.8667ZM12.0938 42.7471L12.1881 42.8051C12.1881 42.8051 12.1881 42.8051 12.1881 42.8268L12.0975 42.7761C12.091 42.7648 12.0824 42.755 12.0721 42.7471H12.0938ZM11.9452 42.5549C11.9659 42.5661 11.9853 42.5795 12.0032 42.5948L11.9452 42.5549ZM11.9452 42.6854L11.8183 42.6057C11.8095 42.5906 11.7998 42.5761 11.7893 42.5622C11.8278 42.5897 11.8678 42.6151 11.909 42.6383C11.9219 42.6533 11.934 42.6691 11.9452 42.6854ZM11.8002 42.6854L11.8328 42.7326C11.7712 42.6999 11.7168 42.6601 11.6588 42.6311L11.6189 42.5731L11.7966 42.6891L11.8002 42.6854ZM11.6334 42.4534L11.6588 42.4861C11.6081 42.4534 11.5609 42.4172 11.5102 42.3882L11.4812 42.3447L11.6371 42.4534H11.6334ZM11.6334 42.3302C11.6661 42.3556 11.7023 42.3737 11.7313 42.3991L11.7567 42.4317L11.6516 42.3628C11.6435 42.3525 11.6362 42.3416 11.6298 42.3302H11.6334ZM11.4848 42.1236C11.5102 42.1236 11.5319 42.1598 11.5537 42.1743L11.4776 42.1199L11.4848 42.1236ZM11.4848 42.4861C11.5026 42.5088 11.5184 42.5331 11.5319 42.5586C11.4739 42.5259 11.4087 42.4897 11.3507 42.4498C11.3357 42.4197 11.3188 42.3907 11.2999 42.3628C11.3652 42.4027 11.4232 42.4462 11.4848 42.4861ZM11.3688 42.3012L11.2021 42.1888L11.1586 42.1163L11.3326 42.2396C11.3326 42.2613 11.3579 42.2794 11.3724 42.3048L11.3688 42.3012ZM11.3326 42.1199L11.4667 42.2214C11.4667 42.2214 11.3833 42.1598 11.3398 42.1344C11.2963 42.1091 11.3398 42.1344 11.3398 42.1054L11.3326 42.1199ZM11.0534 41.9314C11.0429 41.907 11.0295 41.8839 11.0136 41.8625L11.1622 41.9858L11.1948 42.0365L11.0498 41.9314H11.0534ZM10.9012 41.6595L10.8758 41.6197L11.0027 41.732V41.7538L10.8867 41.6595H10.9012ZM10.8794 41.7538L10.9266 41.8372L10.7707 41.7212L10.7199 41.6233L10.8758 41.7502L10.8794 41.7538ZM10.7634 41.5508C10.7199 41.5109 10.6692 41.4783 10.6257 41.4384C10.5822 41.3985 10.6003 41.3877 10.5858 41.3659L10.7235 41.4855L10.7598 41.5508H10.7634ZM10.7308 41.3659C10.764 41.3955 10.7955 41.427 10.825 41.4602L10.7308 41.3804V41.3478V41.3659ZM10.4915 41.1738C10.4819 41.1466 10.4685 41.121 10.4517 41.0977L10.5604 41.2028C10.5739 41.2237 10.586 41.2455 10.5967 41.268L10.4879 41.1738H10.4915ZM10.4589 41.2535L10.4915 41.3188C10.4372 41.2717 10.3864 41.2209 10.3357 41.1702C10.3269 41.1527 10.3196 41.1345 10.3139 41.1158C10.361 41.1629 10.4118 41.2064 10.4625 41.2499L10.4589 41.2535ZM10.3175 40.833C10.3422 40.8626 10.3689 40.8904 10.3973 40.9164C10.4038 40.9313 10.4111 40.9458 10.419 40.9599C10.3973 40.9345 10.3683 40.9128 10.3465 40.891C10.3397 40.8715 10.33 40.8532 10.3175 40.8366V40.833ZM10.0819 40.5938V40.572L10.1762 40.6735C10.1836 40.6861 10.1896 40.6995 10.1943 40.7134L10.0819 40.5938ZM10.0819 40.775L9.9514 40.6373C9.9514 40.601 9.9224 40.5684 9.91152 40.5321L10.0457 40.6844C10.0457 40.717 10.071 40.746 10.0819 40.7786V40.775ZM9.83177 40.3183C9.83177 40.3183 9.83178 40.2784 9.81365 40.2639C9.85353 40.311 9.88978 40.3618 9.92965 40.4125C9.93659 40.4313 9.94508 40.4495 9.95503 40.4669L9.83902 40.3364L9.83177 40.3183ZM9.72302 40.0101V39.9739L9.81727 40.1044C9.78827 40.0681 9.75927 40.0282 9.73027 39.9956L9.72302 40.0101ZM9.21551 39.3322C9.21551 39.3105 9.21551 39.2815 9.19014 39.2561C9.31701 39.4482 9.45476 39.6186 9.58889 39.8071L9.61064 39.8687C9.47651 39.6911 9.34239 39.5062 9.21551 39.3322ZM9.10675 38.9697C9.09251 38.9342 9.08041 38.8979 9.07051 38.861C9.20463 39.0857 9.34964 39.2996 9.49102 39.5099C9.4931 39.5303 9.4931 39.551 9.49102 39.5715C9.34964 39.3757 9.21551 39.1764 9.085 38.9697H9.10675ZM8.97263 38.5238C8.97263 38.4912 8.95088 38.4622 8.94363 38.4296C9.07775 38.6833 9.21913 38.9335 9.36414 39.1764C9.23001 38.9625 9.09951 38.7486 8.97263 38.5275V38.5238ZM9.30976 38.9371C9.15026 38.6543 8.99075 38.368 8.84212 38.0707L8.79862 37.9184C8.96538 38.2628 9.13213 38.6072 9.30976 38.9335V38.9371ZM8.68987 37.5197C8.68987 37.4762 8.66449 37.4327 8.65362 37.3856C8.77325 37.6719 8.89287 37.9474 9.01613 38.2193C8.84937 38.0091 8.737 37.7734 8.63187 37.5378L8.68987 37.5197ZM8.54849 36.9904C8.52312 36.8998 8.50137 36.8092 8.47599 36.7149C8.621 37.1245 8.7805 37.5269 8.94 37.9184C8.80225 37.6139 8.67175 37.3058 8.54849 36.9904ZM8.23673 35.9972C8.20773 35.8811 8.18236 35.7579 8.15336 35.6346C8.29836 36.1277 8.45062 36.6134 8.61737 37.0847C8.48324 36.7222 8.35636 36.3597 8.23673 35.9972ZM7.93947 34.6631C7.87422 34.3296 7.80535 33.9888 7.74372 33.6408C7.95398 34.6196 8.20048 35.5766 8.46874 36.501C8.28749 35.9065 8.11227 35.2939 7.9431 34.6631H7.93947ZM7.89598 17.6614C8.00835 17.3207 8.12073 16.9799 8.25848 16.6428C8.12436 16.9618 8.00835 17.2989 7.89598 17.6614ZM7.48997 18.6257C7.46097 18.7127 7.44647 18.807 7.41747 18.9048C6.74486 21.3898 6.36288 23.9445 6.27919 26.5175C6.3045 24.221 6.59646 21.9352 7.14921 19.706C7.697 17.4895 8.51898 15.3499 9.59614 13.3367C8.71325 15.0159 8.0074 16.7824 7.48997 18.6076V18.6257ZM8.46874 15.5045C8.37086 15.7329 8.28749 15.9576 8.19686 16.186C8.10623 16.4144 8.0446 16.5485 7.97935 16.737L7.85973 17.0343C6.91966 19.6906 6.33814 22.4604 6.13056 25.2705C6.22319 23.6858 6.4426 22.1111 6.7867 20.5615C7.4101 17.7127 8.47548 14.9789 9.94415 12.4594C10.1327 12.1513 10.332 11.8468 10.5314 11.5495C9.73702 12.8036 9.04598 14.1202 8.46512 15.4864L8.46874 15.5045ZM9.23726 13.3802C9.37501 13.1373 9.51639 12.8981 9.66139 12.6552C9.52001 12.8908 9.37864 13.1265 9.24089 13.3802H9.23726ZM10.2015 11.5894C9.96953 11.9302 9.75202 12.2746 9.53452 12.6262C9.82452 12.1332 10.129 11.6583 10.4444 11.1762L10.6583 10.8898C10.506 11.1145 10.3502 11.3429 10.2015 11.5749V11.5894ZM32.8873 60.3433C24.8324 60.9849 17.256 58.5307 11.5501 53.4556C5.64117 48.2536 2.22633 40.7678 1.89645 32.4083C1.53394 23.7806 4.51739 15.896 9.72302 10.0669C9.12851 10.7556 8.56299 11.4698 8.0301 12.2202C3.7915 18.2467 1.72012 25.5317 2.15383 32.8868C2.60334 41.3152 6.10518 48.7357 12.0177 53.7782C16.9369 57.9761 23.2555 60.2055 30.0707 60.2055C31.2065 60.2059 32.3416 60.1454 33.471 60.0242C40.7465 59.2557 46.5467 57.1024 51.0237 53.4991C46.3111 57.4867 40.2463 59.7922 32.8511 60.3868L32.8801 60.3614L32.8873 60.3433ZM33.4855 59.8176C25.4233 60.6695 17.8577 58.4691 12.1663 53.6115C6.29006 48.6016 2.80997 41.2209 2.37859 32.8397C2.01394 25.6908 3.99461 18.6184 8.01923 12.6987C4.057 18.575 2.15021 25.8868 2.64685 33.2856C3.21961 41.732 6.77945 49.0438 12.6775 53.8761C17.4155 57.7513 23.2337 59.7451 29.7154 59.7451C31.1933 59.7433 32.6695 59.644 34.1344 59.4479C39.572 58.7228 45.9739 57.3018 51.3173 53.0677C46.8186 56.8015 40.9351 59.0273 33.5181 59.814L33.4855 59.8176ZM34.08 59.292C25.8945 60.3795 18.5284 58.4655 12.7753 53.7528C6.90995 48.9496 3.36824 41.6813 2.80272 33.282C2.27708 25.4409 4.54639 16.7117 10.1399 10.1321C10.0348 10.2808 9.92965 10.4258 9.82453 10.578C9.17551 11.3834 8.57045 12.2232 8.01198 13.0938C5.40581 17.218 3.76395 21.8772 3.20874 26.7242C2.97077 28.272 2.8906 29.8401 2.96948 31.4042C2.96948 32.1763 3.01298 32.9557 3.0746 33.7351C3.76337 42.1924 7.38846 49.3991 13.272 54.0175C17.7707 57.5374 23.2664 59.35 29.3674 59.35C31.1524 59.3456 32.9342 59.2002 34.6963 58.915C40.9641 57.9072 47.2935 56.2977 52.336 51.9802C47.9858 55.8989 42.1132 58.219 34.0728 59.2884L34.08 59.292ZM49.8963 53.0894C50.1682 52.8973 50.44 52.6907 50.7155 52.4804C51.5309 51.9776 52.3098 51.4179 53.0465 50.8056C52.0702 51.6627 51.0155 52.4262 49.8963 53.0858V53.0894ZM51.8429 51.5633C51.9843 51.4473 52.1221 51.324 52.2635 51.2008C52.684 50.9011 53.0972 50.5785 53.5032 50.2329C52.9743 50.7072 52.4201 51.1526 51.8429 51.5669V51.5633ZM53.293 50.2184L53.4271 50.0879L53.8984 49.6927C53.6954 49.874 53.496 50.0552 53.293 50.222V50.2184ZM53.5359 48.7901L53.4779 48.8227C53.6265 48.7067 53.7751 48.5943 53.9201 48.4602C53.7969 48.569 53.6664 48.6705 53.5359 48.7792V48.7901ZM54.1558 48.5726C54.1422 48.5803 54.13 48.5901 54.1195 48.6016L54.337 48.3986C54.279 48.4602 54.2138 48.5182 54.1558 48.5726ZM53.9745 48.0433L53.8041 48.1448C54.0108 47.9998 54.2138 47.8476 54.4168 47.6953C54.2718 47.8149 54.1195 47.9309 53.9709 48.0578L53.9745 48.0433ZM53.2024 48.4783C52.8979 48.6342 52.5933 48.7756 52.2816 48.9097C52.9823 48.5515 53.6548 48.1406 54.2935 47.6808H54.3116C54.4095 47.6228 54.4965 47.5612 54.5908 47.4996C54.1463 47.8544 53.6828 48.1848 53.2024 48.4892V48.4783ZM55.0403 47.1189L54.9533 47.1769C55.1019 47.0537 55.2505 46.9304 55.3992 46.8144C55.2832 46.9232 55.1635 47.0247 55.0367 47.1334L55.0403 47.1189ZM49.5301 48.6378C47.5943 49.091 45.5897 49.5622 43.7119 50.7839C43.4762 50.9071 43.2442 51.0377 43.0195 51.179L42.7548 51.3349L42.3923 51.5162C42.164 51.6467 41.9392 51.7627 41.7144 51.8787C41.2939 52.0998 40.8843 52.3064 40.471 52.5131C39.9237 52.7668 39.3835 53.0024 38.8687 53.2381C38.354 53.4737 37.9371 53.6006 37.4876 53.771C37.0381 53.9413 36.5777 54.0682 36.1391 54.206C35.6315 54.3474 35.1313 54.4779 34.6528 54.5902C34.1743 54.7026 33.6667 54.7896 33.2027 54.8694C32.7387 54.9491 32.1768 54.9999 31.6874 55.0434C31.0857 55.0796 30.5129 55.0978 29.9764 55.0905C29.7045 55.0905 29.4363 55.0651 29.1825 55.0506C28.3533 54.9704 27.5316 54.8262 26.7247 54.6192L26.3042 54.4887C25.8862 54.338 25.4771 54.1638 25.0789 53.9667C24.6337 53.7251 24.2082 53.4487 23.8065 53.1402C23.6832 53.0387 23.56 52.9336 23.444 52.8248C23.328 52.7161 23.1286 52.4949 22.9836 52.3282C22.8386 52.1614 22.7443 52.0092 22.6211 51.8424C22.4978 51.6757 22.4833 51.6068 22.4217 51.4799L22.2622 51.1174C22.197 50.9216 22.1317 50.7295 22.0701 50.5374C21.4502 48.6342 20.8557 46.818 16.8463 45.2593L16.2591 45.0091L15.8966 44.8424L15.2984 44.5524C15.1824 44.4907 15.0628 44.4291 14.9359 44.3711C14.809 44.3131 14.664 44.2152 14.5226 44.1427L14.0949 43.889L13.5946 43.5808C13.4387 43.4685 13.2756 43.3633 13.1125 43.251L12.7173 42.9718C12.5615 42.8449 12.402 42.7217 12.2352 42.6093C12.0685 42.4969 11.9778 42.3882 11.8437 42.2794L11.6008 42.051C11.4993 41.9604 11.4087 41.8589 11.3144 41.7647C11.1223 41.5725 10.9519 41.3695 10.7598 41.1593C10.6692 41.0505 10.5822 40.9418 10.4952 40.8294C10.3357 40.6083 10.1762 40.3799 10.0239 40.1442C9.96228 40.0427 9.90427 39.9376 9.84265 39.8325C9.71214 39.5896 9.58527 39.3431 9.45839 39.0821C9.39676 38.9407 9.33151 38.7993 9.27351 38.658C9.16838 38.3861 9.06688 38.107 8.96538 37.8206C8.96538 37.7843 8.94363 37.7517 8.93275 37.7191C7.44646 32.4917 5.60855 22.4502 9.87528 13.75C10.3051 12.8746 10.7894 12.0271 11.3253 11.2124C11.8651 10.3914 12.4598 9.60779 13.1052 8.86697C13.7557 8.11434 14.4531 7.40361 15.1933 6.73904C15.955 6.05682 16.7564 5.42012 17.5931 4.83225C18.4754 4.2274 19.3889 3.66956 20.33 3.16108C21.4828 2.52675 22.6728 1.96262 23.8935 1.47179C25.0948 0.964098 26.3594 0.621434 27.6527 0.453136C28.7251 0.353427 29.8022 0.313489 30.8791 0.333508C35.1381 0.331966 39.3498 1.22525 43.2416 2.95547C47.1333 4.68569 50.618 7.21425 53.4701 10.3773C56.3221 13.5403 58.4778 17.2673 59.7974 21.3167C61.1171 25.3661 61.5712 29.6476 61.1304 33.8837C61.1304 33.9925 61.0978 34.0976 61.0833 34.21C61.0616 34.3514 61.0398 34.4891 61.0108 34.6269C60.9818 34.7646 60.9564 34.906 60.9347 35.0474L60.8585 35.4679C60.7715 35.9681 60.6737 36.4539 60.5685 36.9179V36.9687C60.467 37.4218 60.351 37.8604 60.2314 38.2918C60.2184 38.3274 60.2075 38.3637 60.1988 38.4006C59.7388 40.0082 59.1094 41.5625 58.321 43.0371C58.0854 43.4612 57.8425 43.8745 57.596 44.266C57.4727 44.4472 57.3531 44.6285 57.2335 44.7952C57.1537 44.9004 57.0703 45.0055 56.9833 45.107C56.8963 45.2085 56.8093 45.3064 56.7223 45.397C54.4639 47.5068 51.9771 48.0868 49.5519 48.6596L49.5301 48.6378Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.3482 -16.9655L77.2331 24.4113L32.9925 77.7509L-16.8924 36.3741L27.3482 -16.9655Z",
    fill: "url(#paint0_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.022 27.7102L34.3011 27.9386L34.0691 28.2177L33.79 27.9857L34.022 27.7102Z",
    fill: "url(#paint1_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0292 27.8116L33.877 27.9965L34.0619 28.1488L34.2141 27.9639L34.0292 27.8116ZM34.0075 27.5579L34.4679 27.9421L34.0836 28.4025L33.6232 28.04L34.0075 27.5579Z",
    fill: "url(#paint2_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0148 27.6231L33.7066 27.9857L34.0691 28.2938L34.3773 27.9313L34.0148 27.6231ZM33.9894 27.3694L34.6383 27.9059L34.1018 28.5548L33.4529 28.0183L33.9749 27.3694H33.9894Z",
    fill: "url(#paint3_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9966 27.4492L33.5362 28.0075L34.0945 28.4678L34.5549 27.9096L33.9966 27.4492ZM33.9749 27.1954L34.8086 27.8878L34.1162 28.7216L33.2825 28.0292L33.9749 27.1954Z",
    fill: "url(#paint4_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9749 27.286L33.3623 28.011L34.0873 28.6273L34.6999 27.8841L33.9749 27.2715V27.286ZM33.9531 27.0322L34.9718 27.8769L34.1308 28.8991L33.1121 28.0545L33.9531 27.0322Z",
    fill: "url(#paint5_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9749 27.1157L33.2063 28.0401L34.1307 28.8086L34.8993 27.8842L33.9749 27.1157ZM33.9495 26.8619L35.153 27.8588L34.1561 29.0624L32.9526 28.0655L33.9495 26.8619Z",
    fill: "url(#paint6_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9495 26.9453L33.0287 28.0582L34.1416 28.979L35.0624 27.8697L33.9495 26.9453ZM33.9277 26.6915L35.3161 27.8443L34.1634 29.2327L32.775 28.0799L33.9277 26.6915Z",
    fill: "url(#paint7_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.935 26.7749L32.8475 28.0727L34.1453 29.1602L35.2328 27.8624L33.935 26.7749ZM33.9096 26.5211L35.4866 27.8298L34.1815 29.4031L32.6046 28.098L33.9096 26.5211Z",
    fill: "url(#paint8_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9205 26.6081L32.6916 28.0872L34.1706 29.3161L35.3995 27.837L33.9205 26.6081ZM33.8951 26.3544L35.6569 27.8044L34.2068 29.5662L32.4487 28.1162L33.8987 26.358L33.8951 26.3544Z",
    fill: "url(#paint9_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9024 26.4377L32.5248 28.1053L34.1924 29.4864L35.5699 27.8116L33.9024 26.4377ZM33.8806 26.184L35.8237 27.8116L34.2105 29.7547L32.2675 28.1415L33.8806 26.184Z",
    fill: "url(#paint10_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8878 26.2674L32.3508 28.1198L34.2032 29.6569L35.7403 27.8117L33.8878 26.2747V26.2674ZM33.8625 26.0137L35.994 27.7827L34.2286 29.9106L32.097 28.1452L33.8625 26.0137Z",
    fill: "url(#paint11_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8734 26.1006L32.1805 28.1379L34.2178 29.8272L35.9107 27.7899L33.8734 26.1006ZM33.848 25.8433L36.1644 27.7646L34.2431 30.081L31.9267 28.1742L33.848 25.8433Z",
    fill: "url(#paint12_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8553 25.9303L32.0137 28.1525L34.2359 29.9867L36.0774 27.7646L33.8553 25.9303ZM33.8335 25.6765L36.3312 27.7501L34.2576 30.2478L31.7599 28.1742L33.8335 25.6765Z",
    fill: "url(#paint13_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8408 25.7599L31.8433 28.1742L34.2504 30.1716L36.2478 27.7645L33.8408 25.7599ZM33.8154 25.5061L36.5125 27.7319L34.2867 30.4181L31.6005 28.1923L33.8154 25.5061Z",
    fill: "url(#paint14_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8263 25.5894L31.6729 28.1741L34.2685 30.3492L36.4182 27.7573L33.8263 25.604V25.5894ZM33.8009 25.3357L36.6719 27.7174L34.2903 30.5885L31.4373 28.2068L33.8009 25.3357Z",
    fill: "url(#paint15_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8081 25.4227L31.5025 28.1995L34.283 30.5051L36.5885 27.7246L33.8081 25.4227ZM33.7863 25.1689L36.8423 27.7065L34.3047 30.7625L31.2488 28.2249L33.7863 25.1689Z",
    fill: "url(#paint16_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7936 25.2523L31.3358 28.214L34.2975 30.6718L36.7553 27.7101L33.7936 25.2523ZM33.7682 24.9985L37.009 27.6847L34.3373 30.9292L31.0748 28.2394L33.7682 24.9985Z",
    fill: "url(#paint17_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7755 25.082L31.1654 28.2322L34.3156 30.8423L36.9257 27.6957L33.7755 25.082ZM33.7538 24.8282L37.1795 27.6703L34.3374 31.096L30.9117 28.254L33.7538 24.8282Z",
    fill: "url(#paint18_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.761 24.9116L30.995 28.2467L34.3301 31.0126L37.0961 27.6775L33.761 24.9116ZM33.7392 24.6578L37.3643 27.6558L34.3664 31.2809L30.7413 28.2866L33.7392 24.6578Z",
    fill: "url(#paint19_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7465 24.7448L30.8283 28.2612L34.3374 31.183L37.2592 27.663L33.7465 24.7448ZM33.7211 24.4911L37.5202 27.6377L34.37 31.4368L30.5709 28.2866L33.7211 24.4911Z",
    fill: "url(#paint20_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7283 24.5744L30.6579 28.2793L34.3627 31.3497L37.4332 27.6449L33.7283 24.5744ZM33.7066 24.3207L37.6942 27.6231L34.3917 31.6107L30.4041 28.3083L33.7066 24.3207Z",
    fill: "url(#paint21_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7139 24.404L30.4875 28.2937L34.3772 31.5201L37.6 27.6304L33.7102 24.404H33.7139ZM33.6885 24.1503L37.8573 27.6086L34.4026 31.7738L30.2338 28.3191L33.6885 24.1503Z",
    fill: "url(#paint22_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6994 24.2337L30.3171 28.312L34.3917 31.6905L37.774 27.6159L33.6994 24.2337ZM33.674 23.98L38.0241 27.6051L34.399 31.9552L30.0489 28.3301L33.674 23.98Z",
    fill: "url(#paint23_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6812 24.067L30.1504 28.3265L34.4099 31.8609L37.9407 27.5978L33.6812 24.067ZM33.6595 23.8132L38.1945 27.5761L34.4316 32.1147L29.893 28.3482L33.6595 23.8132Z",
    fill: "url(#paint24_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6667 23.8966L29.9873 28.3409L34.4316 32.0277L38.1183 27.5833L33.6667 23.8966ZM33.6414 23.6428L38.354 27.5579L34.4389 32.2705L29.7263 28.3554L33.6414 23.6428Z",
    fill: "url(#paint25_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6523 23.7262L29.8097 28.359L34.4389 32.198L38.2815 27.5688L33.6523 23.7262ZM33.6124 23.4615L38.5208 27.5325L34.4643 32.4518L29.5559 28.3808L33.6124 23.4615Z",
    fill: "url(#paint26_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6341 23.5594L29.6248 28.3735L34.4425 32.3611L38.4301 27.5434L33.6124 23.5558L33.6341 23.5594ZM33.6124 23.302L38.7056 27.5289L34.4788 32.604L29.4036 28.3771L33.6124 23.302Z",
    fill: "url(#paint27_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6124 23.389L29.4725 28.388L34.4715 32.5242L38.6186 27.5216L33.6124 23.389ZM33.587 23.1353L38.8651 27.5107L34.4969 32.7925L29.2188 28.4134L33.6124 23.1353H33.587Z",
    fill: "url(#paint28_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6123 23.2187L29.3021 28.4062L34.4896 32.7056L38.789 27.5217L33.6123 23.2187ZM33.5869 22.965L39.05 27.4963L34.5113 32.9593L29.0483 28.428L33.5797 22.965H33.5869Z",
    fill: "url(#paint29_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.587 23.0483L29.1317 28.4207L34.5041 32.8868L38.9594 27.5144L33.587 23.0483ZM33.5652 22.7946L39.2131 27.4818L34.5259 33.1297L28.878 28.4461L33.5652 22.7946Z",
    fill: "url(#paint30_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5725 22.8815L28.9613 28.4352L34.5186 33.0463L39.1297 27.489L33.5725 22.8815ZM33.5471 22.6241L39.3835 27.4491L34.544 33.2855L28.7076 28.446L33.5471 22.6241Z",
    fill: "url(#paint31_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5544 22.7112L28.7946 28.4533L34.5368 33.213L39.2965 27.4745L33.5544 22.7112ZM33.5326 22.4574L39.5503 27.4491L34.5585 33.4668L28.5372 28.475L33.529 22.4574H33.5326Z",
    fill: "url(#paint32_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5399 22.5407L28.6242 28.4678L34.5513 33.3834L39.4669 27.4491L33.5399 22.5407ZM33.5181 22.287L39.7206 27.4491L34.573 33.6516L28.3705 28.4931L33.5181 22.287Z",
    fill: "url(#paint33_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5253 22.3741L28.4502 28.486L34.5621 33.5611L39.6372 27.4492L33.5253 22.3741ZM33.5 22.1203L39.891 27.4202L34.5911 33.8076L28.2001 28.5077L33.5 22.1167V22.1203Z",
    fill: "url(#paint34_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5072 22.2036L28.2835 28.5004L34.5839 33.7241L39.804 27.4273L33.5072 22.2036ZM33.4855 21.9498L40.0614 27.3875L34.6056 33.9743L28.0297 28.5366L33.4855 21.9607V21.9498Z",
    fill: "url(#paint35_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4927 22.0333L28.1167 28.515L34.5984 33.891L39.9744 27.4093L33.4927 22.0333ZM33.4674 21.7795L40.2282 27.3876L34.6238 34.1484L27.863 28.5367L33.4674 21.7795Z",
    fill: "url(#paint36_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4782 21.8629L27.9463 28.5367L34.6129 34.0649L40.1375 27.3948L33.4782 21.8629ZM33.4528 21.6091L40.3985 27.3694L34.6382 34.3151L27.6926 28.5548L33.4528 21.6091Z",
    fill: "url(#paint37_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4601 21.6925L27.776 28.5366L34.631 34.2208L40.3152 27.3766L33.4601 21.6925ZM33.4384 21.4387L40.5689 27.3549L34.6528 34.4854L27.5222 28.5693L33.4384 21.4387Z",
    fill: "url(#paint38_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4456 21.5257L27.6092 28.562L34.6455 34.4021L40.5 27.3621L33.4456 21.5257ZM33.4202 21.272L40.7393 27.3404L34.6709 34.6558L27.3518 28.5874L33.4202 21.2865V21.272Z",
    fill: "url(#paint39_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4311 21.3553L27.4497 28.5801L34.6636 34.5688L40.6523 27.3476L33.4311 21.3553ZM33.4057 21.1016L40.906 27.3222L34.6999 34.8225L27.1851 28.6019L33.4057 21.1016Z",
    fill: "url(#paint40_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.413 21.185L27.2685 28.5946L34.6782 34.7573L40.8227 27.3476L33.413 21.185ZM33.3912 20.9312L41.0764 27.3077L34.6999 34.9929L27.0147 28.62L33.3912 20.924V20.9312Z",
    fill: "url(#paint41_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3984 21.0146L27.0872 28.6092L34.6998 34.9096L41.0003 27.315L33.3876 21.0146H33.3984ZM33.3731 20.7609L41.2468 27.286L34.7216 35.1597L26.8479 28.6346L33.3731 20.7609Z",
    fill: "url(#paint42_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.384 20.8479L26.9313 28.6273L34.6999 35.0619L41.1489 27.286L33.3731 20.8334L33.384 20.8479ZM33.3586 20.5941L41.4135 27.2752L34.7325 35.3337L26.6776 28.6491L33.3586 20.5941Z",
    fill: "url(#paint43_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3658 20.6775L26.7609 28.6527L34.7361 35.2576L41.341 27.2824L33.3658 20.6775ZM33.3441 20.4237L41.5875 27.2606L34.7506 35.5005L26.5071 28.6672L33.3441 20.4237Z",
    fill: "url(#paint44_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3513 20.5071L26.5906 28.6563L34.7398 35.4243L41.5006 27.2678L33.3513 20.5071ZM33.326 20.2533L41.7543 27.2425L34.7651 35.6708L26.3368 28.6816L33.326 20.2533Z",
    fill: "url(#paint45_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3332 20.3403L26.4238 28.678L34.7615 35.5911L41.6746 27.2534L33.3332 20.3403ZM33.3115 20.0865L41.9247 27.228L34.7797 35.8412L26.1664 28.6961L33.3115 20.0865Z",
    fill: "url(#paint46_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3188 20.17L26.2535 28.689L34.7724 35.7543L41.8377 27.2353L33.3188 20.17ZM33.2934 19.9163L42.0915 27.2136L34.7942 36.0117L25.9997 28.7144L33.2934 19.9163Z",
    fill: "url(#paint47_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3042 19.9996L26.083 28.6998L34.7833 35.921L42.0044 27.2208L33.3042 19.9996ZM33.2788 19.7458L42.2618 27.1954L34.8123 36.1784L25.8293 28.7288L33.2788 19.7458Z",
    fill: "url(#paint48_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2861 19.8365L25.9127 28.7216L34.805 36.0951L42.1785 27.2063L33.2861 19.8365ZM33.2644 19.5828L42.4322 27.1955L34.8195 36.3633L25.6517 28.7506L33.2644 19.5828Z",
    fill: "url(#paint49_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2716 19.6624L25.7423 28.7252L34.805 36.2545L42.3343 27.1918L33.2716 19.6624ZM33.2462 19.4087L42.6026 27.1664L34.8449 36.5119L25.4885 28.7542L33.2462 19.4087Z",
    fill: "url(#paint50_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2498 19.492L25.5755 28.7541L34.834 36.4321L42.5156 27.1736L33.2498 19.492ZM33.2245 19.2383L42.7621 27.1482L34.8594 36.6858L25.3218 28.7759L33.2245 19.2383Z",
    fill: "url(#paint51_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2498 19.3217L25.4051 28.7687L34.8521 36.6026L42.6751 27.1556L33.2498 19.3217ZM33.2281 19.068L42.9506 27.1338L34.8739 36.8744L25.1514 28.7941L33.2172 19.068H33.2281Z",
    fill: "url(#paint52_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2245 19.1513L25.2493 28.7832L34.8811 36.7584L42.8563 27.1265L33.2245 19.1513ZM33.1991 18.8976L43.1101 27.1157L34.892 37.0267L24.981 28.8086L33.1991 18.8976Z",
    fill: "url(#paint53_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2099 18.9846L25.068 28.8013L34.8847 36.9433L43.0376 27.1265L33.2099 18.9846ZM33.1846 18.7308L43.2804 27.0867L34.9065 37.1825L24.8106 28.8086L33.1846 18.749V18.7308Z",
    fill: "url(#paint54_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1919 18.8142L24.9122 28.8158L34.9138 37.11L43.208 27.1084L33.1919 18.8142ZM33.1701 18.5604L43.4473 27.0866L34.9211 37.3638L24.6439 28.8376L33.1701 18.5604Z",
    fill: "url(#paint55_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1774 18.6438L24.7273 28.8303L34.9138 37.2804L43.3639 27.0866L33.1774 18.6438ZM33.152 18.39L43.6176 27.0866L34.9392 37.5341L24.4735 28.8556L33.152 18.39Z",
    fill: "url(#paint56_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1628 18.4771L24.5496 28.8485L34.9246 37.4508L43.5342 27.0867L33.1628 18.4771ZM33.1374 18.2197L43.788 27.0541L34.9536 37.7046L24.3031 28.8702L33.1374 18.2197Z",
    fill: "url(#paint57_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1447 18.3066L24.3901 28.8629L34.9464 37.6175L43.701 27.0612L33.1447 18.3066ZM33.1229 18.0529L43.9583 27.0395L34.9717 37.8749L24.1364 28.8991L33.1229 18.0637V18.0529Z",
    fill: "url(#paint58_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1302 18.1363L24.2198 28.8774L34.9609 37.7879L43.8714 27.0468L33.1302 18.1363ZM33.1049 17.8825L44.1251 27.0214L34.9863 38.0417L23.966 28.8992L33.1049 17.8789V17.8825Z",
    fill: "url(#paint59_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1121 17.9659L24.0493 28.8992L34.979 37.9619L44.0417 27.0323L33.1121 17.9695V17.9659ZM33.0903 17.7122L44.2955 27.0069L35.0007 38.212L23.7956 28.9173L33.0903 17.7122Z",
    fill: "url(#paint60_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0976 17.7991L23.879 28.8992L34.9935 38.1178L44.2121 27.0141L33.0976 17.7991ZM33.0722 17.5417L44.4659 26.9924L35.0153 38.3824L23.6252 28.9354L33.0722 17.5417Z",
    fill: "url(#paint61_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0831 17.6288L23.7122 28.9245L35.008 38.2954L44.3789 26.9996L33.0831 17.6288ZM33.0577 17.375L44.6326 26.9742L35.0334 38.5528L23.4621 28.9499L33.0613 17.375H33.0577Z",
    fill: "url(#paint62_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.065 17.4583L23.5418 28.9426L35.0261 38.4657L44.5492 26.9815L33.065 17.4583ZM33.0432 17.2046L44.803 26.9597L35.0624 38.7195L23.2881 28.9644L33.0432 17.2046Z",
    fill: "url(#paint63_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0505 17.2989L23.3715 28.9681L35.0407 38.6471L44.7197 26.9779L33.0505 17.2989ZM33.0251 17.0452L44.9879 26.9561L35.0624 38.8899L23.0996 28.9826L33.007 17.0198L33.0251 17.0452Z",
    fill: "url(#paint64_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.036 17.1213L23.2047 28.9754L35.0624 38.8066L44.8973 26.9526L33.036 17.1213ZM33.0106 16.8676L45.1438 26.9272L35.0805 39.0495L22.9473 28.9971L33.0106 16.8676Z",
    fill: "url(#paint65_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0178 16.9364L23.0343 28.9898L35.0624 38.9733L45.0459 26.9344L33.0178 16.9364ZM32.9961 16.6826L45.3214 26.8981L35.1059 39.2234L22.7806 29.0079L32.9961 16.6826Z",
    fill: "url(#paint66_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0033 16.7805L22.8531 29.0043L35.0769 39.1545L45.2271 26.9307L33.0033 16.7805ZM32.9779 16.5267L45.4809 26.8945L35.1131 39.4119L22.6102 29.0442L32.9779 16.5267Z",
    fill: "url(#paint67_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9888 16.6101L22.6936 29.0224L35.1022 39.314L45.3975 26.9053L32.9888 16.6101ZM32.9634 16.3563L45.6513 26.8691L35.1385 39.5569L22.4507 29.0441L32.9634 16.3563Z",
    fill: "url(#paint68_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9707 16.4433L22.5268 29.0369L35.1204 39.4844L45.5752 26.8872L32.9707 16.4433ZM32.949 16.1896L45.8217 26.8655L35.1422 39.7382L22.2695 29.0586L32.949 16.1896Z",
    fill: "url(#paint69_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9562 16.273L22.3746 29.0515L35.1349 39.6513L45.7347 26.8728L32.9562 16.273ZM32.9309 16.0193L45.9812 26.8474L35.153 39.8978L22.1027 29.0696L32.9309 16.0193Z",
    fill: "url(#paint70_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9381 16.1026L22.1861 29.0696L35.153 39.8216L45.905 26.8583L32.9381 16.1026ZM32.9163 15.8489L46.1588 26.8329L35.1748 40.0754L21.9323 29.0913L32.9163 15.8489Z",
    fill: "url(#paint71_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9236 15.9322L22.0121 29.0841L35.1675 39.9919L46.0754 26.8401L32.9236 15.9322ZM32.9019 15.6785L46.3147 26.8184L35.1748 40.2312L21.762 29.0949L32.9019 15.6821V15.6785Z",
    fill: "url(#paint72_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9091 15.7655L21.8489 29.0986L35.182 40.1623L46.2422 26.8256L32.9091 15.7655ZM32.8837 15.5117L46.4995 26.8003L35.2074 40.4161L21.5916 29.1239L32.8873 15.5117H32.8837Z",
    fill: "url(#paint73_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8873 15.5951L21.6786 29.1167L35.2001 40.3291L46.4125 26.8111L32.8873 15.5951ZM32.8656 15.3413L46.6627 26.7857L35.2183 40.5828L21.4248 29.1384L32.8656 15.3413Z",
    fill: "url(#paint74_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8873 15.4248L21.5082 29.1312L35.2146 40.4995L46.5829 26.7931L32.8873 15.4248ZM32.8656 15.171L46.8476 26.7713L35.2473 40.7533L21.2617 29.153L32.8656 15.171Z",
    fill: "url(#paint75_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.862 15.258L21.3378 29.1457L35.2291 40.6699L46.7533 26.7785L32.862 15.258ZM32.8366 15.0006L47.0252 26.7532L35.2726 40.9236L21.084 29.1711L32.8366 15.0006Z",
    fill: "url(#paint76_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8439 15.0876L21.1711 29.1638L35.2473 40.8366L46.9201 26.7604L32.8439 15.0876ZM32.8221 14.8339L47.1738 26.7242L35.269 41.0795L20.9246 29.1856L32.8221 14.8339Z",
    fill: "url(#paint77_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8294 14.9172L21.0007 29.1783L35.2618 41.007L47.0905 26.7459L32.8294 14.9172ZM32.804 14.6635L47.3442 26.7241L35.2872 41.2607L20.7469 29.2037L32.804 14.6635Z",
    fill: "url(#paint78_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8148 14.7613L20.8303 29.1964L35.2763 41.1773L47.2608 26.7241L32.8148 14.7613ZM32.7894 14.5075L47.5146 26.7241L35.3016 41.4492L20.562 29.2182L32.7749 14.493L32.7894 14.5075Z",
    fill: "url(#paint79_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7967 14.5801L20.6599 29.211L35.2944 41.3478L47.4312 26.7242L32.7967 14.5801ZM32.7749 14.3228L47.6849 26.6916L35.3161 41.5871L20.4061 29.2327L32.7749 14.3228Z",
    fill: "url(#paint80_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7822 14.3988L20.4931 29.2254L35.3089 41.5145L47.5979 26.6987L32.7822 14.3988ZM32.7568 14.145L47.8517 26.6625L35.3343 41.7682L20.2394 29.2616L32.7568 14.1668V14.145Z",
    fill: "url(#paint81_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7677 14.2394L20.3228 29.2617L35.327 41.703L47.7683 26.7024L32.7677 14.2394ZM32.7423 13.9856L48.0221 26.6734L35.3343 41.9532L20.069 29.2617L32.7423 13.9856Z",
    fill: "url(#paint82_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7496 14.0689L20.1524 29.2617L35.3415 41.8589L47.9387 26.6698L32.7496 14.0726V14.0689ZM32.7278 13.8152L48.1925 26.6444L35.3633 42.109L19.8986 29.2798L32.7278 13.8152Z",
    fill: "url(#paint83_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7351 13.9022L19.9857 29.2617L35.356 42.0148L48.1127 26.6516L32.7351 13.9022ZM32.7097 13.6484L48.3629 26.6263L35.3814 42.2794L19.7283 29.298L32.7097 13.6484Z",
    fill: "url(#paint84_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.717 13.7318L19.8153 29.2907L35.3742 42.1924L48.2759 26.6371L32.717 13.7318ZM32.6952 13.478L48.5296 26.6117L35.3959 42.4497L19.5615 29.3124L32.6952 13.478Z",
    fill: "url(#paint85_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7024 13.5614L19.6521 29.3051L35.3959 42.3555L48.4462 26.6117L32.7024 13.5614ZM32.6807 13.3076L48.7 26.5972L35.4249 42.6165L19.402 29.3305L32.6807 13.3076Z",
    fill: "url(#paint86_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.688 13.3911L19.4745 29.3197L35.4032 42.5332L48.6166 26.6045L32.688 13.3911ZM32.6626 13.1373L48.8704 26.5792L35.4249 42.7869L19.2208 29.3451L32.6626 13.1373Z",
    fill: "url(#paint87_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6698 13.2243L19.3077 29.3379L35.4249 42.7036L48.787 26.5864L32.6698 13.2243ZM32.6481 12.9706L49.0407 26.5647L35.443 42.9573L19.0504 29.3596L32.6481 12.9706Z",
    fill: "url(#paint88_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6553 13.0539L19.1374 29.3668L35.4503 42.8848L48.9682 26.5719L32.6553 13.0539ZM32.6336 12.8002L49.2002 26.5501L35.4611 43.1241L18.8836 29.3777L32.6336 12.8002Z",
    fill: "url(#paint89_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6408 12.8835L18.967 29.3704L35.4502 43.037L49.1241 26.5537L32.6408 12.8835ZM32.6154 12.6298L49.3778 26.532L35.4756 43.2944L18.7132 29.3922L32.6154 12.6298Z",
    fill: "url(#paint90_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6227 12.7167L18.7966 29.3921L35.472 43.2182L49.2981 26.5428L32.6227 12.7167ZM32.601 12.4594L49.5627 26.5175L35.5046 43.4647L18.5428 29.4066L32.601 12.463V12.4594Z",
    fill: "url(#paint91_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6082 12.5464L18.6298 29.3994L35.4829 43.3778L49.4612 26.5247L32.6082 12.5464ZM32.5828 12.2926L49.7186 26.503L35.5083 43.6351L18.387 29.4248L32.5828 12.2926Z",
    fill: "url(#paint92_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5937 12.3761L18.4559 29.414L35.4938 43.5518L49.6317 26.5139L32.5937 12.3761ZM32.5684 12.1223L49.8854 26.4849L35.5228 43.802L18.2057 29.4394L32.5684 12.1223Z",
    fill: "url(#paint93_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5756 12.2238L18.2891 29.4321L35.5155 43.7186L49.802 26.4921L32.5756 12.2238ZM32.5538 11.97L50.0558 26.4704L35.5373 43.9723L18.0245 29.4538L32.543 11.9519L32.5538 11.97Z",
    fill: "url(#paint94_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5611 12.0389L18.1187 29.4393L35.5192 43.8817L49.9615 26.4812L32.5611 12.0425V12.0389ZM32.5357 11.7815L50.2262 26.4522L35.5554 44.1427L17.865 29.4719L32.5249 11.7815H32.5357Z",
    fill: "url(#paint95_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5465 11.8613L17.9519 29.4647L35.5481 44.0594L50.1391 26.4632L32.5465 11.8613ZM32.5212 11.6075L50.3929 26.4305L35.5699 44.3131L17.6982 29.4865L32.5212 11.6075Z",
    fill: "url(#paint96_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5248 11.6981L17.7816 29.4792L35.5445 44.226L50.2914 26.445L32.5248 11.6981ZM32.5031 11.4443L50.5597 26.4232L35.5844 44.487L17.5278 29.5009L32.5248 11.4443H32.5031Z",
    fill: "url(#paint97_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5248 11.5278L17.6112 29.4938L35.5771 44.3965L50.4799 26.4305L32.5248 11.5278ZM32.4994 11.274L50.7445 26.4052L35.6134 44.6503L17.3574 29.5191L32.4885 11.274H32.4994Z",
    fill: "url(#paint98_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4958 11.3611L17.4408 29.5119L35.5953 44.5669L50.6503 26.4161L32.4958 11.3611ZM32.4741 11.1073L50.904 26.3907L35.617 44.8206L17.1871 29.5336L32.4741 11.1073Z",
    fill: "url(#paint99_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4813 11.1906L17.2741 29.5264L35.6098 44.7517L50.817 26.3979L32.4813 11.1906ZM32.4596 10.9369L51.0708 26.3616L35.6315 44.9729L17.0203 29.5517L32.4596 10.9369Z",
    fill: "url(#paint100_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4668 11.0202L17.1037 29.5408L35.6243 44.904L50.9874 26.3834L32.4668 11.0202ZM32.4415 10.7665L51.2412 26.3544L35.6533 45.1541L16.8536 29.5662L32.4415 10.7665Z",
    fill: "url(#paint101_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4487 10.8498L16.9369 29.5589L35.646 45.0743L51.1578 26.3616L32.4487 10.8462V10.8498ZM32.427 10.5961L51.4116 26.3616L35.6642 45.3462L16.6796 29.5807L32.427 10.5961Z",
    fill: "url(#paint102_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4342 10.6831L16.7665 29.5734L35.6569 45.2447L51.3281 26.3616L32.4342 10.6831ZM32.4088 10.4293L51.5819 26.329L35.6786 45.4984L16.5092 29.5988L32.4088 10.4293Z",
    fill: "url(#paint103_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4197 10.5127L16.5962 29.5915L35.6714 45.4114L51.4949 26.3362L32.4197 10.5127ZM32.3943 10.2589L51.7378 26.3108L35.6859 45.6652L16.3424 29.6241L32.3943 10.2698V10.2589Z",
    fill: "url(#paint104_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4016 10.3424L16.4258 29.6242L35.6895 45.5746L51.6653 26.3182L32.4016 10.3424ZM32.3798 10.0886L51.9191 26.2964L35.7113 45.8356L16.1721 29.6242L32.3798 10.0886Z",
    fill: "url(#paint105_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3871 10.172L16.2554 29.6242L35.704 45.7559L51.8357 26.3072L32.3871 10.172ZM32.3617 9.91821L52.1003 26.2819L35.7403 46.006L16.0016 29.646L32.3617 9.91821Z",
    fill: "url(#paint106_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3726 10.0052L16.0887 29.6242L35.7185 45.9371L52.0025 26.2891L32.3726 10.0052ZM32.3472 9.75146L52.2598 26.2638L35.7439 46.1764L15.8494 29.6605L32.3472 9.75146Z",
    fill: "url(#paint107_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3545 9.83481L15.9183 29.6532L35.7367 46.0893L52.1728 26.271L32.3545 9.83481ZM32.3327 9.58105L52.4266 26.2565L35.7512 46.3503L15.6573 29.6749L32.3327 9.58105Z",
    fill: "url(#paint108_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.34 9.6644L15.7479 29.6677L35.7512 46.2597L52.3432 26.2564L32.34 9.6644ZM32.3146 9.41064L52.6151 26.2311L35.7947 46.5316L15.4869 29.693L32.3074 9.41064H32.3146Z",
    fill: "url(#paint109_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3255 9.49774L15.5775 29.6859L35.7874 46.4302L52.5317 26.242L32.3436 9.49411L32.3255 9.49774ZM32.3001 9.24036L52.7673 26.2167L35.7874 46.6839L15.3238 29.7076L32.3001 9.24036Z",
    fill: "url(#paint110_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3073 9.3237L15.4107 29.6967L35.7874 46.5969L52.6839 26.2239L32.3073 9.3237ZM32.2855 9.06995L52.9486 26.1985L35.82 46.8615L15.157 29.733L32.2855 9.06995Z",
    fill: "url(#paint111_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2928 9.15695L15.2549 29.7148L35.8128 46.7528L52.8507 26.1949L32.2928 9.15695ZM32.2674 8.9032L53.1045 26.184L35.8237 47.0247L14.9866 29.7402L32.2674 8.9032Z",
    fill: "url(#paint112_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2747 8.98654L15.07 29.7329L35.8164 46.9376L53.0211 26.1948L32.2747 8.98654ZM32.2529 8.73279L53.2784 26.1695L35.8417 47.195L14.8162 29.7583L32.2529 8.73279Z",
    fill: "url(#paint113_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2602 8.81976L14.8996 29.7474L35.8309 47.108L53.1878 26.1767L32.2602 8.81976ZM32.2384 8.56238L53.4452 26.1549L35.8563 47.3617L14.6459 29.7728L32.2384 8.56238Z",
    fill: "url(#paint114_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2457 8.64939L14.7329 29.7619L35.8454 47.2747L53.3582 26.1622L32.2457 8.64939ZM32.2203 8.39563L53.6084 26.1368L35.8672 47.5249L14.4791 29.78L32.2203 8.39563Z",
    fill: "url(#paint115_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2276 8.4791L14.5625 29.7801L35.8636 47.4452L53.5286 26.1442L32.2276 8.4791ZM32.2058 8.22534L53.7824 26.1224L35.8853 47.699L14.3088 29.8019L32.2058 8.22534Z",
    fill: "url(#paint116_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.213 8.30869L14.3994 29.7946L35.8853 47.6155L53.7062 26.1296L32.213 8.30869ZM32.1913 8.05493L53.9418 26.1079L35.8925 47.8584L14.142 29.8091L32.1913 8.05493Z",
    fill: "url(#paint117_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1986 8.14191L14.2254 29.8127L35.8926 47.7859L53.8694 26.1151L32.1986 8.14191ZM32.1623 7.87366L54.1123 26.0752L35.9179 48.0397L13.968 29.8345L32.1623 7.87366Z",
    fill: "url(#paint118_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1804 7.97153L14.055 29.8272L35.9106 47.9527L54.0361 26.097L32.1804 7.97153ZM32.1587 7.71777L54.2753 26.0752L35.9324 48.2064L13.8012 29.849L32.1587 7.71777Z",
    fill: "url(#paint119_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1623 7.80112L13.8846 29.8417L35.9252 48.1121L54.2065 26.0716L32.1623 7.80112ZM32.1369 7.54736L54.4566 26.0607L35.9469 48.3768L13.6309 29.867L32.1369 7.54736Z",
    fill: "url(#paint120_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1623 7.63083L13.7142 29.8599L35.9396 48.2935L54.3768 26.068L32.1623 7.63083ZM32.1369 7.37708L54.6378 26.0427L35.965 48.5472L13.4604 29.8816L32.1369 7.37708Z",
    fill: "url(#paint121_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1333 7.46408L13.5475 29.8744L35.9578 48.4747L54.5436 26.0608L32.1333 7.46408ZM32.1116 7.21033L54.801 26.0282L35.9795 48.7176L13.2901 29.8961L32.1116 7.21033Z",
    fill: "url(#paint122_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1188 7.29367L13.3771 29.8889L35.9723 48.6306L54.714 26.0354L32.1188 7.29367ZM32.0935 7.03992L54.9678 25.9991L35.9977 48.8735L13.1234 29.9142L32.0935 7.03992Z",
    fill: "url(#paint123_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1007 7.12326L13.2067 29.907L35.9904 48.8009L54.8844 26.0209L32.1007 7.12326ZM32.0789 6.86951L55.1381 25.9991L36.0122 49.0547L12.9493 29.9287L32.0789 6.86951Z",
    fill: "url(#paint124_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0862 6.95285L13.0364 29.9214L36.0049 48.9713L55.0548 25.9991L32.0862 6.95285ZM32.0644 6.6991L55.3085 25.9991L36.0267 49.2432L12.7826 29.9432L32.0644 6.6991Z",
    fill: "url(#paint125_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0717 6.7861L12.8587 29.9359L36.0086 49.1489L55.2215 25.9991L32.0717 6.7861ZM32.0463 6.53235L55.4753 25.9628L36.0448 49.3954L12.6158 29.9613L32.0463 6.53235Z",
    fill: "url(#paint126_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0535 6.61582L12.6992 29.9541L36.0375 49.3085L55.3919 25.9738L32.0535 6.61582ZM32.0318 6.36206L55.6456 25.9375L36.0701 49.5514L12.4454 29.9868L32.0209 6.37294L32.0318 6.36206Z",
    fill: "url(#paint127_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0391 6.44541L12.5288 29.9867L36.0521 49.497L55.5623 25.9738L32.0391 6.44541ZM32.0173 6.19165L55.816 25.9339L36.0774 49.7326L12.2751 29.9867L32.0173 6.19165Z",
    fill: "url(#paint128_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0245 6.27862L12.3584 29.9867L36.0665 49.6528L55.7254 25.9411L32.0245 6.27862ZM31.9992 6.02124L55.9864 25.9157L36.0919 49.903L12.1047 30.0085L31.9992 6.02124Z",
    fill: "url(#paint129_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0064 6.10825L12.1917 29.9867L36.0847 49.8015L55.8994 25.9085L32.0064 6.10825ZM31.9847 5.85449L56.1531 25.9012L36.1064 50.0733L11.9379 30.023L31.9847 5.85449Z",
    fill: "url(#paint130_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.992 5.93784L12.0213 30.0157L36.0992 49.9863L56.0879 25.9085L31.992 5.93784ZM31.9702 5.68408L56.3236 25.8867L36.1246 50.2401L11.7676 30.0411L31.9702 5.69858V5.68408Z",
    fill: "url(#paint131_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9774 5.76743L11.8618 30.0338L36.1245 50.1567L56.251 25.8939L31.9774 5.76743ZM31.952 5.51367L56.4939 25.8686L36.1499 50.4104L11.608 30.0555L31.9629 5.51367H31.952Z",
    fill: "url(#paint132_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9593 5.60069L11.6842 30.0483L36.1499 50.3271L56.4287 25.8758L31.9593 5.60069ZM31.9376 5.33606L56.6643 25.8541L36.1499 50.5808L11.4268 30.0701L31.9376 5.33606Z",
    fill: "url(#paint133_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9448 5.43039L11.4993 30.0629L36.1499 50.4939L56.5809 25.8614L31.9303 5.43039H31.9448ZM31.9194 5.17664L56.831 25.8397L36.168 50.7477L11.2564 30.0846L31.9194 5.17664Z",
    fill: "url(#paint134_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9303 5.25998L11.3434 30.081L36.1499 50.6497L56.7368 25.8324L31.9303 5.25998ZM31.9049 5.00623L57.0014 25.8215L36.1862 50.918L11.0897 30.1027L31.9049 5.00623Z",
    fill: "url(#paint135_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9122 5.08957L11.173 30.1027L36.1861 50.8418L56.9253 25.8287L31.9122 5.08957ZM31.8904 4.83582L57.1754 25.807L36.2043 51.0883L10.9193 30.1208L31.8904 4.83582Z",
    fill: "url(#paint136_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8977 4.92282L11.0063 30.1099L36.1934 51.0122L57.0848 25.8215L31.8977 4.92282ZM31.8723 4.66907L57.3422 25.7888L36.2188 51.2587L10.7489 30.1353L31.8723 4.66907Z",
    fill: "url(#paint137_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8796 4.75241L10.8359 30.128L36.2115 51.1717L57.2552 25.7961L31.8796 4.75241ZM31.8578 4.49866L57.509 25.7743L36.2333 51.4255L10.5822 30.1498L31.8578 4.49866Z",
    fill: "url(#paint138_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8651 4.58213L10.6656 30.1426L36.2261 51.3422L57.4256 25.7817L31.8651 4.58213ZM31.8433 4.32837L57.6794 25.7599L36.2478 51.5959L10.4118 30.168L31.8433 4.32837Z",
    fill: "url(#paint139_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8506 4.41534L10.4951 30.1535L36.2333 51.5089L57.5887 25.7707L31.8506 4.41534ZM31.8252 4.15796L57.8497 25.7417L36.2659 51.7663L10.2414 30.1825L31.8252 4.15796Z",
    fill: "url(#paint140_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8325 4.24859L10.3284 30.1752L36.2587 51.6793L57.7627 25.749L31.8325 4.24859ZM31.7998 3.99121L58.0092 25.7418L36.2587 51.9512L10.0529 30.2006L31.7998 3.99121Z",
    fill: "url(#paint141_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8179 4.07456L10.158 30.1752L36.2586 51.8351L57.9186 25.7345L31.8179 4.07456ZM31.7962 3.8208L58.1868 25.7127L36.2985 52.0998L9.90424 30.2151L31.7998 3.8208H31.7962Z",
    fill: "url(#paint142_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7998 3.90415L9.98764 30.2042L36.2877 52.02L58.1035 25.7199L31.7998 3.90415ZM31.7744 3.65039L58.3536 25.6946L36.3094 52.2737L9.73389 30.2296L31.7781 3.65039H31.7744Z",
    fill: "url(#paint143_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7998 3.73748L9.83173 30.2224L36.3203 52.1904L58.2629 25.7019L31.7998 3.73748ZM31.778 3.4801L58.5421 25.6802L36.3275 52.4623L9.56348 30.2441L31.778 3.4801Z",
    fill: "url(#paint144_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7708 3.56711L9.65774 30.2369L36.3275 52.3499L58.4406 25.6802L31.7708 3.56711ZM31.7454 3.31335L58.6943 25.6657L36.3456 52.6146L9.39673 30.2623L31.7454 3.31335Z",
    fill: "url(#paint145_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7563 3.3967L9.48013 30.255L36.3348 52.5275L58.6255 25.6729L31.7563 3.3967ZM31.7309 3.14294L58.8647 25.6366L36.3602 52.7704L9.22638 30.2767L31.7309 3.14294Z",
    fill: "url(#paint146_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7382 3.22629L9.32429 30.2695L36.3675 52.6979L58.7959 25.6547L31.7382 3.22629ZM31.7165 2.97253L59.0352 25.6366L36.3747 52.9553L9.05603 30.2912L31.7165 2.97253Z",
    fill: "url(#paint147_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7237 3.05954L9.143 30.284L36.3674 52.8683L58.9517 25.6366L31.7237 3.05954ZM31.6983 2.80579L59.2055 25.6366L36.3928 53.1402L8.88562 30.3093L31.6983 2.80579Z",
    fill: "url(#paint148_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7092 2.88913L8.96175 30.3021L36.3711 53.035L59.1185 25.6366L31.7092 2.88913ZM31.6838 2.63538L59.3723 25.6003L36.4073 53.2924L8.71887 30.3238L31.6838 2.63538Z",
    fill: "url(#paint149_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.691 2.71884L8.80222 30.3167L36.4 53.2055L59.2888 25.6077L31.691 2.71884ZM31.6693 2.46509L59.5426 25.5859L36.4218 53.4592L8.54846 30.3493L31.6693 2.47234V2.46509Z",
    fill: "url(#paint150_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6766 2.54836L8.63187 30.3492L36.4146 53.3939L59.4593 25.5931L31.6766 2.54836ZM31.6512 2.2946L59.713 25.5677L36.4399 53.6295L8.37811 30.3492L31.6512 2.28735V2.2946Z",
    fill: "url(#paint151_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6584 2.38165L8.46509 30.3492L36.4327 53.5498L59.6332 25.5822L31.662 2.38165H31.6584ZM31.6367 2.12789L59.8834 25.5532L36.4544 53.7999L8.2077 30.371L31.6367 2.12427V2.12789Z",
    fill: "url(#paint152_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6439 2.21128L8.29471 30.3492L36.4472 53.6984L59.7964 25.546L31.6439 2.21128ZM31.6222 1.95752L60.0501 25.5387L36.4689 53.9667L8.04095 30.4036L31.6222 1.95752Z",
    fill: "url(#paint153_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6294 2.04087L8.12434 30.3782L36.4617 53.8833L59.9668 25.546L31.6294 2.04087ZM31.6041 1.78711L60.2205 25.5206L36.487 54.137L7.87421 30.4036L31.6041 1.78711Z",
    fill: "url(#paint154_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6113 1.87046L7.95394 30.3963L36.4798 54.0536L60.1371 25.5314L31.6113 1.87408V1.87046ZM31.5895 1.6167L60.3909 25.506L36.5124 54.3074L7.71106 30.418L31.5895 1.6167Z",
    fill: "url(#paint155_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5968 1.71103L7.7872 30.4109L36.5124 54.2241L60.322 25.5134L31.5968 1.71103ZM31.5751 1.45728L60.5758 25.4989L36.5342 54.4996L7.53345 30.458L31.5751 1.45728Z",
    fill: "url(#paint156_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5823 1.53342L7.61679 30.4254L36.5124 54.3909L60.4779 25.4989L31.5823 1.53342ZM31.5569 1.27966L60.728 25.4735L36.5341 54.6374L7.36304 30.4508L31.5569 1.27966Z",
    fill: "url(#paint157_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5642 1.34848L7.44645 30.4435L36.5124 54.5612L60.6301 25.4807L31.5642 1.34848ZM31.5424 1.09473L60.9057 25.4445L36.5559 54.8077L7.19269 30.458L31.5424 1.09473Z",
    fill: "url(#paint158_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5496 1.19622L7.26154 30.458L36.5269 54.7461L60.815 25.4807L31.5496 1.19622ZM31.5243 0.938843L61.0687 25.4445L36.5668 54.9998L7.02228 30.4978L31.5243 0.938843Z",
    fill: "url(#paint159_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5352 1.02585L7.10932 30.4761L36.5559 54.9019L60.9818 25.4517L31.5352 1.02585ZM31.5098 0.772095L61.2356 25.4227L36.5849 55.1485L6.85919 30.4978L31.5098 0.772095Z",
    fill: "url(#paint160_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.517 0.855441L6.93894 30.4906L36.5741 55.0687L61.163 25.4336L31.517 0.855441ZM31.4953 0.601685L61.4059 25.4118L36.5958 55.3224L6.68518 30.5123L31.4953 0.601685Z",
    fill: "url(#paint161_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5026 0.685153L6.78671 30.5051L36.6067 55.2391L61.3226 25.4191L31.5026 0.685153ZM31.4772 0.431396L61.5654 25.3974L36.6031 55.4856L6.51483 30.5233L31.4772 0.435021V0.431396Z",
    fill: "url(#paint162_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.488 0.518368L6.59818 30.5232L36.6031 55.4095L61.4929 25.4046L31.488 0.518368ZM31.4627 0.260986L61.7467 25.3792L36.6284 55.6632L6.34442 30.545L31.4627 0.260986Z",
    fill: "url(#paint163_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4699 0.347995L6.42414 30.5377L36.6139 55.5762L61.6524 25.3865L31.4699 0.347995ZM31.4481 0.0942383L61.8989 25.3647L36.6429 55.8336L6.19214 30.5631L31.4373 0.0942383H31.4481Z",
    fill: "url(#paint164_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4554 0.177585L6.26102 30.5522L36.6356 55.7466L61.83 25.372L31.4554 0.177585ZM31.43 -0.0761719L62.0838 25.3466L36.661 56.0004L6.00726 30.5776L31.43 -0.0761719Z",
    fill: "url(#paint165_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4373 0.00717422L6.09067 30.5703L36.6538 55.9169L62.0004 25.3574L31.4373 0.00717422ZM31.4156 -0.246582L62.2506 25.3321L36.6719 56.1707L5.83691 30.5921L31.4156 -0.246582Z",
    fill: "url(#paint166_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4373 -0.159574L5.92393 30.5848L36.6683 56.0873L62.1672 25.3393L31.4373 -0.159574ZM31.4156 -0.41333L62.4391 25.3248L36.701 56.3483L5.67743 30.6102L31.4156 -0.41333Z",
    fill: "url(#paint167_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4083 -0.329862L5.75351 30.5994L36.6828 56.2542L62.3375 25.3249L31.4083 -0.329862ZM31.3829 -0.583618L62.5913 25.2995L36.7082 56.5079L5.49976 30.6248L31.3829 -0.583618Z",
    fill: "url(#paint168_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3902 -0.500272L5.58317 30.6175L36.701 56.4245L62.508 25.3104L31.3902 -0.500272ZM31.3684 -0.754028L62.7617 25.2741L36.7227 56.6674L5.33667 30.6393L31.3684 -0.754028Z",
    fill: "url(#paint169_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3757 -0.670682L5.41282 30.632L36.7155 56.5949L62.6784 25.2922L31.3757 -0.670682ZM31.354 -0.924438L62.9321 25.2741L36.7408 56.8486L5.15906 30.6573L31.354 -0.924438Z",
    fill: "url(#paint170_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3612 -0.826566L5.2605 30.6573L36.7444 56.7761L62.8451 25.2886L31.3612 -0.826566ZM31.3358 -1.08032L63.1024 25.2632L36.7553 57.0299L4.97412 30.6718L31.3358 -1.08032Z",
    fill: "url(#paint171_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3431 -1.00783L5.07565 30.6646L36.7481 56.932L63.0155 25.2741L31.3431 -1.00783ZM31.3213 -1.26159L63.2692 25.2378L36.7698 57.1749L4.8219 30.6755L31.3213 -1.27246V-1.26159Z",
    fill: "url(#paint172_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3285 -1.18911L4.90524 30.6791L36.7625 57.1023L63.1858 25.245L31.3285 -1.18911ZM31.3032 -1.44287L63.4396 25.2124L36.7879 57.3561L4.65149 30.7117L31.3032 -1.44287Z",
    fill: "url(#paint173_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3141 -1.34861L4.7349 30.7117L36.7771 57.2872L63.3562 25.2451L31.3141 -1.34861ZM31.2887 -1.60237L63.61 25.2233L36.8024 57.5374L4.48114 30.7117L31.3068 -1.60962L31.2887 -1.60237Z",
    fill: "url(#paint174_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2959 -1.51529L4.56815 30.7118L36.7952 57.4396L63.523 25.2125L31.2959 -1.51529ZM31.2742 -1.76904L63.7767 25.1908L36.817 57.6969L4.31439 30.7335L31.2742 -1.76904Z",
    fill: "url(#paint175_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2814 -1.6857L4.39774 30.7117L36.8097 57.5954L63.7006 25.198L31.2814 -1.6857ZM31.256 -1.93945L63.9471 25.1726L36.835 57.8637L4.14398 30.7516L31.256 -1.93945Z",
    fill: "url(#paint176_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2669 -1.85611L4.22739 30.7443L36.8278 57.7803L63.8638 25.1834L31.2669 -1.85611ZM31.2416 -2.10986L64.1175 25.1581L36.8496 58.034L3.97363 30.7661L31.2416 -2.10986Z",
    fill: "url(#paint177_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2488 -2.02289L4.0606 30.7588L36.8459 57.947L64.0341 25.1617L31.2488 -2.02652V-2.02289ZM31.227 -2.28027L64.2879 25.1435L36.8749 58.2044L3.80322 30.7842L31.227 -2.27665V-2.28027Z",
    fill: "url(#paint178_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2343 -2.19327L3.88661 30.7733L36.8749 58.1174L64.219 25.1508L31.2343 -2.19327ZM31.2089 -2.44702L64.4546 25.1254L36.8749 58.3747L3.63647 30.7987L31.2089 -2.44702Z",
    fill: "url(#paint179_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2161 -2.36355L3.71982 30.7915L36.8749 58.2878L64.3712 25.1364L31.2161 -2.36355ZM31.1944 -2.61731L64.625 25.111L36.8966 58.5416L3.46606 30.8133L31.1944 -2.61731Z",
    fill: "url(#paint180_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2017 -2.53396L3.54948 30.8169L36.9003 58.4691L64.5525 25.1182L31.2017 -2.53396ZM31.1799 -2.78772L64.7881 25.0965L36.9076 58.7119L3.29572 30.8314L31.1799 -2.78772Z",
    fill: "url(#paint181_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1872 -2.70075L3.38275 30.8205L36.904 58.6249L64.712 25.1001L31.1872 -2.70075ZM31.1618 -2.95813L64.9658 25.0783L36.9293 58.8823L3.12537 30.8458L31.1618 -2.95813Z",
    fill: "url(#paint182_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1691 -2.87112L3.21237 30.8422L36.9257 58.7989L64.8824 25.0856L31.1691 -2.87112ZM31.1473 -3.12488L65.1507 25.0638L36.962 59.049L2.95862 30.8603L31.1473 -3.12488Z",
    fill: "url(#paint183_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1545 -3.04153L3.04195 30.8531L36.9365 58.9656L65.0491 25.071L31.1545 -3.04153ZM31.1292 -3.29529L65.3029 25.0493L36.9583 59.2194L2.79907 30.8784L31.14 -3.29529H31.1292Z",
    fill: "url(#paint184_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1401 -3.21182L2.86436 30.864L36.9402 59.1397L65.2159 25.0639L31.1401 -3.21182ZM31.1147 -3.46558L65.4733 25.0313L36.9765 59.3899L2.61786 30.893L31.1147 -3.46558Z",
    fill: "url(#paint185_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1219 -3.36407L2.70484 30.8858L36.9692 59.3065L65.3899 25.0385L31.1219 -3.36407ZM31.1002 -3.61782L65.6437 25.0204L37.0054 59.5639L2.43658 30.9075L31.0748 -3.63232L31.1002 -3.61782Z",
    fill: "url(#paint186_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1074 -3.54898L2.53446 30.8894L36.9728 59.4623L65.5458 25.024L31.1074 -3.54898ZM31.082 -3.80273L65.8104 24.9986L37.0091 59.7125L2.2807 30.9111L31.0748 -3.80273H31.082Z",
    fill: "url(#paint187_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0929 -3.72659L2.36405 30.9184L36.9982 59.6436L65.727 25.0095L31.0929 -3.72659ZM31.0675 -3.98035L65.9808 24.9841L37.0235 59.8974L2.11029 30.9402L31.0748 -3.9731L31.0675 -3.98035Z",
    fill: "url(#paint188_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0748 -3.8898L2.1937 30.9328L37.0163 59.8139L65.8974 24.9913L31.0748 -3.8898ZM31.053 -4.14355L66.1512 24.9695L37.0381 60.0749L1.93994 30.9654L31.053 -4.1363V-4.14355Z",
    fill: "url(#paint189_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0748 -4.05655L2.02691 30.9473L37.0308 59.9843L66.0641 24.9768L31.0748 -4.05655ZM31.0494 -4.3103L66.3324 24.955L37.0562 60.2381L1.76953 30.9727L31.0349 -4.3103H31.0494Z",
    fill: "url(#paint190_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0458 -4.22683L1.8566 30.9655L37.0454 60.1511L66.2382 24.9624L31.0458 -4.22683ZM31.0205 -4.48059L66.4883 24.937L37.0707 60.4049L1.60284 30.9873L31.0205 -4.48059Z",
    fill: "url(#paint191_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0277 -4.39725L1.68619 30.98L37.0634 60.3215L66.4049 24.9442L31.0277 -4.39725ZM31.0059 -4.651L66.6587 24.9116L37.0852 60.5644L1.43243 31.0054L31.0059 -4.651Z",
    fill: "url(#paint192_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0132 -4.56403L1.51585 30.9945L37.078 60.4918L66.5753 24.9297L31.0132 -4.56403ZM30.9878 -4.82141L66.8291 24.9043L37.1034 60.7456L1.26208 31.0199L30.9878 -4.82141Z",
    fill: "url(#paint193_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.995 -4.7344L1.34903 31.0126L37.096 60.6586L66.742 24.9116L30.995 -4.7344ZM30.9733 -4.98816L66.9958 24.8898L37.1178 60.916L1.09528 31.0344L30.9733 -4.98816Z",
    fill: "url(#paint194_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9806 -4.90481L1.17868 31.0271L37.1106 60.8289L66.9124 24.9116L30.9806 -4.90481ZM30.9588 -5.15857L67.1662 24.8753L37.136 61.0827L0.924927 31.0525L30.9588 -5.15857Z",
    fill: "url(#paint195_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.966 -5.0751L1.00827 31.0417L37.125 60.9994L67.0828 24.8826L30.966 -5.0751ZM30.9406 -5.32886L67.3257 24.8573L37.1395 61.2532L0.754517 31.0743L30.9406 -5.32161V-5.32886Z",
    fill: "url(#paint196_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9479 -5.24192L0.841551 31.0742L37.1432 61.1625L67.2532 24.8681L30.9479 -5.24192ZM30.9262 -5.4993L67.507 24.8427L37.165 61.4235L0.584167 31.0742L30.9262 -5.50293V-5.4993Z",
    fill: "url(#paint197_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9334 -5.41226L0.67118 31.0743L37.1577 61.3402L67.42 24.85L30.9334 -5.41226ZM30.9081 -5.66602L67.6882 24.8282L37.1831 61.5939L0.417419 31.0997L30.9081 -5.66602Z",
    fill: "url(#paint198_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9189 -5.58267L0.500793 31.0742L37.1722 61.525L67.5903 24.8355L30.9189 -5.58267ZM30.8935 -5.83643L67.8441 24.8101L37.1976 61.7606L0.261536 31.1141L30.8935 -5.83643Z",
    fill: "url(#paint199_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9008 -5.75308L0.330426 31.1068L37.1903 61.6772L67.7607 24.8173L30.9008 -5.75308ZM30.8791 -6.00684L68.0145 24.8064L37.2012 61.9419L0.0657959 31.1286L30.8791 -6.00684Z",
    fill: "url(#paint200_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8863 -5.90164L0.163678 31.1214L37.2049 61.8477L67.9275 24.8029L30.8863 -5.90164ZM30.8609 -6.1554L68.1994 24.7956L37.2375 62.1014L-0.100952 31.1468L30.8537 -6.19165L30.8609 -6.1554Z",
    fill: "url(#paint201_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8718 -6.09024L-0.00674284 31.1394L37.2374 62.0143L68.0978 24.7883L30.8718 -6.09024ZM30.8464 -6.34399L68.3516 24.7629L37.2374 62.2681L-0.260498 31.1612L30.8464 -6.34399Z",
    fill: "url(#paint202_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8536 -6.26419L-0.177153 31.154L37.2374 62.1848L68.2682 24.7702L30.8536 -6.26419ZM30.8319 -6.51794L68.5328 24.7448L37.27 62.4458L-0.430908 31.183L30.8319 -6.51794Z",
    fill: "url(#paint203_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8392 -6.43094L-0.336622 31.1685L37.2628 62.3443L68.4386 24.7448L30.8392 -6.43094ZM30.8138 -6.68469L68.6923 24.7303L37.2773 62.6125L-0.601257 31.1939L30.8138 -6.68469Z",
    fill: "url(#paint204_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8247 -6.59772L-0.514223 31.1866L37.2665 62.5255L68.6054 24.7412L30.8247 -6.59772ZM30.7993 -6.85148L68.8628 24.7158L37.2918 62.7793L-0.771606 31.2083L30.7957 -6.8551L30.7993 -6.85148Z",
    fill: "url(#paint205_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8066 -6.76809L-0.684599 31.2011L37.2846 62.6923L68.7758 24.7231L30.8066 -6.76809ZM30.7848 -7.02185L69.0295 24.7013L37.3064 62.946L-0.938354 31.2265L30.7848 -7.02185Z",
    fill: "url(#paint206_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.792 -6.9385L-0.855009 31.2156L37.2991 62.8626L68.9461 24.7085L30.792 -6.9385ZM30.7667 -7.19226L69.1926 24.6832L37.3172 63.1091L-1.10876 31.2337L30.7667 -7.19226Z",
    fill: "url(#paint207_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7739 -7.10517L-1.02536 31.2338L37.3172 63.0331L69.1165 24.6941L30.7739 -7.10879V-7.10517ZM30.7522 -7.36255L69.3703 24.6687L37.339 63.2868L-1.27911 31.2555L30.7522 -7.35167V-7.36255Z",
    fill: "url(#paint208_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7594 -7.27554L-1.18854 31.2483L37.3353 63.1999L69.2832 24.676L30.7594 -7.27554ZM30.7376 -7.5293L69.5261 24.6543L37.3425 63.4427L-1.44592 31.2592L30.7376 -7.5293Z",
    fill: "url(#paint209_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7449 -7.44598L-1.36252 31.2627L37.3462 63.3702L69.4536 24.6614L30.7449 -7.44598ZM30.7123 -7.71423L69.7001 24.6216L37.3643 63.6094L-1.61627 31.2881L30.7123 -7.71423Z",
    fill: "url(#paint210_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7122 -7.61636L-1.55105 31.2809L37.3462 63.5442L69.6095 24.6506L30.7122 -7.61636ZM30.6905 -7.87012L69.8632 24.6216L37.386 63.7943L-1.78668 31.3026L30.6905 -7.87012Z",
    fill: "url(#paint211_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7123 -7.78314L-1.70327 31.2953L37.3788 63.7L69.7944 24.6288L30.7123 -7.78314ZM30.6905 -8.04053L70.0481 24.607L37.4223 63.9646L-1.9389 31.3388L30.6905 -8.04053Z",
    fill: "url(#paint212_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7123 -7.95352L-1.87002 31.3135L37.3933 63.8776L69.9611 24.6143L30.7123 -7.95352ZM30.6869 -8.20728L70.2258 24.5889L37.4187 64.135L-2.12378 31.3352L30.6724 -8.20728H30.6869Z",
    fill: "url(#paint213_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6796 -8.12381L-2.04043 31.328L37.4114 64.0626L70.1315 24.5963L30.6796 -8.12381ZM30.6579 -8.37756L70.3853 24.5745L37.4332 64.3019L-2.27606 31.3498L30.6579 -8.37756Z",
    fill: "url(#paint214_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6652 -8.29422L-2.21078 31.3425L37.426 64.2185L70.3019 24.5817L30.6652 -8.29422ZM30.6398 -8.54797L70.5557 24.5491L37.4513 64.4613L-2.46454 31.3679L30.6398 -8.54797Z",
    fill: "url(#paint215_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6507 -8.46097L-2.37754 31.3607L37.4404 64.3888L70.4723 24.5672L30.6507 -8.46097ZM30.6253 -8.71472L70.726 24.5491L37.4658 64.6426L-2.63855 31.3824L30.6253 -8.71472Z",
    fill: "url(#paint216_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6325 -8.63138L-2.54794 31.3751L37.4586 64.5556L70.639 24.5491L30.6325 -8.63138ZM30.6108 -8.88513L70.8928 24.5273L37.4803 64.8093L-2.8017 31.3969L30.6108 -8.88513Z",
    fill: "url(#paint217_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.618 -8.80179L-2.73279 31.3896L37.4586 64.7404L70.8094 24.549L30.618 -8.80179ZM30.5927 -9.05554L71.0632 24.5092L37.4985 64.9797L-2.97205 31.415L30.5927 -9.05554Z",
    fill: "url(#paint218_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6035 -8.97207L-2.8887 31.4078L37.4912 64.8964L70.9798 24.5201L30.6035 -8.97207ZM30.5781 -9.22583L71.2335 24.4875L37.5129 65.1501L-3.14246 31.4368L30.5781 -9.22583Z",
    fill: "url(#paint219_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5854 -9.13894L-3.05542 31.4367L37.5057 65.0775L71.1466 24.5164L30.5854 -9.13894ZM30.5637 -9.3927L71.4039 24.4801L37.5275 65.3204L-3.31281 31.4367L30.5637 -9.3927Z",
    fill: "url(#paint220_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5709 -9.30923L-3.22579 31.4368L37.5202 65.2335L71.3133 24.4875L30.5709 -9.30923ZM30.5455 -9.56299L71.5707 24.4621L37.5456 65.4873L-3.47955 31.4622L30.5455 -9.56299Z",
    fill: "url(#paint221_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5528 -9.47964L-3.39621 31.4549L37.5383 65.4038L71.4873 24.473L30.5528 -9.47964ZM30.531 -9.7334L71.741 24.4476L37.5601 65.6576L-3.64996 31.4766L30.531 -9.7334Z",
    fill: "url(#paint222_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5383 -9.65005L-3.56656 31.4693L37.5528 65.5742L71.6758 24.4548L30.5383 -9.64643V-9.65005ZM30.5165 -9.90381L71.9114 24.433L37.5782 65.828L-3.82031 31.4947L30.5165 -9.90381Z",
    fill: "url(#paint223_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5238 -9.8168L-3.72605 31.4839L37.5746 65.7446L71.8245 24.4403L30.5238 -9.8168ZM30.4984 -10.0706L72.0782 24.4149L37.6 65.9983L-3.98706 31.5092L30.4984 -10.0706Z",
    fill: "url(#paint224_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5056 -9.98721L-3.90372 31.5019L37.5999 65.9113L71.9948 24.4221L30.5056 -9.98721ZM30.4839 -10.241L72.2486 24.4004L37.5999 66.1651L-4.15747 31.5237L30.4839 -10.241Z",
    fill: "url(#paint225_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4912 -10.1575L-4.08858 31.5165L37.6 66.0817L72.1652 24.3932L30.4767 -10.172L30.4912 -10.1575ZM30.4694 -10.4113L72.4189 24.3896L37.6181 66.3391L-4.33508 31.5383L30.4658 -10.4149L30.4694 -10.4113Z",
    fill: "url(#paint226_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4766 -10.3243L-4.24447 31.5346L37.5999 66.2376L72.3356 24.3932L30.4766 -10.3243ZM30.4513 -10.5817L72.5893 24.3678L37.6398 66.5059L-4.49823 31.5564L30.4513 -10.5817Z",
    fill: "url(#paint227_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4585 -10.4947L-4.41122 31.5564L37.6398 66.4261L72.5096 24.3751L30.4585 -10.4947ZM30.4368 -10.7484L72.7633 24.3533L37.6543 66.6763L-4.66498 31.5709L30.4368 -10.7484Z",
    fill: "url(#paint228_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.444 -10.6651L-4.58157 31.5636L37.6471 66.6001L72.6727 24.3606L30.444 -10.6651ZM30.4187 -10.9188L72.9265 24.3352L37.6725 66.843L-4.83533 31.589L30.4187 -10.9188Z",
    fill: "url(#paint229_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4295 -10.8355L-4.75198 31.5781L37.6616 66.7415L72.825 24.3279L30.4114 -10.8355H30.4295ZM30.4041 -11.0892L73.0968 24.3206L37.687 67.0133L-5.00574 31.6035L30.4041 -11.0892Z",
    fill: "url(#paint230_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4114 -11.0022L-4.9187 31.5962L37.6797 66.93L73.0135 24.3279L30.4114 -11.0022ZM30.3897 -11.256L73.2673 24.3062L37.7015 67.1837L-5.17609 31.618L30.3897 -11.256Z",
    fill: "url(#paint231_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3969 -11.1725L-5.08913 31.6036L37.6869 67.0896L73.173 24.3135L30.3969 -11.1725ZM30.3715 -11.4263L73.434 24.2881L37.7196 67.3506L-5.3429 31.6362L30.3715 -11.4263Z",
    fill: "url(#paint232_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3824 -11.3393L-5.25949 31.6289L37.7123 67.2672L73.3506 24.299L30.3824 -11.3393ZM30.357 -11.593L73.6044 24.2954L37.7341 67.5427L-5.51324 31.6507L30.357 -11.593Z",
    fill: "url(#paint233_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3497 -11.5133L-5.4444 31.6252L37.6942 67.4194L73.4883 24.2808L30.3497 -11.5133ZM30.328 -11.7671L73.7747 24.2591L37.7486 67.6876L-5.68365 31.6687L30.3497 -11.7671H30.328Z",
    fill: "url(#paint234_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3498 -11.6801L-5.59663 31.6579L37.7413 67.6079L73.6914 24.2663L30.3498 -11.6801ZM30.3244 -11.9338L73.9451 24.2409L37.7667 67.8616L-5.854 31.6833L30.3244 -11.9338Z",
    fill: "url(#paint235_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3498 -11.8505L-5.767 31.676L37.7595 67.7746L73.8509 24.2518L30.3498 -11.8505ZM30.328 -12.1042L74.1119 24.2264L37.7812 68.0284L-6.02075 31.6977L30.328 -12.1042Z",
    fill: "url(#paint236_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3172 -12.0208L-5.93735 31.6906L37.774 67.9415L74.0249 24.2301L30.3136 -12.0208H30.3172ZM30.2918 -12.2745L74.2823 24.212L37.7994 68.1988L-6.1911 31.7159L30.2918 -12.2745Z",
    fill: "url(#paint237_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3027 -12.1912L-6.10776 31.705L37.7885 68.1154L74.2134 24.2192L30.3027 -12.1912ZM30.2773 -12.4449L74.4526 24.1866L37.8138 68.3692L-6.36151 31.7304L30.2773 -12.4268V-12.4449Z",
    fill: "url(#paint238_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2846 -12.3579L-6.2636 31.7232L37.8175 68.2858L74.3657 24.2047L30.2846 -12.3579ZM30.2628 -12.6117L74.6194 24.1866L37.8284 68.5396L-6.53186 31.7449L30.2628 -12.6117Z",
    fill: "url(#paint239_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.27 -12.5283L-6.44491 31.7376L37.8211 68.4525L74.536 24.1866L30.27 -12.5283ZM30.2446 -12.7821L74.7897 24.1648L37.8464 68.7063L-6.69867 31.763L30.2446 -12.7821Z",
    fill: "url(#paint240_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2555 -12.6988L-6.62614 31.7521L37.8356 68.6229L74.7064 24.1865L30.2555 -12.6988ZM30.2302 -12.9525L74.9601 24.1467L37.861 68.8766L-6.86902 31.7775L30.2302 -12.9525Z",
    fill: "url(#paint241_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2374 -12.8654L-6.78567 31.7703L37.8537 68.7934L74.8767 24.154L30.2374 -12.8654ZM30.2156 -13.1228L75.1305 24.1323L37.8754 69.0471L-7.03943 31.7993L30.2156 -13.1228Z",
    fill: "url(#paint242_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2229 -13.0359L-6.95242 31.7992L37.8682 68.9636L75.0435 24.1394L30.2229 -13.0359ZM30.1975 -13.2897L75.3009 24.114L37.8936 69.2174L-7.20618 31.7992L30.1975 -13.2897Z",
    fill: "url(#paint243_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2084 -13.2062L-7.12277 31.7993L37.8864 69.1377L75.2248 24.1322L30.2084 -13.2062ZM30.183 -13.46L75.4677 24.0996L37.9081 69.3842L-7.37653 31.8247L30.183 -13.46Z",
    fill: "url(#paint244_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1903 -13.3766L-7.29315 31.8174L37.9008 69.3008L75.3843 24.1068L30.1903 -13.3766ZM30.1685 -13.6304L75.638 24.0706L37.9371 69.5401L-7.53241 31.8391L30.1685 -13.6304Z",
    fill: "url(#paint245_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1758 -13.5434L-7.46355 31.8319L37.9153 69.4712L75.5546 24.0923L30.1758 -13.5434ZM30.1504 -13.8008L75.8265 24.0669L37.9588 69.743L-7.71368 31.8572L30.1504 -13.8008Z",
    fill: "url(#paint246_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1613 -13.7138L-7.63028 31.85L37.9335 69.6379L75.7214 24.0778L30.1613 -13.7138ZM30.1359 -13.9675L75.9752 24.0524L37.9625 69.8953L-7.88403 31.8717L30.1359 -13.9675Z",
    fill: "url(#paint247_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1432 -13.8769L-7.80066 31.8645L37.9625 69.8083L75.8918 24.0597L30.1432 -13.8769ZM30.1214 -14.1307L76.16 24.0452L37.9625 70.062L-8.07617 31.8898L30.0997 -14.1488L30.1214 -14.1307Z",
    fill: "url(#paint248_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1287 -14.0545L-7.97103 31.8791L37.9625 69.9788L76.0622 24.0452L30.1287 -14.0545ZM30.1033 -14.3082L76.3159 24.0199L37.9879 70.2253L-8.22479 31.9044L30.1033 -14.3082Z",
    fill: "url(#paint249_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1105 -14.2213L-8.13782 31.8971L37.9806 70.1491L76.2289 24.0307L30.1105 -14.2213ZM30.0888 -14.475L76.4899 24.0053L38.006 70.4065L-8.3952 31.9225L30.0888 -14.4786V-14.475Z",
    fill: "url(#paint250_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.096 -14.3916L-8.3082 31.9116L37.9951 70.3159L76.3884 24.0126L30.096 -14.3916ZM30.0706 -14.6454L76.6531 23.9908L38.0168 70.5877L-8.56195 31.937L30.0706 -14.6454Z",
    fill: "url(#paint251_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0815 -14.562L-8.47854 31.9297L38.0096 70.4862L76.5697 23.998L30.0815 -14.562ZM30.0562 -14.8158L76.8198 23.9727L38.0314 70.7363L-8.7323 31.9479L30.0562 -14.8158Z",
    fill: "url(#paint252_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0634 -14.7324L-8.64895 31.9442L38.0277 70.6566L76.7509 23.9799L30.0634 -14.7324ZM30.0416 -14.9862L76.9938 23.9581L38.0495 70.9103L-8.90271 31.966L30.0416 -14.9862Z",
    fill: "url(#paint253_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0489 -14.8992L-8.80118 31.9587L38.0422 70.8269L76.9068 23.9654L30.0489 -14.8992ZM30.0235 -15.153L77.1497 23.9436L38.0531 71.0698L-9.07306 31.9732L30.0235 -15.153Z",
    fill: "url(#paint254_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0344 -15.0695L-8.98611 31.9769L38.0567 70.9937L77.0772 23.951L30.0344 -15.0695ZM30.009 -15.3233L77.3309 23.9256L38.0821 71.2475L-9.23987 31.9987L30.009 -15.3269V-15.3233Z",
    fill: "url(#paint255_linear_4_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0163 -15.2399L-9.16372 31.9914L38.0748 71.1642L77.2476 23.9329L30.0163 -15.2399ZM30.0163 -15.4066L77.4179 23.9184L38.0893 71.3345L-9.32684 32.0059L30.0163 -15.4066Z",
    fill: "url(#paint256_linear_4_3)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.1127 31.9443C48.1903 31.965 48.2614 32.0051 48.3191 32.0609C48.3768 32.1168 48.4193 32.1864 48.4426 32.2633C48.4612 32.3441 48.4516 32.4288 48.4153 32.5034C48.379 32.5779 48.3183 32.6378 48.2432 32.6729C47.8988 32.876 47.5508 33.079 47.1992 33.2783C46.3557 33.7617 45.5183 34.2595 44.687 34.7719L42.9759 35.8594C42.5844 36.1168 42.2002 36.3705 41.8196 36.6134C41.6605 36.7045 41.5232 36.8292 41.4174 36.9789C41.3116 37.1285 41.2397 37.2995 41.2069 37.4798C40.8575 39.018 40.3897 40.527 39.8076 41.9931C38.323 45.6178 35.8715 48.7652 32.7206 51.092C32.1434 51.533 31.5169 51.9053 30.8536 52.2013C30.1797 52.4992 29.4626 52.6876 28.7293 52.7596C28.0468 52.8454 27.3537 52.7581 26.7138 52.5058C26.2332 52.3244 25.8282 51.9855 25.5649 51.5445C25.3016 51.1034 25.1954 50.5861 25.2638 50.077C25.3462 49.4724 25.5549 48.8919 25.8764 48.3732C26.1603 47.8812 26.484 47.4132 26.8443 46.9739C27.2068 46.5462 27.5693 46.1257 27.9935 45.7124C28.8925 44.8061 29.8277 43.9397 30.7993 43.1132C31.7708 42.2867 32.758 41.4795 33.761 40.6916C35.4072 39.38 37.1193 38.1531 38.8905 37.0158C39.1931 36.8468 39.4486 36.6047 39.6335 36.3114C39.8185 36.0182 39.9269 35.6833 39.949 35.3374C40.0106 34.7791 40.0868 34.2245 40.181 33.6698C40.2499 33.3581 40.3043 33.0355 40.3514 32.6983C40.3514 32.5569 40.3514 32.4011 40.3514 32.2271L40.3731 31.9407C40.236 32.0088 40.1129 32.1023 40.0106 32.2162C39.9135 32.3032 39.8335 32.4077 39.775 32.5243C39.7268 32.5762 39.6865 32.6348 39.6554 32.6983C38.5448 34.2946 37.1589 35.6805 35.5626 36.791V35.0981C35.9251 34.7827 36.2877 34.4529 36.6067 34.1012C37.6678 33.0092 38.5422 31.7503 39.195 30.3746C39.8431 28.9884 40.2829 27.514 40.5 25.9992C40.5 25.9992 40.5 25.9774 40.5254 25.9665C40.5573 25.5797 40.6228 25.1964 40.7211 24.821C40.8516 24.2265 41.196 23.9691 41.7507 24.0489C42.3053 24.1286 42.5156 24.4114 42.5337 24.9624C42.5808 25.8922 42.5808 26.8239 42.5337 27.7537C42.4101 29.8573 42.1681 31.9523 41.8087 34.0287C41.7833 34.2281 41.7579 34.4311 41.7289 34.6414C41.7239 34.6956 41.7239 34.7502 41.7289 34.8045C41.7342 34.8323 41.7457 34.8585 41.7627 34.8811C41.7797 34.9038 41.8016 34.9222 41.8268 34.935H41.95C41.9692 34.9377 41.9887 34.9365 42.0074 34.9315C42.026 34.9265 42.0435 34.9178 42.0588 34.906C42.2618 34.8009 42.4576 34.6957 42.6461 34.587C42.7367 34.5399 42.8273 34.4855 42.9107 34.4311C43.1427 34.2934 43.3675 34.1592 43.585 34.036L46.8222 32.1799C47.0083 32.0661 47.2097 31.9795 47.4203 31.9226C47.6428 31.8665 47.8757 31.8665 48.0982 31.9226L48.1127 31.9443ZM34.5222 37.4617C33.8225 37.865 33.0779 38.185 32.3037 38.4151C31.4046 38.6752 30.4693 38.7878 29.5341 38.7486C28.4124 38.7152 27.3119 38.4342 26.3114 37.9257C25.3207 37.4067 24.4452 36.6928 23.7376 35.8268C22.9466 34.9026 22.3322 33.841 21.925 32.6947C21.5331 31.5411 21.318 30.3347 21.287 29.1167C21.2719 28.6526 21.2803 28.188 21.3124 27.7247C21.3124 27.5471 21.3124 27.3622 21.3124 27.1592C21.32 27.1018 21.3158 27.0436 21.3002 26.9879C21.2846 26.9322 21.2579 26.8802 21.2216 26.8351C21.1853 26.7901 21.1403 26.7528 21.0893 26.7257C21.0382 26.6985 20.9822 26.6819 20.9245 26.677L20.359 26.5502C19.6702 26.4052 18.9875 26.2493 18.3108 26.0825C17.1951 25.7893 16.1109 25.3874 15.0736 24.8826C14.0312 24.3771 13.0215 23.8069 12.0503 23.1752C11.9859 23.1312 11.9356 23.0695 11.9053 22.9976C11.8908 22.931 11.8953 22.8617 11.9184 22.7976C11.9415 22.7334 11.9822 22.6771 12.0358 22.6351C12.0836 22.5972 12.1375 22.5677 12.1953 22.5481C12.3923 22.5031 12.5962 22.4975 12.7953 22.5317C12.9944 22.5659 13.1847 22.6393 13.3553 22.7474C13.6671 22.9432 13.9788 23.1353 14.2906 23.3166C16.279 24.5004 18.4711 25.302 20.7541 25.6801C20.9523 25.7427 21.165 25.7427 21.3632 25.6801C21.4695 25.6221 21.5565 25.4481 21.6242 25.1581L21.7982 24.5382C21.9047 24.1198 22.0367 23.7081 22.1933 23.3057C22.786 21.6404 23.6176 20.07 24.662 18.6438C25.7108 17.2233 26.9828 15.9819 28.4285 14.968C30.6262 13.3893 33.2863 12.5859 35.9904 12.6842C38.3491 12.8123 39.9708 13.2956 40.8553 14.1342C41.7398 14.9728 41.9706 16.0447 41.5477 17.3497C41.1272 18.6547 40.1315 20.0552 38.5606 21.5512C37.7431 22.3398 36.8368 23.0307 35.8599 23.6102C34.8819 24.19 33.8573 24.6871 32.7967 25.0965C30.1553 26.1438 27.3502 26.7181 24.5097 26.793C24.1835 26.793 23.8608 26.8148 23.5418 26.8402C23.3842 26.8321 23.2277 26.8712 23.0923 26.9526C23.0459 27.0006 23.0095 27.0574 22.9852 27.1196C22.961 27.1818 22.9493 27.2483 22.9509 27.3151C22.8162 28.8304 22.9388 30.3575 23.3135 31.8319C23.7121 33.3176 24.4803 34.6782 25.5465 35.7869C25.7694 36.0255 26.0119 36.245 26.2715 36.443C27.0225 37.1018 27.9404 37.541 28.9246 37.7124C29.9087 37.8838 30.9211 37.7807 31.8505 37.4146C32.7591 37.0622 33.6191 36.5957 34.4099 36.0262L34.5222 35.9464V37.4726V37.4617ZM23.3352 24.9588C23.2752 25.1561 23.2458 25.3615 23.2482 25.5678C23.2438 25.6082 23.2484 25.6491 23.2616 25.6876C23.2749 25.7261 23.2965 25.7611 23.3249 25.7902C23.3533 25.8193 23.3879 25.8418 23.426 25.856C23.4641 25.8702 23.5049 25.8757 23.5455 25.8723C24.0288 25.8554 24.5122 25.8264 24.9955 25.7853C26.5704 25.6505 28.1289 25.3665 29.6501 24.937C31.1722 24.5089 32.6412 23.9106 34.0292 23.1535C34.9107 22.6892 35.7427 22.1365 36.5124 21.504C37.2819 20.8727 37.9635 20.1412 38.5388 19.329C39.9115 17.3956 40.2994 15.9347 39.7025 14.9463C39.1056 13.9578 37.6326 13.5337 35.2835 13.6738C34.1492 13.7331 33.0324 13.978 31.9774 14.3989C30.9269 14.8294 29.944 15.4093 29.0592 16.1208C27.651 17.2282 26.4369 18.5624 25.4668 20.0685C24.5098 21.5771 23.7908 23.2241 23.3352 24.9515V24.9588ZM31.343 50.5011C35.278 47.5751 38.0515 43.3518 39.1732 38.5782C38.9874 38.5815 38.8055 38.6313 38.644 38.7232C38.5027 38.8028 38.3681 38.8938 38.2416 38.9951C38.1986 39.0351 38.1497 39.0681 38.0966 39.093C35.6128 40.8488 33.2354 42.7505 30.9769 44.788C29.8711 45.7447 28.8587 46.8043 27.9536 47.9527C27.5565 48.4738 27.2355 49.0487 27.0002 49.6601C26.8829 49.9371 26.8297 50.237 26.8443 50.5374C26.8683 50.8436 26.9889 51.1343 27.1887 51.3675C27.3802 51.602 27.651 51.7581 27.95 51.8062C28.2554 51.8491 28.5665 51.8218 28.8598 51.7264C29.7608 51.4871 30.6049 51.0705 31.343 50.5011Z",
    fill: "url(#paint257_linear_4_3)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8671 4.15435C29.0574 4.14248 29.2469 4.18751 29.4116 4.2837C29.5762 4.37989 29.7084 4.52288 29.7915 4.69448H30.705C30.5558 4.26022 30.2571 3.89315 29.8622 3.65883C29.4673 3.42451 29.0019 3.3382 28.5492 3.41531C28.0966 3.49243 27.6861 3.72795 27.391 4.0798C27.096 4.43166 26.9356 4.87694 26.9386 5.33612C26.9472 5.84926 27.158 6.33825 27.5253 6.6967C27.8926 7.05515 28.3866 7.25407 28.8998 7.25017C29.1539 7.24876 29.4053 7.1971 29.6395 7.09819C29.8736 6.99927 30.0859 6.85504 30.2641 6.67379C30.4424 6.49255 30.583 6.27785 30.6779 6.04207C30.7729 5.80628 30.8203 5.55405 30.8174 5.29987V5.173H28.965V5.81101H29.922C29.8523 6.02279 29.7139 6.20521 29.5287 6.32934C29.3435 6.45347 29.1221 6.51218 28.8998 6.49615C28.6029 6.48115 28.3236 6.35138 28.1207 6.13426C27.9177 5.91713 27.8071 5.62964 27.8122 5.3325C27.8042 5.03313 27.9134 4.74247 28.1166 4.52242C28.3197 4.30236 28.6007 4.1703 28.8998 4.15435H28.8671Z",
    fill: "url(#paint258_linear_4_3)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.7916 6.42367C36.7094 6.70216 36.5254 6.93955 36.2763 7.08865C36.0271 7.23774 35.7309 7.28765 35.4467 7.22844C35.1675 7.14546 34.9301 6.95992 34.7822 6.70908C34.6342 6.45825 34.5867 6.16072 34.6492 5.87628C34.7313 5.59818 34.9156 5.36143 35.1651 5.21352C35.4145 5.06561 35.7106 5.01747 35.9941 5.07876C36.2726 5.16019 36.5099 5.34434 36.658 5.59399C36.806 5.84363 36.8538 6.14017 36.7916 6.42367ZM37.5964 6.63392C37.6592 6.38756 37.6729 6.13124 37.6367 5.87959C37.6004 5.62794 37.515 5.38588 37.3852 5.16725C37.2555 4.94861 37.0839 4.75768 36.8804 4.60535C36.6768 4.45301 36.4452 4.34227 36.1989 4.27943C35.9525 4.21659 35.6962 4.20289 35.4446 4.23911C35.1929 4.27533 34.9508 4.36076 34.7322 4.49053C34.5136 4.6203 34.3226 4.79186 34.1703 4.99542C34.018 5.19897 33.9072 5.43054 33.8444 5.6769C33.7276 6.17342 33.8077 6.69588 34.068 7.13457C34.3282 7.57326 34.7483 7.89405 35.24 8.02958C35.7376 8.14753 36.2614 8.06802 36.7015 7.80774C37.1416 7.54747 37.4637 7.12672 37.6 6.63392H37.5964Z",
    fill: "url(#paint259_linear_4_3)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.6771 9.53405L41.6129 10.5346L41.9573 9.86393L40.7574 9.24766L42.1349 6.57235L41.4099 6.20984L39.688 9.55217L39.6771 9.53405Z",
    fill: "url(#paint260_linear_4_3)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.5612 12.2238L47.0324 11.6402L46.021 10.8282L46.4887 10.2482L47.5436 11.0892L48.0112 10.5019L46.3002 9.13525L43.9511 12.068L44.6073 12.5863L45.5534 11.4082L46.5612 12.2238Z",
    fill: "url(#paint261_linear_4_3)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.2795 16.1208L51.1071 13.6449L50.5597 13.0214L47.7502 15.4864L48.2795 16.1208Z",
    fill: "url(#paint262_linear_4_3)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.5711 21.0146L54.8337 19.1223L54.4168 18.3973L52.3903 19.5791L53.7679 17.2808L53.351 16.5558L50.0884 18.4481L50.5089 19.1731L52.5317 17.9913L51.1578 20.2896L51.5747 21.0146H51.5711Z",
    fill: "url(#paint263_linear_4_3)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.3629 25.9013C55.1522 25.9634 54.9279 25.9613 54.7184 25.8954C54.5089 25.8294 54.3239 25.7026 54.1867 25.5311C54.0496 25.3595 53.9667 25.151 53.9485 24.9322C53.9304 24.7133 53.9778 24.494 54.0847 24.3022C54.1917 24.1104 54.3533 23.9548 54.5491 23.8553C54.7448 23.7557 54.9658 23.7167 55.1838 23.7432C55.4018 23.7696 55.6069 23.8604 55.7731 24.004C55.9393 24.1475 56.059 24.3373 56.1169 24.5491C56.1823 24.828 56.1413 25.1211 56.0018 25.3713C55.8623 25.6214 55.6345 25.8104 55.3629 25.9013ZM55.5913 26.6988C55.9585 26.5911 56.2856 26.3769 56.5311 26.0834C56.7767 25.7898 56.9297 25.4301 56.9709 25.0496C57.0121 24.6691 56.9395 24.2849 56.7624 23.9456C56.5854 23.6063 56.3117 23.3272 55.976 23.1434C55.6403 22.9596 55.2576 22.8794 54.8764 22.913C54.4952 22.9466 54.1324 23.0924 53.8341 23.3321C53.5357 23.5718 53.315 23.8945 53.2 24.2595C53.085 24.6246 53.0808 25.0155 53.1878 25.3829C53.3406 25.8705 53.6762 26.2799 54.1244 26.5252C54.5725 26.7706 55.0983 26.8328 55.5913 26.6988Z",
    fill: "url(#paint264_linear_4_3)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.8191 31.3716C54.8033 31.2774 54.8068 31.181 54.8297 31.0883C54.8525 30.9955 54.894 30.9084 54.9517 30.8324C55.0095 30.7563 55.0822 30.6928 55.1654 30.6459C55.2485 30.599 55.3404 30.5696 55.4354 30.5596L55.4028 29.7222C54.4856 29.7657 54.1086 30.5414 54.1413 31.3716C54.1775 32.1365 54.5364 32.9122 55.4209 32.876C56.8528 32.8144 56.2764 30.6611 56.9471 30.6357C57.2262 30.6357 57.3531 30.9438 57.3603 31.1758C57.3785 31.5891 57.2625 31.8211 56.8709 31.9008L56.9072 32.702C57.7627 32.6367 58.0745 31.9262 58.0419 31.1541C58.0129 30.4689 57.6177 29.7657 56.8419 29.7983C55.4572 29.8599 56.019 32.0096 55.2904 32.0422C54.9533 32.0422 54.83 31.6507 54.8191 31.3897V31.3716Z",
    fill: "url(#paint265_linear_4_3)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9842 0.0979371C38.1521 0.0988869 45.0979 2.58535 50.6379 7.1336C56.1779 11.6819 59.9694 18.0105 61.3662 25.0409C62.763 32.0714 61.6787 39.3687 58.298 45.6893C54.9174 52.0099 49.4496 56.9626 42.8265 59.7036C36.2033 62.4445 28.8347 62.8039 21.9762 60.7207C15.1177 58.6375 9.19381 54.2404 5.21401 48.2789C1.2342 42.3173 -0.555233 35.1602 0.150628 28.0272C0.856489 20.8941 4.01397 14.2266 9.085 9.16066C11.9584 6.28209 15.3722 3.9996 19.1304 2.44433C22.8885 0.889065 26.9169 0.0916632 30.9842 0.0979371ZM52.4918 9.56305C47.5163 4.58909 40.9702 1.49408 33.9686 0.805322C26.9671 0.116566 19.9433 1.87667 14.094 5.78577C8.24464 9.69487 3.93158 15.5111 1.88963 22.2436C-0.152321 28.9761 0.203167 36.2083 2.89553 42.7081C5.58789 49.2079 10.4506 54.5731 16.6551 57.8897C22.8596 61.2063 30.0221 62.2691 36.9224 60.8971C43.8226 59.525 50.0337 55.8029 54.4974 50.365C58.9611 44.927 61.4013 38.1097 61.4023 31.0743C61.4076 27.0785 60.6231 23.121 59.094 19.4294C57.5648 15.7377 55.3211 12.3847 52.4918 9.56305Z",
    fill: "url(#paint266_linear_4_3)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7695 32.1599C96.7695 35.9978 94.4453 38.322 90.5195 38.322C86.3105 38.322 83.7324 35.5681 83.7324 30.988C83.7324 26.4763 86.3105 23.7419 90.4512 23.7419C93.7422 23.7419 96.2227 25.6853 96.6426 28.5369H93.6836C93.2539 27.0623 92.0527 26.1833 90.4609 26.1833C88.1367 26.1833 86.7402 27.9509 86.7402 30.949C86.7402 34.0056 88.2246 35.8708 90.5684 35.8708C92.4922 35.8708 93.8301 34.6892 93.8887 32.9412L93.8984 32.7166H90.832V30.5681H96.7695V32.1599ZM110.08 23.7419C114.25 23.7419 116.877 26.5447 116.877 31.0369C116.877 35.5193 114.25 38.322 110.08 38.322C105.9 38.322 103.283 35.5193 103.283 31.0369C103.283 26.5447 105.9 23.7419 110.08 23.7419ZM110.08 26.2029C107.775 26.2029 106.291 28.0779 106.291 31.0369C106.291 33.9861 107.766 35.8513 110.08 35.8513C112.385 35.8513 113.859 33.9861 113.859 31.0369C113.859 28.0779 112.385 26.2029 110.08 26.2029ZM132.893 35.6365V38.0779H123.781V23.9861H126.73V35.6365H132.893ZM142.59 38.0779H139.641V23.9861H148.869V26.4177H142.59V30.197H148.322V32.531H142.59V38.0779ZM158.566 38.0779H155.617V23.9861H158.566V38.0779ZM168.732 38.0779H165.91V23.9861H168.371L174.953 33.1658H175.031V23.9861H177.854V38.0779H175.412L168.82 28.8494H168.732V38.0779ZM191.564 23.7419C195.734 23.7419 198.361 26.5447 198.361 31.0369C198.361 35.5193 195.734 38.322 191.564 38.322C187.385 38.322 184.768 35.5193 184.768 31.0369C184.768 26.5447 187.385 23.7419 191.564 23.7419ZM191.564 26.2029C189.26 26.2029 187.775 28.0779 187.775 31.0369C187.775 33.9861 189.25 35.8513 191.564 35.8513C193.869 35.8513 195.344 33.9861 195.344 31.0369C195.344 28.0779 193.869 26.2029 191.564 26.2029ZM204.738 34.0642H207.58C207.717 35.2263 208.928 35.988 210.49 35.988C212.062 35.988 213.137 35.2361 213.137 34.2009C213.137 33.283 212.463 32.7751 210.764 32.3943L208.928 31.9939C206.33 31.4373 205.051 30.1189 205.051 28.0583C205.051 25.4607 207.297 23.7419 210.441 23.7419C213.723 23.7419 215.783 25.4314 215.832 27.9802H213.068C212.971 26.7888 211.926 26.0662 210.451 26.0662C208.996 26.0662 208.02 26.7595 208.02 27.8044C208.02 28.6736 208.703 29.1619 210.324 29.533L212.033 29.8943C214.855 30.4998 216.086 31.7107 216.086 33.8591C216.086 36.5935 213.869 38.322 210.373 38.322C206.984 38.322 204.826 36.7107 204.738 34.0642Z",
    fill: "url(#paint267_linear_4_3)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_3",
    x1: -72.9195,
    y1: 122.854,
    x2: 95.9478,
    y2: -6.92203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4_3",
    x1: 33.4857,
    y1: 28.4594,
    x2: 34.3936,
    y2: 27.7523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4_3",
    x1: 33.1205,
    y1: 28.8047,
    x2: 34.6288,
    y2: 27.6383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4_3",
    x1: 32.7473,
    y1: 29.1193,
    x2: 34.8641,
    y2: 27.4823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4_3",
    x1: 32.374,
    y1: 29.4483,
    x2: 35.0993,
    y2: 27.3408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4_3",
    x1: 32.0052,
    y1: 29.7882,
    x2: 35.3357,
    y2: 27.2226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4_3",
    x1: 31.6428,
    y1: 30.1102,
    x2: 35.5721,
    y2: 27.0715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4_3",
    x1: 31.2624,
    y1: 30.4428,
    x2: 35.8002,
    y2: 26.9335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4_3",
    x1: 30.8892,
    y1: 30.7754,
    x2: 36.0355,
    y2: 26.7956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4_3",
    x1: 30.539,
    y1: 31.0956,
    x2: 36.2728,
    y2: 26.6665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4_3",
    x1: 30.1507,
    y1: 31.455,
    x2: 36.5204,
    y2: 26.5491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4_3",
    x1: 29.7774,
    y1: 31.7663,
    x2: 36.7363,
    y2: 26.3848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4_3",
    x1: 29.4042,
    y1: 32.099,
    x2: 36.9716,
    y2: 26.2469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_4_3",
    x1: 29.039,
    y1: 32.4245,
    x2: 37.2019,
    y2: 26.1119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_4_3",
    x1: 28.6767,
    y1: 32.7571,
    x2: 37.4481,
    y2: 25.9739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_4_3",
    x1: 28.3215,
    y1: 33.0898,
    x2: 37.6932,
    y2: 25.8673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_4_3",
    x1: 27.9193,
    y1: 33.426,
    x2: 37.9077,
    y2: 25.7017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_4_3",
    x1: 27.5425,
    y1: 33.7533,
    x2: 38.1345,
    y2: 25.5571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_4_3",
    x1: 27.1809,
    y1: 34.0807,
    x2: 38.3733,
    y2: 25.4252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_4_3",
    x1: 26.799,
    y1: 34.4347,
    x2: 38.6258,
    y2: 25.2886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_4_3",
    x1: 26.4344,
    y1: 34.7442,
    x2: 38.8391,
    y2: 25.1463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_4_3",
    x1: 26.0648,
    y1: 35.0822,
    x2: 39.0828,
    y2: 25.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_4_3",
    x1: 25.6959,
    y1: 35.4041,
    x2: 39.3094,
    y2: 24.8763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_4_3",
    x1: 25.3017,
    y1: 35.7529,
    x2: 39.5432,
    y2: 24.7395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_4_3",
    x1: 24.9517,
    y1: 36.0678,
    x2: 39.7757,
    y2: 24.6039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_4_3",
    x1: 24.5907,
    y1: 36.379,
    x2: 39.9973,
    y2: 24.4645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_4_3",
    x1: 24.2197,
    y1: 36.7328,
    x2: 40.2622,
    y2: 24.3617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_4_3",
    x1: 23.8667,
    y1: 37.0335,
    x2: 40.4774,
    y2: 24.1879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_4_3",
    x1: 23.4769,
    y1: 37.3912,
    x2: 40.717,
    y2: 24.0738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_4_3",
    x1: 23.095,
    y1: 37.7186,
    x2: 40.9453,
    y2: 23.9043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_4_3",
    x1: 22.7261,
    y1: 38.0512,
    x2: 41.1817,
    y2: 23.7788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_4_3",
    x1: 22.3529,
    y1: 38.3624,
    x2: 41.3976,
    y2: 23.6145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_4_3",
    x1: 21.9819,
    y1: 38.7094,
    x2: 41.6431,
    y2: 23.4996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_4_3",
    x1: 21.6144,
    y1: 39.0634,
    x2: 41.9019,
    y2: 23.3944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_4_3",
    x1: 21.2412,
    y1: 39.3747,
    x2: 42.1178,
    y2: 23.2301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_4_3",
    x1: 20.868,
    y1: 39.7002,
    x2: 42.3435,
    y2: 23.0825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_4_3",
    x1: 20.5027,
    y1: 40.0383,
    x2: 42.5883,
    y2: 22.9638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_4_3",
    x1: 20.1295,
    y1: 40.3655,
    x2: 42.8187,
    y2: 22.8192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_4_3",
    x1: 19.7563,
    y1: 40.6981,
    x2: 43.054,
    y2: 22.6813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_4_3",
    x1: 19.3831,
    y1: 41.0291,
    x2: 43.2844,
    y2: 22.5404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_4_3",
    x1: 19.0178,
    y1: 41.3563,
    x2: 43.5195,
    y2: 22.4083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_4_3",
    x1: 18.6446,
    y1: 41.6924,
    x2: 43.7645,
    y2: 22.2764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_4_3",
    x1: 18.2772,
    y1: 42.0163,
    x2: 43.9894,
    y2: 22.1322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_4_3",
    x1: 17.9061,
    y1: 42.3526,
    x2: 44.2252,
    y2: 22.0042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_4_3",
    x1: 17.5307,
    y1: 42.6799,
    x2: 44.4551,
    y2: 21.8533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_4_3",
    x1: 17.1597,
    y1: 43.0125,
    x2: 44.691,
    y2: 21.7216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_4_3",
    x1: 16.7865,
    y1: 43.3434,
    x2: 44.9214,
    y2: 21.5807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_4_3",
    x1: 16.4213,
    y1: 43.6761,
    x2: 45.1614,
    y2: 21.4554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_4_3",
    x1: 16.048,
    y1: 44.0034,
    x2: 45.3918,
    y2: 21.3109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_4_3",
    x1: 15.6633,
    y1: 44.354,
    x2: 45.6285,
    y2: 21.1809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_4_3",
    x1: 15.3016,
    y1: 44.6562,
    x2: 45.8479,
    y2: 21.0188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_4_3",
    x1: 14.9406,
    y1: 44.9942,
    x2: 46.0937,
    y2: 20.9125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_4_3",
    x1: 14.5566,
    y1: 45.3537,
    x2: 46.3506,
    y2: 20.7764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_4_3",
    x1: 14.1899,
    y1: 45.6596,
    x2: 46.5633,
    y2: 20.6242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_4_3",
    x1: 13.8167,
    y1: 45.9691,
    x2: 46.7743,
    y2: 20.4568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_4_3",
    x1: 13.4515,
    y1: 46.3177,
    x2: 47.0289,
    y2: 20.3512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_4_3",
    x1: 13.0782,
    y1: 46.6504,
    x2: 47.2641,
    y2: 20.2133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_4_3",
    x1: 12.705,
    y1: 46.9831,
    x2: 47.4994,
    y2: 20.0754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_4_3",
    x1: 12.3375,
    y1: 47.3139,
    x2: 47.734,
    y2: 19.9407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_4_3",
    x1: 11.9665,
    y1: 47.643,
    x2: 47.9698,
    y2: 19.8054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_4_3",
    x1: 11.5933,
    y1: 47.9739,
    x2: 48.2002,
    y2: 19.6645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_4_3",
    x1: 11.2201,
    y1: 48.3065,
    x2: 48.4355,
    y2: 19.5266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_4_3",
    x1: 10.8606,
    y1: 48.6374,
    x2: 48.6748,
    y2: 19.4045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_4_3",
    x1: 10.4816,
    y1: 48.9647,
    x2: 48.9011,
    y2: 19.2536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_4_3",
    x1: 10.0709,
    y1: 49.3043,
    x2: 49.1329,
    y2: 19.0713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_4_3",
    x1: 9.73517,
    y1: 49.6123,
    x2: 49.3523,
    y2: 18.9551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_4_3",
    x1: 9.36343,
    y1: 49.9572,
    x2: 49.6149,
    y2: 18.8294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_4_3",
    x1: 8.99666,
    y1: 50.3096,
    x2: 49.8566,
    y2: 18.7313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_4_3",
    x1: 8.64082,
    y1: 50.6048,
    x2: 50.0704,
    y2: 18.5659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_4_3",
    x1: 8.2503,
    y1: 50.9518,
    x2: 50.303,
    y2: 18.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_4_3",
    x1: 7.88935,
    y1: 51.2685,
    x2: 50.5295,
    y2: 18.2934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_4_3",
    x1: 7.51179,
    y1: 51.6118,
    x2: 50.7734,
    y2: 18.1562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_4_3",
    x1: 7.14724,
    y1: 51.923,
    x2: 50.9914,
    y2: 18.0168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_4_3",
    x1: 6.76537,
    y1: 52.2753,
    x2: 51.2391,
    y2: 17.8773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_4_3",
    x1: 6.40226,
    y1: 52.6026,
    x2: 51.4747,
    y2: 17.7515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_4_3",
    x1: 6.03196,
    y1: 52.9353,
    x2: 51.7162,
    y2: 17.6012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_4_3",
    x1: 5.64289,
    y1: 53.2679,
    x2: 51.9421,
    y2: 17.4381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_4_3",
    x1: 5.29999,
    y1: 53.5774,
    x2: 52.1689,
    y2: 17.3272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_4_3",
    x1: 4.91523,
    y1: 53.9261,
    x2: 52.4104,
    y2: 17.1965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_4_3",
    x1: 4.51883,
    y1: 54.2855,
    x2: 52.6532,
    y2: 17.0666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_4_3",
    x1: 4.16875,
    y1: 54.5701,
    x2: 52.8615,
    y2: 16.8943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_4_3",
    x1: 3.80348,
    y1: 54.9221,
    x2: 53.1257,
    y2: 16.7946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_4_3",
    x1: 3.4303,
    y1: 55.2711,
    x2: 53.3659,
    y2: 16.6742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_4_3",
    x1: 3.05706,
    y1: 55.5823,
    x2: 53.5818,
    y2: 16.5098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_4_3",
    x1: 2.68388,
    y1: 55.9132,
    x2: 53.8122,
    y2: 16.3689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_4_3",
    x1: 2.31861,
    y1: 56.2458,
    x2: 54.0522,
    y2: 16.2435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_4_3",
    x1: 1.96271,
    y1: 56.5731,
    x2: 54.2951,
    y2: 16.1177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_4_3",
    x1: 1.57219,
    y1: 56.9058,
    x2: 54.5179,
    y2: 15.9611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_4_3",
    x1: 1.19894,
    y1: 57.2367,
    x2: 54.7483,
    y2: 15.8202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_4_3",
    x1: 0.837994,
    y1: 57.564,
    x2: 54.9845,
    y2: 15.7007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_4_3",
    x1: 0.460438,
    y1: 57.8966,
    x2: 55.2187,
    y2: 15.5502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_4_3",
    x1: 0.0786225,
    y1: 58.2292,
    x2: 55.4519,
    y2: 15.3872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_4_3",
    x1: -0.262828,
    y1: 58.5601,
    x2: 55.7011,
    y2: 15.2964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_4_3",
    x1: -0.651194,
    y1: 58.8875,
    x2: 55.9196,
    y2: 15.1394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_4_3",
    x1: -1.04177,
    y1: 59.2201,
    x2: 56.1424,
    y2: 14.9827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_4_3",
    x1: -1.39761,
    y1: 59.5528,
    x2: 56.3902,
    y2: 14.8635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_4_3",
    x1: -1.76294,
    y1: 59.8872,
    x2: 56.635,
    y2: 14.7412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_4_3",
    x1: -2.13396,
    y1: 60.2217,
    x2: 56.866,
    y2: 14.6101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_4_3",
    x1: -2.51584,
    y1: 60.5437,
    x2: 57.0894,
    y2: 14.4339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_4_3",
    x1: -2.88255,
    y1: 60.8746,
    x2: 57.3215,
    y2: 14.3118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_4_3",
    x1: -3.24781,
    y1: 61.1805,
    x2: 57.5372,
    y2: 14.1533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_4_3",
    x1: -3.61523,
    y1: 61.5291,
    x2: 57.7912,
    y2: 14.0415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_4_3",
    x1: -3.99424,
    y1: 61.8939,
    x2: 58.0514,
    y2: 13.9369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_4_3",
    x1: -4.36748,
    y1: 62.198,
    x2: 58.2576,
    y2: 13.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_4_3",
    x1: -4.72627,
    y1: 62.5253,
    x2: 58.4943,
    y2: 13.6497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_4_3",
    x1: -5.10592,
    y1: 62.858,
    x2: 58.728,
    y2: 13.4931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_4_3",
    x1: -5.48564,
    y1: 63.1906,
    x2: 58.9617,
    y2: 13.3364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_4_3",
    x1: -5.82343,
    y1: 63.5216,
    x2: 59.2145,
    y2: 13.2456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_4_3",
    x1: -6.22919,
    y1: 63.8595,
    x2: 59.4303,
    y2: 13.0829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_4_3",
    x1: -6.61317,
    y1: 64.2082,
    x2: 59.6775,
    y2: 12.9334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_4_3",
    x1: -6.96404,
    y1: 64.5142,
    x2: 59.8995,
    y2: 12.8064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_4_3",
    x1: -7.338,
    y1: 64.8575,
    x2: 60.1469,
    y2: 12.6691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_4_3",
    x1: -7.70254,
    y1: 65.1777,
    x2: 60.3698,
    y2: 12.5401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_4_3",
    x1: -8.07795,
    y1: 65.5103,
    x2: 60.6046,
    y2: 12.3959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_4_3",
    x1: -8.44897,
    y1: 65.8376,
    x2: 60.8356,
    y2: 12.2576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_4_3",
    x1: -8.81208,
    y1: 66.1578,
    x2: 61.0615,
    y2: 12.1222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_4_3",
    x1: -9.18742,
    y1: 66.4959,
    x2: 61.3012,
    y2: 11.9847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_4_3",
    x1: -9.54842,
    y1: 66.8125,
    x2: 61.5276,
    y2: 11.852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_4_3",
    x1: -9.92737,
    y1: 67.1663,
    x2: 61.7879,
    y2: 11.7366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_4_3",
    x1: -10.2905,
    y1: 67.4867,
    x2: 62.0041,
    y2: 11.5989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_4_3",
    x1: -10.6702,
    y1: 67.8193,
    x2: 62.2378,
    y2: 11.4421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_4_3",
    x1: -11.0499,
    y1: 68.1521,
    x2: 62.4715,
    y2: 11.2855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_4_3",
    x1: -11.4188,
    y1: 68.483,
    x2: 62.703,
    y2: 11.1571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_4_3",
    x1: -11.784,
    y1: 68.7942,
    x2: 62.9236,
    y2: 11.0053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_4_3",
    x1: -12.163,
    y1: 69.1429,
    x2: 63.1693,
    y2: 10.8809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_4_3",
    x1: -12.5305,
    y1: 69.5022,
    x2: 63.4329,
    y2: 10.7822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_4_3",
    x1: -12.8957,
    y1: 69.8064,
    x2: 63.6438,
    y2: 10.6208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_4_3",
    x1: -13.269,
    y1: 70.1177,
    x2: 63.8597,
    y2: 10.4565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_4_3",
    x1: -13.6422,
    y1: 70.4664,
    x2: 64.1096,
    y2: 10.3384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_4_3",
    x1: -14.0154,
    y1: 70.799,
    x2: 64.3448,
    y2: 10.2005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_4_3",
    x1: -14.3807,
    y1: 71.1299,
    x2: 64.58,
    y2: 10.0721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_4_3",
    x1: -14.7538,
    y1: 71.4572,
    x2: 64.8104,
    y2: 9.92753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_4_3",
    x1: -15.1097,
    y1: 71.7898,
    x2: 65.0581,
    y2: 9.80835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_4_3",
    x1: -15.5003,
    y1: 72.1259,
    x2: 65.2907,
    y2: 9.65762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_4_3",
    x1: -15.8713,
    y1: 72.4481,
    x2: 65.5071,
    y2: 9.51049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_4_3",
    x1: -16.2388,
    y1: 72.7807,
    x2: 65.7465,
    y2: 9.37879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_4_3",
    x1: -16.6142,
    y1: 73.1134,
    x2: 65.9813,
    y2: 9.23455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_4_3",
    x1: -16.9852,
    y1: 73.4443,
    x2: 66.2123,
    y2: 9.09991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_4_3",
    x1: -17.3505,
    y1: 73.7715,
    x2: 66.4474,
    y2: 8.96787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_4_3",
    x1: -17.7236,
    y1: 74.1043,
    x2: 66.6827,
    y2: 8.83004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_4_3",
    x1: -18.0969,
    y1: 74.4369,
    x2: 66.918,
    y2: 8.6921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_4_3",
    x1: -18.4925,
    y1: 74.7892,
    x2: 67.1486,
    y2: 8.5651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_4_3",
    x1: -18.8354,
    y1: 75.0897,
    x2: 67.3786,
    y2: 8.41252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_4_3",
    x1: -19.2064,
    y1: 75.4277,
    x2: 67.6193,
    y2: 8.28745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_4_3",
    x1: -19.5904,
    y1: 75.7872,
    x2: 67.8762,
    y2: 8.15135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_4_3",
    x1: -19.9471,
    y1: 76.0914,
    x2: 68.0892,
    y2: 8.01497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_4_3",
    x1: -20.3203,
    y1: 76.4026,
    x2: 68.3051,
    y2: 7.85058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_4_3",
    x1: -20.6934,
    y1: 76.7566,
    x2: 68.5598,
    y2: 7.73906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_4_3",
    x1: -21.0667,
    y1: 77.1089,
    x2: 68.8096,
    y2: 7.62459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_4_3",
    x1: -21.4319,
    y1: 77.4148,
    x2: 69.0254,
    y2: 7.46612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_4_3",
    x1: -21.8052,
    y1: 77.7422,
    x2: 69.2558,
    y2: 7.32168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_4_3",
    x1: -22.1784,
    y1: 78.0782,
    x2: 69.5008,
    y2: 7.18962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_4_3",
    x1: -22.5516,
    y1: 78.4074,
    x2: 69.7264,
    y2: 7.04576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_4_3",
    x1: -22.9169,
    y1: 78.733,
    x2: 69.9566,
    y2: 6.91078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_4_3",
    x1: -23.2843,
    y1: 79.0656,
    x2: 70.1961,
    y2: 6.77908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_4_3",
    x1: -23.646,
    y1: 79.3982,
    x2: 70.4397,
    y2: 6.65366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_4_3",
    x1: -24.0394,
    y1: 79.7578,
    x2: 70.6791,
    y2: 6.50892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_4_3",
    x1: -24.4018,
    y1: 80.0458,
    x2: 70.8831,
    y2: 6.34883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_4_3",
    x1: -24.7793,
    y1: 80.3853,
    x2: 71.1367,
    y2: 6.21024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_4_3",
    x1: -25.1482,
    y1: 80.7431,
    x2: 71.3827,
    y2: 6.11258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_4_3",
    x1: -25.5077,
    y1: 81.042,
    x2: 71.593,
    y2: 5.95079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_4_3",
    x1: -25.8867,
    y1: 81.3799,
    x2: 71.8289,
    y2: 5.81317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear_4_3",
    x1: -26.2534,
    y1: 81.7019,
    x2: 72.0561,
    y2: 5.68093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_4_3",
    x1: -26.6331,
    y1: 82.0453,
    x2: 72.2995,
    y2: 5.5374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_4_3",
    x1: -26.9666,
    y1: 82.3762,
    x2: 72.5533,
    y2: 5.45916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_4_3",
    x1: -27.3716,
    y1: 82.7035,
    x2: 72.765,
    y2: 5.26445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear_4_3",
    x1: -27.7426,
    y1: 83.0361,
    x2: 73.0009,
    y2: 5.13276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_4_3",
    x1: -28.1093,
    y1: 83.3777,
    x2: 73.2508,
    y2: 4.99255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear_4_3",
    x1: -28.4833,
    y1: 83.6944,
    x2: 73.4659,
    y2: 4.85368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear_4_3",
    x1: -28.8449,
    y1: 84.0109,
    x2: 73.695,
    y2: 4.70842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear_4_3",
    x1: -29.2297,
    y1: 84.3596,
    x2: 73.9365,
    y2: 4.57776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_4_3",
    x1: -29.6261,
    y1: 84.7014,
    x2: 74.1503,
    y2: 4.42266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_4_3",
    x1: -29.9682,
    y1: 85.0069,
    x2: 74.4021,
    y2: 4.29396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear_4_3",
    x1: -30.3414,
    y1: 85.3556,
    x2: 74.6518,
    y2: 4.17583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear_4_3",
    x1: -30.7146,
    y1: 85.7026,
    x2: 74.8969,
    y2: 4.05476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint175_linear_4_3",
    x1: -31.0799,
    y1: 86.0141,
    x2: 75.1078,
    y2: 3.90066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint176_linear_4_3",
    x1: -31.4531,
    y1: 86.3413,
    x2: 75.3382,
    y2: 3.75609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint177_linear_4_3",
    x1: -31.8263,
    y1: 86.674,
    x2: 75.5735,
    y2: 3.61814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint178_linear_4_3",
    x1: -32.1995,
    y1: 87.0066,
    x2: 75.8087,
    y2: 3.48017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint179_linear_4_3",
    x1: -32.5648,
    y1: 87.3375,
    x2: 76.0439,
    y2: 3.3518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint180_linear_4_3",
    x1: -32.938,
    y1: 87.6649,
    x2: 76.2743,
    y2: 3.20736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint181_linear_4_3",
    x1: -33.3069,
    y1: 87.9975,
    x2: 76.5107,
    y2: 3.08193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint182_linear_4_3",
    x1: -33.6844,
    y1: 88.3301,
    x2: 76.7449,
    y2: 2.93144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint183_linear_4_3",
    x1: -34.0605,
    y1: 88.6557,
    x2: 76.9725,
    y2: 2.76512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint184_linear_4_3",
    x1: -34.4056,
    y1: 88.9883,
    x2: 77.2229,
    y2: 2.67728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint185_linear_4_3",
    x1: -34.7961,
    y1: 89.321,
    x2: 77.4458,
    y2: 2.52065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint186_linear_4_3",
    x1: -35.1867,
    y1: 89.6573,
    x2: 77.6686,
    y2: 2.36758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint187_linear_4_3",
    x1: -35.5346,
    y1: 89.9578,
    x2: 77.8919,
    y2: 2.22127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint188_linear_4_3",
    x1: -35.9078,
    y1: 90.3153,
    x2: 78.1563,
    y2: 2.11578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint189_linear_4_3",
    x1: -36.281,
    y1: 90.6551,
    x2: 78.3916,
    y2: 1.98502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint190_linear_4_3",
    x1: -36.6607,
    y1: 90.9754,
    x2: 78.6107,
    y2: 1.8121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint191_linear_4_3",
    x1: -37.0195,
    y1: 91.3028,
    x2: 78.8475,
    y2: 1.69898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint192_linear_4_3",
    x1: -37.3927,
    y1: 91.6193,
    x2: 79.0682,
    y2: 1.54119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint193_linear_4_3",
    x1: -37.7659,
    y1: 91.968,
    x2: 79.3181,
    y2: 1.42307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint194_linear_4_3",
    x1: -38.1312,
    y1: 92.2989,
    x2: 79.5531,
    y2: 1.29471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint195_linear_4_3",
    x1: -38.5044,
    y1: 92.6262,
    x2: 79.7836,
    y2: 1.15013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint196_linear_4_3",
    x1: -38.8712,
    y1: 92.9589,
    x2: 80.0204,
    y2: 1.03108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint197_linear_4_3",
    x1: -39.2508,
    y1: 93.2932,
    x2: 80.259,
    y2: 0.877282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint198_linear_4_3",
    x1: -39.6247,
    y1: 93.6225,
    x2: 80.4872,
    y2: 0.720908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint199_linear_4_3",
    x1: -39.9662,
    y1: 93.9497,
    x2: 80.7363,
    y2: 0.626462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint200_linear_4_3",
    x1: -40.3798,
    y1: 94.2984,
    x2: 80.9571,
    y2: 0.464473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint201_linear_4_3",
    x1: -40.7559,
    y1: 94.6219,
    x2: 81.1993,
    y2: 0.299917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint202_linear_4_3",
    x1: -41.101,
    y1: 94.9405,
    x2: 81.4206,
    y2: 0.190508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint203_linear_4_3",
    x1: -41.4807,
    y1: 95.2856,
    x2: 81.6688,
    y2: 0.050033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint204_linear_4_3",
    x1: -41.8474,
    y1: 95.6112,
    x2: 81.896,
    y2: -0.0786886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint205_linear_4_3",
    x1: -42.2206,
    y1: 95.9385,
    x2: 82.1265,
    y2: -0.22324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint206_linear_4_3",
    x1: -42.5859,
    y1: 96.264,
    x2: 82.3567,
    y2: -0.358253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint207_linear_4_3",
    x1: -42.9548,
    y1: 96.586,
    x2: 82.5834,
    y2: -0.496887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint208_linear_4_3",
    x1: -43.3323,
    y1: 96.9294,
    x2: 82.8273,
    y2: -0.634045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint209_linear_4_3",
    x1: -43.6912,
    y1: 97.2389,
    x2: 83.0446,
    y2: -0.770052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint210_linear_4_3",
    x1: -44.0665,
    y1: 97.5731,
    x2: 83.2939,
    y2: -0.90896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint211_linear_4_3",
    x1: -44.4354,
    y1: 97.9202,
    x2: 83.5302,
    y2: -1.01986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint212_linear_4_3",
    x1: -44.7883,
    y1: 98.2528,
    x2: 83.7842,
    y2: -1.15157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint213_linear_4_3",
    x1: -45.189,
    y1: 98.5837,
    x2: 83.997,
    y2: -1.33007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint214_linear_4_3",
    x1: -45.5268,
    y1: 98.9111,
    x2: 84.2497,
    y2: -1.42439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint215_linear_4_3",
    x1: -45.9289,
    y1: 99.2277,
    x2: 84.4497,
    y2: -1.6135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint216_linear_4_3",
    x1: -46.3079,
    y1: 99.5747,
    x2: 84.6906,
    y2: -1.74083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint217_linear_4_3",
    x1: -46.6674,
    y1: 99.9019,
    x2: 84.9298,
    y2: -1.86661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint218_linear_4_3",
    x1: -47.0406,
    y1: 100.235,
    x2: 85.1651,
    y2: -2.00456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint219_linear_4_3",
    x1: -47.4139,
    y1: 100.567,
    x2: 85.4004,
    y2: -2.1424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint220_linear_4_3",
    x1: -47.787,
    y1: 100.898,
    x2: 85.6309,
    y2: -2.28342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint221_linear_4_3",
    x1: -48.1523,
    y1: 101.225,
    x2: 85.866,
    y2: -2.41534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint222_linear_4_3",
    x1: -48.5256,
    y1: 101.558,
    x2: 86.1012,
    y2: -2.55328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint223_linear_4_3",
    x1: -48.8987,
    y1: 101.891,
    x2: 86.3366,
    y2: -2.69124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint224_linear_4_3",
    x1: -49.264,
    y1: 102.222,
    x2: 86.5717,
    y2: -2.81963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint225_linear_4_3",
    x1: -49.6372,
    y1: 102.549,
    x2: 86.8021,
    y2: -2.9642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint226_linear_4_3",
    x1: -50.022,
    y1: 102.889,
    x2: 87.0388,
    y2: -3.10499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint227_linear_4_3",
    x1: -50.3837,
    y1: 103.214,
    x2: 87.2727,
    y2: -3.23999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint228_linear_4_3",
    x1: -50.7532,
    y1: 103.545,
    x2: 87.5067,
    y2: -3.38089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint229_linear_4_3",
    x1: -51.1221,
    y1: 103.872,
    x2: 87.7383,
    y2: -3.51294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint230_linear_4_3",
    x1: -51.4954,
    y1: 104.205,
    x2: 87.9735,
    y2: -3.6509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint231_linear_4_3",
    x1: -51.8685,
    y1: 104.536,
    x2: 88.204,
    y2: -3.7918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint232_linear_4_3",
    x1: -52.2339,
    y1: 104.863,
    x2: 88.4391,
    y2: -3.92371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint233_linear_4_3",
    x1: -52.607,
    y1: 105.226,
    x2: 88.6986,
    y2: -4.02494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint234_linear_4_3",
    x1: -52.9803,
    y1: 105.523,
    x2: 88.9048,
    y2: -4.20624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint235_linear_4_3",
    x1: -53.3535,
    y1: 105.859,
    x2: 89.1401,
    y2: -4.34054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint236_linear_4_3",
    x1: -53.7187,
    y1: 106.187,
    x2: 89.3752,
    y2: -4.47256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint237_linear_4_3",
    x1: -54.0919,
    y1: 106.52,
    x2: 89.6106,
    y2: -4.6104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint238_linear_4_3",
    x1: -54.4652,
    y1: 106.852,
    x2: 89.8458,
    y2: -4.74836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint239_linear_4_3",
    x1: -54.8362,
    y1: 107.183,
    x2: 90.0768,
    y2: -4.883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint240_linear_4_3",
    x1: -55.2037,
    y1: 107.51,
    x2: 90.3113,
    y2: -5.0213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint241_linear_4_3",
    x1: -55.5768,
    y1: 107.843,
    x2: 90.5467,
    y2: -5.15926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint242_linear_4_3",
    x1: -55.9501,
    y1: 108.176,
    x2: 90.7819,
    y2: -5.29709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint243_linear_4_3",
    x1: -56.3175,
    y1: 108.506,
    x2: 91.0165,
    y2: -5.43185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint244_linear_4_3",
    x1: -56.6885,
    y1: 108.834,
    x2: 91.2475,
    y2: -5.57003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint245_linear_4_3",
    x1: -57.0386,
    y1: 109.145,
    x2: 91.48,
    y2: -5.70937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint246_linear_4_3",
    x1: -57.44,
    y1: 109.526,
    x2: 91.7438,
    y2: -5.83797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint247_linear_4_3",
    x1: -57.8002,
    y1: 109.83,
    x2: 91.9532,
    y2: -5.97432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint248_linear_4_3",
    x1: -58.2168,
    y1: 110.162,
    x2: 92.1711,
    y2: -6.17256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint249_linear_4_3",
    x1: -58.5467,
    y1: 110.479,
    x2: 92.4093,
    y2: -6.26994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint250_linear_4_3",
    x1: -58.9221,
    y1: 110.828,
    x2: 92.6585,
    y2: -6.39434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint251_linear_4_3",
    x1: -59.2852,
    y1: 111.175,
    x2: 92.9087,
    y2: -6.49662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint252_linear_4_3",
    x1: -59.6562,
    y1: 111.475,
    x2: 93.1155,
    y2: -6.66797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint253_linear_4_3",
    x1: -60.0316,
    y1: 111.813,
    x2: 93.3551,
    y2: -6.80559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint254_linear_4_3",
    x1: -60.3961,
    y1: 112.128,
    x2: 93.5731,
    y2: -6.94126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint255_linear_4_3",
    x1: -60.7701,
    y1: 112.473,
    x2: 93.8254,
    y2: -7.07545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint256_linear_4_3",
    x1: -60.9606,
    y1: 112.64,
    x2: 93.9359,
    y2: -7.15181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint257_linear_4_3",
    x1: -9.86188,
    y1: 71.8942,
    x2: 59.8397,
    y2: 22.776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint258_linear_4_3",
    x1: 24.6296,
    y1: 9.08947,
    x2: 31.5342,
    y2: 3.72701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint259_linear_4_3",
    x1: 31.4917,
    y1: 9.92265,
    x2: 38.3913,
    y2: 4.58574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint260_linear_4_3",
    x1: 38.2141,
    y1: 12.594,
    x2: 44.0924,
    y2: 10.0105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint261_linear_4_3",
    x1: 41.5344,
    y1: 14.2297,
    x2: 47.8734,
    y2: 8.46244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint262_linear_4_3",
    x1: 45.7521,
    y1: 17.5967,
    x2: 51.382,
    y2: 12.8814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint263_linear_4_3",
    x1: 47.2639,
    y1: 23.1379,
    x2: 55.337,
    y2: 16.4937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint264_linear_4_3",
    x1: 50.806,
    y1: 28.6072,
    x2: 57.7073,
    y2: 23.2576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint265_linear_4_3",
    x1: 51.815,
    y1: 34.3796,
    x2: 57.6306,
    y2: 28.8135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint266_linear_4_3",
    x1: -36.881,
    y1: 91.5628,
    x2: 73.762,
    y2: 5.99877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint267_linear_4_3",
    x1: 3.23811,
    y1: 54.5065,
    x2: 22.7049,
    y2: -29.5466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDF294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E4A837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7A1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9341e74dd585c99f3c8ce7d4569a419c.svg";
export { ForwardRef as ReactComponent };